// import { SharedService } from './../../services/sharedService/shared-service.service';
import { CommonPatternsService } from './../../common-patterns.service';

import { state } from '@angular/animations';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
// import { DecimalPipe, KeyValue } from '@angular/common';
import SignaturePad from 'signature_pad';
// import { Modal } from 'bootstrap';
import { DecimalPipe, KeyValue, formatNumber } from '@angular/common';
import { error } from 'jquery';
import { PhoneFormatPipe } from '../../pipes/phone-format.pipe';
import { floatWith2Decimals, groupBy, sumBy, adjustWith2DecimalsForUI } from "../../common-functions";
import { DatePipe } from "@angular/common";
import { LoggerService } from 'src/app/services/logger.service';
import { SharedService } from 'src/app/services/sharedService/shared.service';
import { CustomDatePipe } from './../../pipes/customdate.pipe';
import { loadMemberData, loadMemberDataSuccess } from 'src/app/state/actions/members.actions';
import { Store } from '@ngrx/store';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';
import { loadFormConfig2Data } from 'src/app/state/actions/formConfig2.actions';
import { selectFormConfig2Data } from 'src/app/state/selectors/formConfig2.selectors';

declare var $: any;

@Component({
  //app-add-customer
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css'],
  providers: [CustomDatePipe, DecimalPipe, PhoneFormatPipe, DatePipe],
  // encapsulation: ViewEncapsulation.None
})

export class AddCustomerComponent implements OnChanges, OnInit {
  greenValue: any;
  yellowValue: any;
  public formData: any;
  public allFormData: any = {};
  public lastUpdatedType: any = "";
  public signUpData: any = {};
  public premiums: any = {};
  names: any[] = [
    { label: 'Guaranteed', position: 10 },    // Display "Start" at 0%
    { label: 'Pending', position: 0 }, // Display "Quarter" at 25%

  ];
  addeditbenficiary = false
  benficiaryCount = false;
  showaddmorebenficiary = true;
  benficiaryCountMessage: any;
  beneficariesDetails: any;
  benficiary = false;
  editBenficiaryIndex: any;
  showBenificiaryForm = true;
  showbenificaryTable = false;
  addbenificaryData: any = []
  showSpouseSignature = false;
  showIAFGerrorMessage = false;
  signatureNeeded: any = true;
  beneficiaryError = false;
  beneficiaryErrorMessage = ''
  rangeValues: any = [];
  productobj: any;
  minValue = 0;
  maxValue: any;
  public planssummarymainLife: any = [];
  showyellowbar = false
  myDateOfBirth: Date;
  myDateOfHire: Date;
  spouseDateOfBirth: Date;
  childDateOfBirth: Date;
  graduationDate: Date;
  configprovinceres: any;
  configpworkingrovinceres: any;
  countries: any;
  currencySymbol: any;
  languageTokensArray: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any
  configresults: any;
  configPlanEnrollmentDate: any;
  requireDentalHealthCoverage: any = true;
  brokerTermsConditions: any;
  disclosureAgreement_dynamicData: any;
  disclosureAgreement: any;
  term_and_conditions: any;
  formid: any;
  postalvalue: any;
  provincialZipcodes: any;
  invalidpostalcodeprivince: boolean;
  pdfvisibletermsandconditions: boolean;
  // phoneNoFormat: any;
  public applicantDateofBirth: any = new Date(2000, 3, 1);
  provincialHealthcareUrl: any;
  state_id: number;
  statename: any;
  planobjdata: any = {};
  planobjdataobj: any = {};
  // QCproviance: any;
  checkstudenthealthcardstatus_UHIP: boolean;
  checkhealthcardstatus: boolean = false;
  checkstudenthealthcardstatus: boolean;
  checkhealthcardstatusuhip: boolean;
  spouseinformation: boolean;
  spousehealthcardinfo: boolean;
  parentalhelathinsuranecheck: boolean;
  childrenhealthinformation: boolean;
  childInfoAddDataArray: any = [];
  public mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = []

  // childTableRowsLength: any;
  applicanthavingchildren: any;
  pdfvisibleadvisouredisclosure: boolean = true;
  Shared: any;
  applicantfirstname: any;
  countrydetails: any;
  selectedTab: any = 'tab1';
  planAmount: any = 0;
  public specialpackages: any = [{ groups: [{ plans: [] }] }];
  tab1Img: boolean;
  minDate: any;
  maxDate: any;
  applicantChildrenname: any;
  completeapplicantinfo: string;
  marital_status: any;
  pdfvisibletermsandcodionsmodel: boolean = true;
  padAgrementLoad: boolean = true;
  withSignLoad: boolean = true;
  graducationdaycheck: boolean = false;
  plancheckboxcheck: any;
  plansnexttab: boolean;
  cartcheckvalue: boolean;
  allproducts: any;
  // private _decimalPipe: any;
  paymentfirstname: any;
  paymentemail: any;
  homeaddresscheckvalue: boolean = false;
  homeaddressEnrollmentVal: boolean;
  planssummarymain: any;
  public plansummaryLIFE: any
  plansummaryLIFEFinal: any = [];


  planssummaryopt: any;
  studentplanssummarymain: any;
  studentplanssummarymain1: any[];
  finalenrollemntsummary: any[];
  paymentMethodSelectCC: boolean;
  bankDetailsNames: string;
  enrollmentBankDetailedVerify: boolean;
  bankDetailsError: string;
  bankDetailsVerifyStatus: boolean;
  bankverifyDetails: any;
  signaturePadClear: boolean = false;
  signaturemessagecc: boolean;
  oldvaluenumber: any;
  childrenDetailsArray: any;
  childTableEditRowIndex: number = 0;
  noOfChildrenChangedValue: number = 1;
  childTableRowsLength: number = 0;
  dependentchildInsurenceval: boolean;
  // childTableEditRowIndex: any;
  childInfoModalAddAndUpdateButton: string;
  provincelistid: any;
  invalidenrollmentpostalcodeprovince: boolean;
  childrenenrollement: boolean;
  isFileUploaded: boolean;
  imagedisplay: any;
  bankfile: any;
  pdfview: boolean;
  normalview: boolean;
  showSignAndAgreeOrAgree: boolean;
  padAgreementSignaturePadClear: boolean;
  padAgreementSignaturemessagecc: boolean;
  generatePADaggrement: any;
  agreestatus: boolean;
  signaturestatus: boolean;
  signatureImgcc: any;
  publicapikey: any;
  customerid: any;
  displayStudentId: boolean = false;
  hoursperweek: boolean = false;
  hourperweekvalue: boolean = false;
  displatGig: boolean = false;
  firstName: any = '';
  lastName: any;
  primaryEmail: any;
  primaryPhone: any;
  country: any;
  line1: any;
  line2: any;
  city: any;
  state: any;
  postalZip: any;
  brokers: any;
  showBrokersList: boolean = false;
  formsList: any;
  forms: any = [];
  showForm: boolean = false;
  // phoneNoFormat: any;
  // planobjdata: {
  //   packageId: any;
  //   packageName: any;
  //   planproductname: any;
  //   groupid: any;
  //   groupName: any;
  //   id: any;
  //   name: any;
  //   planLevel: any;
  //   planLevelParent: any;
  //   fusebillPlanID: any;
  //   planFrequencyID: any;
  //   isBundle: any;
  //   coverage: any;
  //   planCoverage: any;
  //   bundledProducts: any[];
  //   products: any[];
  // };

  plansskumain: any[] = [];
  plandetailsobjvalue: any;
  optionstitle: any[];
  optionmessage: any;
  showoptions: boolean = false;
  disabledelement: string;
  fusebill_paymentMethod: any = 'CC';
  minDateHire: string;
  minDatechild: Date = new Date();
  maxDatechild: Date = new Date();
  isStudent: boolean = true;
  isCorporate: boolean = true;
  planssummary: any[] = [];
  terminateReasonsWithKeys: any;
  studentPlaceHolder: any;
  studentPlaceHolderln: any;
  role: string;
  allBrokers: any;
  gsPlans: boolean = false;
  eqPlans: boolean = false;
  showGreenShiled: boolean = false;
  showinvitationmail: boolean = false;
  gsRegistration: boolean = true;
  gsMembershipId: any;
  eqRegistration: boolean = true;
  eqCertificateId: any;
  showEquitable: boolean = false;
  showlandedimgratestatus: boolean;
  showlandeddependentDetails: boolean;
  showdependentdetails: boolean;
  showdependentlandedstatus: boolean;
  waddellForm: boolean;
  userFormSubmitted: boolean;
  plansError: boolean;
  showCowan: boolean;
  cwRegistraion: boolean;
  cwCertificateId: string;
  cwPlans: any;
  savedGs: boolean = false;
  savedEq: boolean = false;
  savedCw: boolean = false;
  kixPlans: boolean = false;
  flexPlans: boolean = false;
  waddellPlans: boolean = false;
  flexCertificateId: any;
  FormbrokerType: any;
  packagesInBlocks: any;
  public modifiedBlocksCoveredByCompany: any;
  public companypaidproductid = [];
  public disabledcompanypaidproductid = [];
  public removedisabledcompanypaidproductid = [];
  public adddisabledcompanypaidproductid = [];
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  deltaCompanyTax: any;
  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;
  alloptinplans: any[];
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public showPaymenthMethod: boolean = false;
  public showPaymenthMethod1: boolean = false;
  public creditcardform: boolean = false;
  public bankpaymentmethod: any;
  public bankpay: boolean = false;
  public companySelectedPlans = [];
  public companyCoveredPlans = [];
  public EmployeeSelectedPlans = [];
  public allSelectedPlans = [];
  public companyDealingPlans = [];

  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  kixRegistration: boolean = true;
  flexRegistration: boolean = true;
  waddellRegistration: boolean = true;
  savedKIX: boolean = false;
  savedFLEX: boolean = false;
  savedWADDELL: boolean = false;
  showKixcarePlans: boolean = false;
  showWaddellPlans: boolean = false;
  iafgplansCheck: any = [];
  voluntryplansCheck: boolean = false;
  upgradeplansCheck: boolean = false;
  companyplansCheck: boolean = true;
  working_provincelistid: any;
  memberDetails: any;
  members: any;
  languageData$: Observable<any>;
  formConfig2Data$: Observable<any>;
  formConfig2Data: any = {};
  private destroy$ = new Subject<void>();
  modifiedBlocksPaidByCompany: any;
  elementcvValues: any;
  paymentlastName: any;
  showFlexPlans: boolean = false;

  constructor
    (private logger: LoggerService,
      private _CustomDatePipe: CustomDatePipe,
      private http: HttpClient,
      private fb: FormBuilder,
      private childInfoFormBuilder: FormBuilder,
      private SharedService: SharedService,

      private toastrService: ToastrService,
      private enrollmentFormBuilder: FormBuilder,
      private greenShildBuilder: FormBuilder,
      private bankPayFormBuilder: FormBuilder,
      private creditCardFormBuilder: FormBuilder,
      private router: Router,
      private _decimalPipe: DecimalPipe,
      private datePipe: DatePipe,
      private commonPatternsService: CommonPatternsService,

      // private phoneNoFormat1: PhoneNoFormatPipe,
      // private studentService: StudentService,
      // private Shared: SharedService,
      // private _decimalPipe: DecimalPipe,
      private renderer: Renderer2,
      private elementRef: ElementRef,
      private el: ElementRef,
      private phoneNoFormat: PhoneFormatPipe,
      private store: Store<{ memberData: [], languageData: [], formConfig2Data: [] }>
    ) {
    // this.minDate = moment().subtract(100, 'years').calendar();
    // this.maxDate = moment().subtract(16, 'years').calendar();
    this.minDate = new Date();
    const today = new Date();
    this.minDate.setFullYear(today.getFullYear() - 74);
    this.minDate.setMonth(0); // January
    this.minDate.setDate(1); // 1st


    // Set maxDate to December 31st, 2030
    this.maxDate = new Date();
    this.maxDate.setFullYear(today.getFullYear() - 16);
    this.maxDate.setMonth(new Date().getMonth()); // current month
    this.maxDate.setDate(new Date().getDate()); // current date

    this.languageData$ = store.select(selectLanguageData);
    this.formConfig2Data$ = store.select(selectFormConfig2Data);
  }
  signaturePadCC: any = SignaturePad;
  padAggsignaturePadCC: any = SignaturePad;
  @ViewChild('dependentWithSpecialNeeds') dependentWithSpecialNeeds: any;
  @ViewChild(' PADpafaggrementModal') PADpafaggrementModalpopup: any;
  @ViewChild('PADpafaggrementModalSign') PADpafaggrementModalpopupSign: any;
  @ViewChild('signaturePadagreementModal') signaturePadagreementModalPopup: any;
  @ViewChild('postSecondaryStudent') postSecondaryStudentVal: any;
  @ViewChild('signaturePadCanvas') signaturePadCanvasEl?: ElementRef;
  @ViewChild('padAgreementSignaturePadCanvas')
  padAgreementSignaturePadCanvasEl?: ElementRef;
  @ViewChild('dependentChildInfo') dependentChildInfo?: ElementRef;
  @ViewChild('QCproviance') QCproviance: any;
  @ViewChild('checkuhipstatusModal') checkuhipstatusModal: any;
  @ViewChild('checkphcpstatusModal') checkphcpstatusModal: any;
  // @ViewChild('childInfoModal') childInfoModal: any;
  @ViewChild('advisoranddisclousreModal') advisoranddisclousreModal: any;
  @ViewChild('termsAndConditionsModal') termsAndConditionsModal: any;
  @Input() valuFormChaild: any;
  // @ViewChild('signaturePadCanvas') signaturePadCanvasEl?: ElementRef;
  // @ViewChild('padAgreementSignaturePadCanvas') padAgreementSignaturePadCanvasEl?: ElementRef;
  membersData$: any;

  ngOnInit(): void {

    this.plansError = false
    this.myDateOfBirth = new Date();
    this.myDateOfHire = new Date();
    this.spouseDateOfBirth = new Date();
    this.childDateOfBirth = new Date();
    this.graduationDate = new Date();
    this.countries = this.commonPatternsService.countries
    this.userFormSubmitted = false;
    this.role = sessionStorage.getItem('role');
    // this.minDate = moment().subtract(100, 'years').calendar();
    // this.maxDate = moment().subtract(16, 'years').calendar();
    // this.minDate = new Date(this.minDate);

    // this.maxDate = new Date(this.maxDate);


    this.minDateHire = moment().subtract(60, 'years').calendar();


    this.minDatechild = new Date();
    const today = new Date();
    this.minDatechild.setFullYear(today.getFullYear() - 21);
    this.minDatechild.setMonth(0); // January
    this.minDatechild.setDate(1); // 1st

    // Set maxDate to December 31st, 2030
    // const today = new Date();
    // let today1 = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    this.maxDatechild = new Date();
    this.maxDatechild.setFullYear(today.getFullYear());
    this.maxDatechild.setMonth(new Date().getMonth()); // December
    this.maxDatechild.setDate(new Date().getDate()); // 31st

    this.getFormConfig();
    this.userFormGroup();
    this.childInfoValidators();
    this.enrolmentFormValidator();
    this.bankPayFormValidator();
    this.greenShiledFormValidations();
    this.EquitableFormValidations();
    this.cowanFormValidations();
    this.welcomeinvitationmail();
    this.getLanguageTokens()
    this.KixCareValidations()
    this.FlexValidations()
    this.waddellPlanValidations()
    // this.memberInfoFormGropu();

    // alert('aaaaaaaaaa')
    this.store.dispatch(loadMemberData());

    this.membersData$ = this.store.select(state => state.memberData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.membersData$?.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.memberData == undefined || Object.keys(data.memberData)?.length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.members?.length > 0) {
          return;
        }
        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          this.members = data.memberData;
          this.members = this.members.map(res => {
            return {
              ...res,
              isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
            }
          })
        } else {
          this.members = data.memberData.map(res => {
            return {
              ...res,
              username: res.user?.username,
              primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
              isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
            };
          });
        }
      }
    })
  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "manageMembers/addMember"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })

  }
  ngOnChanges() {
    this.logger.log('enter to ng on change');
    this.userForm.reset();
    // this.memberInfo.reset();
    this.enrollmentForm.reset();
  }
  ngAfterViewInit() {
    this.logger.log('ngAfterViewInit()');
    this.userForm.reset();
    // this.memberInfo.reset();
    this.enrollmentForm.reset();

  }
  ngDocheck() {
    this.logger.log('enter to ng onDo');
    this.userForm.reset();
    // this.memberInfo.reset();
    this.enrollmentForm.reset();
  }

  getFormConfig() {
    // // let formLink = environment.app.formLink
    // var accessToken = sessionStorage.getItem('accessToken');
    // var endPoint = '/api/ap/customer/formConfig_2';

    // let lang = 'en';
    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (result: any) => {
    //       // this.isLoaded =true
    //       if (result.status == '200') {

    //         let states;
    //         states = result.data.states.filter((country) => {
    //           return country.countryId == 1
    //         });
    //         result.data.states = states;
    //         this.configprovinceres = result.data.states.sort((a: any, b: any) =>
    //           a.shortName > b.shortName ? 1 : -1
    //         );

    //         if (result.data.working_provinces) {
    //           this.configpworkingrovinceres = result.data.working_provinces.sort(
    //             (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //           );
    //         } else {
    //           this.configpworkingrovinceres = result.data.states.sort((a: any, b: any) =>
    //             a.shortName > b.shortName ? 1 : -1
    //           );
    //         }
    //         // this.provincelist
    //         this.currencySymbol = result.data.countries[0].currencySymbol;
    //         this.terminateReasonsWithKeys = result.data.terminateReasonsWithKeys;
    //         sessionStorage.setItem('terminateReasonsWithKeys', JSON.stringify(this.terminateReasonsWithKeys));
    //         // this.currencySymbol ="$"

    //         this.allBrokers = result.data.allBrokers.sort(
    //           (a: any, b: any) => (a.name > b.name ? 1 : -1)
    //         );
    //         this.logger.log('result: ' + JSON.stringify(result));
    //         // this.languageTokensArray =
    //         //   result.data.languageDetails_2.languageTokens;
    //         // this.lang = {};
    //         // for (let token of this.languageTokensArray) {
    //         //   const langValue: any = token['value'];
    //         //   if (typeof langValue === 'string') {
    //         //     this.lang[token['key']] = langValue.trim();
    //         //   } else {
    //         //     this.lang[token['key']] = langValue;
    //         //   }
    //         //   // this.lang[token['key']] = token['value'];
    //         // }
    //         this.studentPlaceHolder = this.lang.name_as_shown_on_provincial_health_card;
    //         this.studentPlaceHolderln = this.lang.name_as_shown_on_provincial_health_card;

    //         this.configresults = result.data;

    //         sessionStorage.setItem(
    //           'provincelist',
    //           result.data.broker_licensed_provinces
    //         );
    //         sessionStorage.setItem(
    //           'countrydetails',
    //           JSON.stringify(result.data.countries)
    //         );

    //         this.logger.log('this.lang: ' + JSON.stringify(this.lang));
    //         sessionStorage.setItem('langTokens', JSON.stringify(this.lang));
    //         this.configPlanEnrollmentDate =
    //           result.data.validations.customer.planEnrollmentDatesFullMonth;

    //         this.brokerTermsConditions =
    //           result.data?.links?.brokerTermsConditions;
    //         this.disclosureAgreement_dynamicData =
    //           result.data?.links?.disclosureAgreement;
    //         this.disclosureAgreement = this.disclosureAgreement_dynamicData;
    //         this.logger.log('lang token: ' + sessionStorage.getItem('lanToken'));
    //         if (sessionStorage.getItem('lanToken') == 'en') {
    //           this.term_and_conditions = this.brokerTermsConditions;
    //         } else {
    //           this.term_and_conditions = this.brokerTermsConditions;
    //         }
    //         this.formid = result.data.form?.id;
    //       } else {
    //         Swal.fire({
    //           title: '<strong>HTML <u>example</u></strong>',
    //           // icon: 'warning',
    //           html: `<div class="custom-content">${result.message ? result.message : result.error
    //             }</div>`,
    //           showCloseButton: true,
    //           showCancelButton: false,
    //           focusConfirm: false,
    //           confirmButtonText: 'OK',
    //           confirmButtonAriaLabel: 'Thumbs up, great!',
    //           cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
    //           cancelButtonAriaLabel: 'Thumbs down',
    //         });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: this.lang.Error ?? 'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           confirmButtonText: this.lang.Proceed,
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //           else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
    //       }
    //     }
    //   );

    this.store.dispatch(loadFormConfig2Data());
    this.formConfig2Data$ = this.store.select(state => state.formConfig2Data).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.formConfig2Data$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.formConfig2Data == undefined || Object.keys(data.formConfig2Data).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(Object.keys(this.formConfig2Data).length>0){
        return;
      }
      this.formConfig2Data = {}
      this.formConfig2Data = { ...data.formConfig2Data }
      let states;
      states = [...this.formConfig2Data.states].filter((country) => {
        return country.countryId == 1
      });
      this.formConfig2Data.states = states;
      this.configprovinceres = [...this.formConfig2Data.states].sort((a: any, b: any) =>
        a.shortName > b.shortName ? 1 : -1
      );

      if (this.formConfig2Data.working_provinces) {
        this.configpworkingrovinceres = [...this.formConfig2Data.working_provinces].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
      } else {
        this.configpworkingrovinceres = [...this.formConfig2Data.states].sort((a: any, b: any) =>
          a.shortName > b.shortName ? 1 : -1
        );
      }
      // this.provincelist
      this.currencySymbol = this.formConfig2Data.countries[0].currencySymbol;
      this.terminateReasonsWithKeys = this.formConfig2Data.terminateReasonsWithKeys;
      sessionStorage.setItem('terminateReasonsWithKeys', JSON.stringify(this.terminateReasonsWithKeys));
      // this.currencySymbol ="$"

      this.allBrokers = [...this.formConfig2Data.allBrokers].sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      this.studentPlaceHolder = this.lang.name_as_shown_on_provincial_health_card;
      this.studentPlaceHolderln = this.lang.name_as_shown_on_provincial_health_card;

      this.configresults = this.formConfig2Data;

      sessionStorage.setItem(
        'provincelist',
        this.formConfig2Data.broker_licensed_provinces
      );
      sessionStorage.setItem(
        'countrydetails',
        JSON.stringify(this.formConfig2Data.countries)
      );

      this.logger.log('this.lang: ' + JSON.stringify(this.lang));
      sessionStorage.setItem('langTokens', JSON.stringify(this.lang));
      this.configPlanEnrollmentDate =
        this.formConfig2Data.validations.customer.planEnrollmentDatesFullMonth;

      this.brokerTermsConditions =
        this.formConfig2Data?.links?.brokerTermsConditions;
      this.disclosureAgreement_dynamicData =
        this.formConfig2Data?.links?.disclosureAgreement;
      this.disclosureAgreement = this.disclosureAgreement_dynamicData;
      this.logger.log('lang token: ' + sessionStorage.getItem('lanToken'));
      if (sessionStorage.getItem('lanToken') == 'en') {
        this.term_and_conditions = this.brokerTermsConditions;
      } else {
        this.term_and_conditions = this.brokerTermsConditions;
      }
      this.formid = this.formConfig2Data.form?.id;
      // console.log(this.allBrokers)
      } else {
        console.error('Observable returned undefined');
      }
    })
  }
  userForm: FormGroup = new FormGroup({
    planEnrollmentDate: new FormControl(''),
    studentId: new FormControl(''),
    givenname: new FormControl(''),
    lastname: new FormControl(''),
    email: new FormControl(''),
    phonenumber: new FormControl(''),
    apt_suite: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    province: new FormControl(''),
    country: new FormControl(''),
    workingProvince: new FormControl(''),
    postalcode: new FormControl(''),
    dateofbirth: new FormControl(''),
    gender: new FormControl(''),
    foreignStudent: new FormControl(''),
    parentalinsurance: new FormControl(''),
    havingspouse: new FormControl(''),
    Dependentchildren: new FormControl(''),
    uhipprovincialhealth: new FormControl(''),
    provincialhealth: new FormControl(''),
    spousefirstname: new FormControl(''),
    spouselastname: new FormControl(''),
    spousegender: new FormControl(''),
    spousedateofbirth: new FormControl(''),
    spousehealthcard: new FormControl(''),
    workinghours: new FormControl(''),
    hoursperweek: new FormControl(''),
    fusbillId: new FormControl(''),
    formrname: new FormControl(''),
    brokername: new FormControl(''),
    dateOfArrival: new FormControl(''),
    isEmployeeImigrant: new FormControl(''),
    applylandedstaus: new FormControl(''),
    countryOrigin: new FormControl(''),
    coverageRequiredOfEmployee: new FormControl(''),
    dependentdateOfArrival: new FormControl(''),
    coverageRequiredOfDependents: new FormControl(''),
    dependentcountryOrigin: new FormControl(''),
    dependentLandedImigrant: new FormControl(''),
    dependentapplylandedstaus: new FormControl(''),
    dependentMorethan3years: new FormControl(''),
    // memberType: new FormControl(''),
  });

  // memberInfo: FormGroup=new FormGroup({
  //   memberType: new FormControl(''),
  //   brokername:new FormControl(''),
  //   fusbillId:new FormControl(''),

  // })
  // memberInfoFormGropu(){
  //   this.memberInfo=this.fb.group({
  //     memberType:['',Validators.compose([Validators.required])],
  //     brokername:['',],
  //     fusbillId:['',Validators.compose([Validators.required])]
  //   })
  // }

  userFormGroup() {
    this.userForm = this.fb.group({
      planEnrollmentDate: ['', [Validators.required]],
      studentId: ['', [Validators.required]],
      givenname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
        ]),
      ],
      lastname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
        ]),
      ],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),

          ,
        ]),
      ],

      phonenumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ]),
      ],
      apt_suite: [''],
      streetaddress: ['', Validators.compose([Validators.required])],
      streetaddressline2: [
        '',
      ],
      city: [
        '',
        Validators.compose([
          Validators.required,
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
        ]),
      ],
      province: ['', Validators.required],
      country: [''],
      workingProvince: [''],
      postalcode: [
        '',
        Validators.compose([Validators.required, postalcodeValidator]),
      ],
      dateofbirth: [
        '',
        Validators.compose([Validators.required]),
      ],
      dateofhire: [''],
      gender: ['', Validators.required],
      foreignStudent: ['', Validators.required],
      parentalinsurance: ['', Validators.required],
      havingspouse: ['', Validators.required],

      uhipprovincialhealth: [''],
      provincialhealth: [''],
      dateOfArrival: [""],
      isEmployeeImigrant: [""],
      applylandedstaus: [""],
      countryOrigin: [""],
      coverageRequiredOfEmployee: [""],

      dependentdateOfArrival: [""],
      coverageRequiredOfDependents: [""],
      dependentcountryOrigin: [""],
      dependentLandedImigrant: [""],
      dependentapplylandedstaus: [""],
      dependentMorethan3years: [""],

      spousefirstname: [''],
      spouselastname: [''],
      spousegender: [''],
      spousedateofbirth: ['04-01-2000'],
      spousehealthcard: [''],

      Spousenameofthecarrier: [''],
      spousecob: [''],

      Dependentchildren: ['', Validators.required],
      enrolledunversity: [''],
      childdsiablility: [''],
      graducationday: [''],
      noofchildren: [''],
      termsandconditions: [''],
      disclouseradvisor: [''],
      recaptchaReactivePerInfo: [''],
      // childrenDetails: this.fb.array([this.initChildDetails()]),
      workinghours: ['', Validators.compose([Validators.required])],
      // hoursperweek:[''],
      hoursperweek: [
        '40',
        Validators.compose([Validators.required, validatehoursperweek]),
      ],
      fusbillId: [''],
      formrname: ['', Validators.compose([Validators.required])],
      brokername: ['', Validators.compose([Validators.required])],
      // memberType: ['', Validators.compose([Validators.required])],
    });
  }

  enrollmentForm: FormGroup = new FormGroup({
    enrollmentSummaryEmail: new FormControl(''),
    ///enrolmentForm
    enrollmentSummaryCardHolderFirstName: new FormControl(''),
    enrollmentSummaryCardHolderLastName: new FormControl(''),
    enrollmentSummaryCardNumnber: new FormControl(''),
    enrollmentSummaryExpirymonth: new FormControl(''),
    enrollmentSummaryExpiryyear: new FormControl(''),
    enrollmentSummaryCVV: new FormControl(''),
    ////******** */
    homeAddressSameasBillingAddress: new FormControl(''),
    enrollmentSummaryApartSuite: new FormControl(''),
    enrollmentSummaryStreetAddress: new FormControl(''),
    enrollmentSummaryStreetAddressLane2: new FormControl(''),
    enrollmentSummaryCity: new FormControl(''),
    enrollmentSummaryProvince: new FormControl(''),
    enrollmentSummaryPostalCode: new FormControl(''),
  });
  greenShiledForm: FormGroup = new FormGroup({
    showGreenShieldProv: new FormControl(),
    greenShiledNumber: new FormControl()
  });
  greenShiledFormValidations() {
    this.greenShiledForm = this.greenShildBuilder.group({
      showGreenShieldProv: ['', [Validators.required]],
      greenShiledNumber: ['']
    })
  }

  EquitableForm: FormGroup = new FormGroup({
    EquitableFormProv: new FormControl(),
    EquitableNumber: new FormControl()
  });
  KixCareForm: FormGroup = new FormGroup({
    KixCareFormProv: new FormControl(),
    // KixCareNumber: new FormControl()
  });
  FlexForm: FormGroup = new FormGroup({
    FlexFormProv: new FormControl(),
    FlexMembershipId: new FormControl()
  });
  waddellPlanForm: FormGroup = new FormGroup({
    waddellFormProv: new FormControl(),
  });
  cowanForm: FormGroup = new FormGroup({
    cowanFormProv: new FormControl(),
    cowanNumber: new FormControl()
  });
  InvitationForm: FormGroup = new FormGroup({
    invitationStatus: new FormControl(),
    invitationEmail: new FormControl(),
  });
  welcomeinvitationmail() {
    this.InvitationForm = this.fb.group({
      invitationStatus: ['', [Validators.required]],
      invitationEmail: ['', [Validators.pattern(this.commonPatternsService.emailPattern)]],

    })
  }
  EquitableFormValidations() {
    this.EquitableForm = this.greenShildBuilder.group({
      EquitableFormProv: ['', [Validators.required]],
      EquitableNumber: ['']
    })
  }
  KixCareValidations() {
    this.KixCareForm = this.greenShildBuilder.group({
      KixCareFormProv: ['', [Validators.required]],
      // KixCareNumber: ['']
    })
  }
  FlexValidations() {
    this.FlexForm = this.greenShildBuilder.group({
      FlexFormProv: ['', [Validators.required]],
      FlexMembershipId: ['']
    })
  }

  waddellPlanValidations() {
    this.waddellPlanForm = this.greenShildBuilder.group({
      waddellFormProv: ['', [Validators.required]],
      // KixCareNumber: ['']
    })
  }

  cowanFormValidations() {
    this.cowanForm = this.greenShildBuilder.group({
      cowanFormProv: ['', [Validators.required]],
      cowanNumber: ['']
    })
  }

  public workingProvincelist(event: any) {
    // alert(event.target.value)

    if (event.target.value == 'QC') {
      // jQuery("#provinceinfo-modal").modal("show");
    }

    this.configpworkingrovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.working_provincelistid = element.id;
      }
    });



  }
  enrolmentFormValidator() {
    this.enrollmentForm = this.enrollmentFormBuilder.group({
      enrollmentSummaryEmail: [''],
      homeAddressSameasBillingAddress: [''],
      enrollmentSummaryApartSuite: [''],
      enrollmentSummaryStreetAddress: [
        '',
        Validators.compose([Validators.required]),
      ],
      enrollmentSummaryStreetAddressLane2: [''],
      enrollmentSummaryCity: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(50)]),
      ],
      enrollmentSummaryProvince: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(50)]),
      ],
      enrollmentSummaryPostalCode: [
        '',
        Validators.compose([Validators.required, postalcodeValidator]),
      ],
      recaptchaReactive: [''],

      //enrollmentSummaryApartSuite: ["", Validators.compose([apt_suitecheck, Validators.maxLength(50)])],
      // enrollmentSummaryStreetAddress: ['', [Validators.required]],
      // enrollmentSummaryStreetAddressLane2: ['', [Validators.required]],
      //enrollmentSummaryCity: ['', [Validators.required]],
      // enrollmentSummaryProvince: ['', [Validators.required]],
      // enrollmentSummaryPostalCode: ["", Validators.compose([Validators.required, postalcodeValidator])],
      // recaptchaReactive: ["",],
      // recaptchaReactive: ["", Validators.required],
      // creditCardFormValid: this.creditCardForm,
      //enrollment
      enrollmentSummaryCardHolderFirstName: [''], //['', Validators.compose([Validators.required, Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")])],
      enrollmentSummaryCardHolderLastName: [''], //['', Validators.compose([Validators.required, Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")])],
      enrollmentSummaryCardNumnber: [''], // ["", Validators.compose([Validators.required, creditcardvalidation]),],
      enrollmentSummaryExpirymonth: [''], // ['', [Validators.required]],
      enrollmentSummaryExpiryyear: [''], // ['', [Validators.required]],
      // enrollmentSummaryCVV: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      enrollmentSummaryCVV: [''],
    });
  }
  bankPayForm: FormGroup = new FormGroup({
    enrollmentSummaryBankNumber: new FormControl(''),
    enrollmentSummaryTransitNumber: new FormControl(''),
    enrollmentSummaryAccontNumber: new FormControl(''),
    enrollmentBankTextdescription: new FormControl(''),
    reviewAndSignThePadAgreementBtn: new FormControl(''),
    enrollmentSummaryvoidCheckUpload: new FormControl(''),
  });

  bankPayFormValidator() {
    this.bankPayForm = this.bankPayFormBuilder.group({
      enrollmentSummaryBankNumber: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(3)],
      ],
      enrollmentSummaryTransitNumber: [
        '',
        [Validators.required, Validators.minLength(5), Validators.maxLength(5)],
      ],
      enrollmentSummaryAccontNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(12),
        ],
      ],
      enrollmentBankTextdescription: ['', [Validators.required]],
      enrollmentSummaryvoidCheckUpload: ['', [Validators.required]],
      // reviewAndSignThePadAgreementBtn:['',[Validators.required]],
      reviewAndSignThePadAgreementBtn: [''],
    });
  }

  childFormGroup: FormGroup = new FormGroup({
    childInfoFirstName: new FormControl(''),
    childInfoLastName: new FormControl(''),
    childInfoGender: new FormControl(''),
    childInfoDOB: new FormControl(''),
    childdisablility: new FormControl(''),
    childInfoCarrierName: new FormControl(''),
    childPostGraduate: new FormControl(''),
    childInfoGraduationday: new FormControl(''),
    DependentchildInsurence: new FormControl(''),
  });

  childInfoValidators() {
    this.childFormGroup = this.childInfoFormBuilder.group({
      childInfoFirstName: [
        '',
        Validators.compose([
          Validators.required,
          ,
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
          Validators.minLength(3),
        ]),
      ],
      childInfoLastName: [
        '',
        Validators.compose([
          Validators.required,
          ,
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
          Validators.minLength(3),
        ]),
      ],
      childInfoGender: ['', [Validators.required]],
      childInfoDOB: ['', [Validators.required]],
      childdisablility: [''],
      childInfoCarrierName: [''],
      childPostGraduate: [''],
      childInfoGraduationday: [''],
      DependentchildInsurence: ['', Validators.required],
    });
  }

  initChildDetails() {
    return (this.childFormGroup = this.childInfoFormBuilder.group({
      childInfoFirstName: [''],
      childInfoLastName: [''],
      childInfoGender: [''],
      childInfoDOB: [''],
      childdisablility: [''],
      childInfoCarrierName: [''],
      childPostGraduate: [''],
      childInfoGraduationday: [''],
      DependentchildInsurence: [''],
    }));
  }

  alphaNumarics(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (event.currentTarget.value.length == 0) {//for first latter not allow space
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 192 && charCode <= 255)
        || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 192 && charCode <= 255) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95 ||
        charCode === 32
      )
        return true;
      else return false;
    }

  }

  alphabatesOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
  }

  numberOnly(event: any): boolean {
    //we have numeric 48 to 57 it return true when enter number

    const charCode = event.which ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //if(charCode>48&&charCode<57)
      return false;
    } else return true;
  }


  phoneFormat(event: any) {
    const inputValue = this.userForm.get('phonenumber').value;

    this.userForm
      .get('phonenumber')
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    console.log(this.userForm.get('phonenumber').value, this.userForm.controls)
  }
  termsandconditionsLoaded(event: any) {
    this.logger.log('termsandconditionsLoaded here');
    this.pdfvisibletermsandconditions = false;
  }




  sendwelcomeinvitation(form: any) {

    this.InvitationForm.markAllAsTouched();

    if (this.InvitationForm.valid) {
      $('#confirmwelcomeemail').hide();
      let inputData: any = sessionStorage.getItem('Data');
      let validationInputData = typeof inputData != 'object' ? JSON.parse(inputData) : inputData;
      inputData = JSON.parse(inputData);
      if (this.isStudent) {
        validationInputData['plans'] = JSON.parse(sessionStorage.getItem('studentsPlansArray'));
      } else {

        let plansMain = ''

        if (this.isCorporate == true) {
          plansMain = sessionStorage.getItem("allSelectedPlans") ? JSON.parse(sessionStorage.getItem("allSelectedPlans") || '') : []

        } else {
          plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []

        }
        // let plansMain = sessionStorage.getItem("plansummarymain")?JSON.parse(sessionStorage.getItem("plansummarymain")||''):[]
        let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []

        validationInputData['plans'] = plansMain.concat(plansLife)
      }

      if (this.isCorporate == true) {
        validationInputData['working_province_id'] = this.working_provincelistid
        validationInputData['corporateStateId'] = parseInt(sessionStorage.getItem("companyStateId"))
        validationInputData['employeeWorkingStateId'] = parseInt(sessionStorage.getItem("corporateStateId"))

      }

      validationInputData['fusebill_paymentMethod'] = this.fusebill_paymentMethod;
      let enrollmentSummaryProvinceval: string =
        this.enrollmentFormControl['enrollmentSummaryProvince'].value;
      //this.paymentMethodSelectCC it means credit card
      if (this.paymentMethodSelectCC) {
        // validationInputData['marital_status'] = this.marital_status;
        validationInputData.signature =
          sessionStorage.getItem('signatureCC') ?? '';
      } else {
      }

      let provincelist = sessionStorage.getItem('provincelist') || '';
      if (provincelist.includes(inputData.province_id)) {
      } else {
        if (this.configresults.assign_default_form == true) {
          inputData.formId = this.configresults.default_form.id;
          inputData.brokershipTransfered = true;
          inputData.originalFormId = this.configresults.form.id;
        } else {
        }
      }

      var fusebillCustomerAddressId = sessionStorage.getItem(
        'fusebillCustomerAddressId'
      );
      if (fusebillCustomerAddressId && fusebillCustomerAddressId.length > 0) {
        inputData['fusebillCustomerAddressId'] =
          sessionStorage.getItem('fusebillCustomerAddressId') || null;
      }
      var fusebillCustomerId = sessionStorage.getItem('fusebillCustomerId');
      if (fusebillCustomerId && fusebillCustomerId.length > 0) {
        inputData.fusebillCustomerId =
          sessionStorage.getItem('fusebillCustomerId') || null;
      }
      var fusebillCustomerBillingAddressId = sessionStorage.getItem(
        'fusebillCustomerBillingAddressId'
      );
      if (
        fusebillCustomerBillingAddressId &&
        fusebillCustomerBillingAddressId.length > 0
      ) {
        inputData.fusebillCustomerBillingAddressId =
          sessionStorage.getItem('fusebillCustomerBillingAddressId') || null;
      }
      var customerId = sessionStorage.getItem('customerId');

      if (customerId && customerId.length > 0) {
        inputData.customerId = sessionStorage.getItem('customerId') || null;
      }

      let statesData: any = this.configprovinceres.filter(
        (item: { shortName: any }) => {
          return (
            item.shortName ===
            (enrollmentSummaryProvinceval == null || enrollmentSummaryProvinceval == ''
              ? validationInputData.province
              : this.enrollmentFormControl['enrollmentSummaryProvince'].value)
          );
        }
      );

      if (
        typeof validationInputData === 'object' &&
        validationInputData !== null
      ) {
        validationInputData['marital_status'] =
          this.marital_status !== '' ? this.marital_status : '';
        validationInputData['billing_sameas_homeAddress'] = this
          .homeaddressEnrollmentVal
          ? true
          : false; //this.enrollmentFormControl['homeAddressSameasBillingAddress'].value == 'true' ? true : false;
        if (!validationInputData['billing_sameas_homeAddress']) {
          validationInputData['billing_address'] = {
            line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
            line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
            city: inputData.city || '',
            country: 'Canada',
            state: statesData.length != 0 ? statesData[0].name : '',
            country_id: 1,
            countryId: 1,
            state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
            stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
            fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
            fusebillCountryId: 124,
            apt: inputData.apt || '',
            postal_zip: inputData.postal_code || '',
          };
        } else {
          validationInputData['billing_address'] = {
            // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
            // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
            line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
            line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
            city: inputData.city || '', //this.enrollmentFormControl["enrollmentSummaryCity"].value || "",
            state: inputData.province || '', //this.enrollmentFormControl["enrollmentSummaryProvince"].value || "",
            country: 'Canada',
            country_id: 1,
            countryId: 1,
            state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
            stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
            fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
            fusebillCountryId: 124,
            postal_zip: inputData.postal_code || '',//this.enrollmentFormControl["enrollmentSummaryPostalCode"].value || "",
            apt: inputData.apt || '',//this.enrollmentFormControl["enrollmentSummaryApartSuite"].value || "",
          };
        }
      } else {
        console.error('Data in sessionStorage is not a valid JSON object.');
      }
      this.logger.log('validationInputData: ' + JSON.stringify(validationInputData));
      let formValid = true;

      if (this.homeaddressEnrollmentVal) {
        this.enrollmentForm
          .get('homeAddressSameasBillingAddress')
          ?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
        this.enrollmentForm
          .get('enrollmentSummaryStreetAddress')
          ?.clearValidators();
        this.enrollmentForm
          .get('enrollmentSummaryStreetAddressLane2')
          ?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
        for (let control of Object.keys(this.enrollmentForm.controls)) {
          this.enrollmentForm.get(control).clearValidators();
          this.enrollmentForm.get(control).updateValueAndValidity();
        }
      }

      // if (this.enrollmentForm.valid) {
      // var endPoint = '/api/ap/customer/registration';
      var endPoint = ''

      if (this.FormbrokerType == 'CORPORATE') {
        // endPoint='/api/ap/v3/corporate/customer/registration/backdate';
        endPoint = '/api/ap/v3/corporate/customer/registration'



      } else {
        // endPoint='/api/ap/v3/customer/registration/withBackdate';
        endPoint = '/api/ap/v3/customer/registration';
      }

      var accessToken = sessionStorage.getItem('accessToken');

      this.planssummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";
      this.plansummaryLIFE = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '')
      this.plansummaryLIFE.forEach((element: any, index: number) => {

        element.member.maximumCoverageWithoutEvidence = element.member.defaultRange

        if (element.spouse && element.spouse.maximumCoverageWithoutEvidence) {
          element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange
        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$" + element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] = element.guaranteedAcceptanceDetails.total
        element['totalPrice'] = element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$" + element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$" + element.guaranteedAcceptanceDetails.tax
        this.plansummaryLIFEFinal.push(element)

      });
      this.planssummarymain = this.planssummarymain.concat(this.plansummaryLIFEFinal)
      var total = 0;
      var amount = 0;
      var tax = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].total);
        amount += parseFloat(this.planssummarymain[i].amount);

        tax += parseFloat(this.planssummarymain[i].tax);

      }


      let array = []

      // alert(this.InvitationForm.get('invitationEmail')?.value)


      if (this.InvitationForm.get('invitationEmail')?.value.length > 0) {
        array.push(this.InvitationForm.get('invitationEmail')?.value)
      }


      validationInputData["planAllAmount"] = amount
      validationInputData["taxAllAmount"] = tax
      validationInputData["totalAllAmount"] = total
      validationInputData["totalAmount"] = total;

      validationInputData["gsRegistration"] = this.gsRegistration;
      validationInputData["gsPlans"] = this.gsPlans;
      validationInputData["gsMembershipId"] = this.gsMembershipId;
      validationInputData["eqRegistration"] = this.eqRegistration;
      validationInputData["eqPlans"] = this.eqPlans;
      validationInputData["eqCertificateId"] = this.eqCertificateId;
      validationInputData["phrRegistration"] = this.cwRegistraion;
      validationInputData["kixcareRegistration"] = this.kixRegistration;
      validationInputData["kixPlans"] = this.kixPlans;
      validationInputData["waddellPlan"] = this.waddellPlans;

      validationInputData["phrPlan"] = this.cwPlans;
      validationInputData["phrCertificateId"] = this.cwCertificateId;
      validationInputData["welcomeMail"] = this.InvitationForm.get('invitationStatus')?.value == "true" ? true : false
      validationInputData["welcomeMailSender"] = array || []

      validationInputData["flexgsRegistration"] = this.flexRegistration;
      validationInputData["flexgsPlans"] = this.flexPlans;
      validationInputData["flexgsMembershipId"] = this.flexCertificateId;

      let companypaidplansCheck = validationInputData['plans'].filter(plan => plan.PaidByCompany === 1);
      if (companypaidplansCheck) {
        validationInputData["failed"] = []
      }else{
          validationInputData["failed"] = [this.fusebill_paymentMethod + "Failed"]
      }


      this.logger.log('validationInputData', validationInputData);

      this.http
        .post(environment.apiUrl + endPoint, validationInputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              // var details = '/api/ap/admin/customers/list';

              // this.store.dispatch(loadMemberDataSuccess({ memberData: [...this.members, {...this.memberDetails}] }));

              // this.http.post(environment.apiUrl + '/api/ap/v2/global/set-adminMembers', { wait: true }).subscribe((newResponse) => {
              //   this.store.dispatch(loadMemberDataSuccess({ memberData: [] }));
              //   this.store.dispatch(loadMemberData());
              // })
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((response) => { })
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((response) => { })
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((response) => { })
              this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
                "message": "Members information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => { })

              Swal.fire({
                title: this.lang.Info,
                // html: error.error.message ? error.error.message : error.error.error,
                html: response.message,
                // icon: "warning",
                width: "30%",
                showCancelButton: true,
                confirmButtonText: this.lang.View_Member,
                cancelButtonText: this.lang.Add_Another_Member
              }).then((result) => {
                if (result.value) {
                  this.logger.log({ "Respo": response })
                  let inputData: any = sessionStorage.getItem('Data');
                  this.logger.log({ inputData })
                  this.SharedService.setUserName(validationInputData.firstName + " " + validationInputData.lastName)
                  sessionStorage.setItem('memberUserName', validationInputData.firstName + " " + validationInputData.lastName);
                  this.router.navigate([response.portalLink || `/manageMembers`]);
                  // this.router.navigate([`/manageMembers`]);

                  this.logger.log("result.value: " + result.value);
                } else {
                  window.location.reload();
                }
              })
            } else {


              Swal.fire({ title: this.lang.Info, text: response.message || response.data.error || response.error || response.error.error })

              // this.router.navigate([`/manageMembers`]);

            }
          },
          (error) => {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              // html: error.error.message ? error.error.message : error.error.error,
              html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error
                }</div>`,
              // icon: "warning",
              width: '30%',
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.value) {
                this.logger.log('result.value: ' + result.value);
              }
            });
          }
        );
      // } else {
      // }
    }
    else {
      const invalid = [];
      const controls = this.InvitationForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      this.logger.log(invalid)
    }
  }

  enrollmentForActivePlans() {

    let inputData: any = sessionStorage.getItem('Data');
    let validationInputData = typeof inputData != 'object' ? JSON.parse(inputData) : inputData;
    inputData = JSON.parse(inputData);

    validationInputData['plans'] = this.customerPlansActiveData;

    validationInputData['fusebill_paymentMethod'] = this.fusebill_paymentMethod;
    let enrollmentSummaryProvinceval: string =
      this.enrollmentFormControl['enrollmentSummaryProvince'].value;
    //this.paymentMethodSelectCC it means credit card
    if (this.paymentMethodSelectCC) {
      // validationInputData['marital_status'] = this.marital_status;
      validationInputData.signature =
        sessionStorage.getItem('signatureCC') ?? '';
    } else {
    }

    let provincelist = sessionStorage.getItem('provincelist') || '';
    if (provincelist.includes(inputData.province_id)) {
    } else {
      if (this.configresults.assign_default_form == true) {
        inputData.formId = this.configresults.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.configresults.form.id;
      } else {
      }
    }

    var fusebillCustomerAddressId = sessionStorage.getItem(
      'fusebillCustomerAddressId'
    );
    if (fusebillCustomerAddressId && fusebillCustomerAddressId.length > 0) {
      inputData['fusebillCustomerAddressId'] =
        sessionStorage.getItem('fusebillCustomerAddressId') || null;
    }
    var fusebillCustomerId = sessionStorage.getItem('fusebillCustomerId');
    if (fusebillCustomerId && fusebillCustomerId.length > 0) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem('fusebillCustomerId') || null;
    }
    var fusebillCustomerBillingAddressId = sessionStorage.getItem(
      'fusebillCustomerBillingAddressId'
    );
    if (
      fusebillCustomerBillingAddressId &&
      fusebillCustomerBillingAddressId.length > 0
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem('fusebillCustomerBillingAddressId') || null;
    }
    var customerId = sessionStorage.getItem('customerId');

    if (customerId && customerId.length > 0) {
      inputData.customerId = sessionStorage.getItem('customerId') || null;
    }

    let statesData: any = this.configprovinceres.filter(
      (item: { shortName: any }) => {
        return (
          item.shortName ===
          (enrollmentSummaryProvinceval == null || enrollmentSummaryProvinceval == ''
            ? validationInputData.province
            : this.enrollmentFormControl['enrollmentSummaryProvince'].value)
        );
      }
    );

    // console.log({ statesData })
    // return;

    if (
      typeof validationInputData === 'object' &&
      validationInputData !== null
    ) {
      validationInputData['marital_status'] =
        this.marital_status !== '' ? this.marital_status : '';
      validationInputData['billing_sameas_homeAddress'] = this
        .homeaddressEnrollmentVal
        ? true
        : false; //this.enrollmentFormControl['homeAddressSameasBillingAddress'].value == 'true' ? true : false;
      if (!validationInputData['billing_sameas_homeAddress']) {
        validationInputData['billing_address'] = {
          line1:
            this.enrollmentFormControl['enrollmentSummaryStreetAddress']
              .value == undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryStreetAddress']
                .value,
          line2:
            this.enrollmentFormControl['enrollmentSummaryStreetAddressLane2']
              .value == undefined
              ? ''
              : this.enrollmentFormControl[
                'enrollmentSummaryStreetAddressLane2'
              ].value,
          city:
            this.enrollmentFormControl['enrollmentSummaryCity'].value ==
              undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryCity'].value,
          state: statesData.length != 0 ? statesData[0].name : '',
          country: 'Canada',
          country_id: 1,
          countryId: 1,
          state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          fusebillCountryId: 124,
          apt:
            this.enrollmentFormControl['enrollmentSummaryApartSuite'].value ==
              undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryApartSuite'].value,
        };
      } else {
        validationInputData['billing_address'] = {
          // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
          // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
          line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
          line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
          city: inputData.city || '', //this.enrollmentFormControl["enrollmentSummaryCity"].value || "",
          state: inputData.province || '', //this.enrollmentFormControl["enrollmentSummaryProvince"].value || "",
          state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          country: 'Canada',
          country_id: 1,
          countryId: 1,
          fusebillCountryId: 124,
          postal_zip: inputData.postal_code || '',//this.enrollmentFormControl["enrollmentSummaryPostalCode"].value || "",
          apt: inputData.apt || '',//this.enrollmentFormControl["enrollmentSummaryApartSuite"].value || "",
        };
      }
    } else {
      console.error('Data in sessionStorage is not a valid JSON object.');
    }
    this.logger.log('validationInputData: ' + JSON.stringify(validationInputData));
    let formValid = true;

    if (this.homeaddressEnrollmentVal) {
      this.enrollmentForm
        .get('homeAddressSameasBillingAddress')
        ?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddress')
        ?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddressLane2')
        ?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
      for (let control of Object.keys(this.enrollmentForm.controls)) {
        this.enrollmentForm.get(control).clearValidators();
        this.enrollmentForm.get(control).updateValueAndValidity();
      }
    }

    if (this.enrollmentForm.valid) {
      // var endPoint = '/api/ap/customer/registration';
      var endPoint = '/api/ap/v3/member/registration';

      var accessToken = sessionStorage.getItem('accessToken');

      this.planssummarymain =
        JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

      var total = 0;
      var amount = 0;
      var tax = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].total);
        amount += parseFloat(this.planssummarymain[i].amount);

        tax += parseFloat(this.planssummarymain[i].tax);

      }


      let array = []

      // alert(this.InvitationForm.get('invitationEmail')?.value)


      if (this.InvitationForm.get('invitationEmail')?.value.length > 0) {
        array.push(this.InvitationForm.get('invitationEmail')?.value)
      }


      validationInputData["planAllAmount"] = amount
      validationInputData["taxAllAmount"] = tax
      validationInputData["totalAllAmount"] = total
      validationInputData["totalAmount"] = total;

      validationInputData["gsRegistration"] = this.gsRegistration;
      validationInputData["gsPlans"] = this.gsPlans;
      validationInputData["gsMembershipId"] = this.gsMembershipId;
      validationInputData["eqRegistration"] = this.eqRegistration;
      validationInputData["eqPlans"] = this.eqPlans;
      validationInputData["kixcareRegistration"] = this.kixRegistration;
      validationInputData["kixPlans"] = this.kixPlans;
      validationInputData["waddellPlan"] = this.waddellPlans;
      validationInputData["eqCertificateId"] = this.eqCertificateId;
      validationInputData["phrRegistration"] = this.cwRegistraion;
      validationInputData["phrPlans"] = this.cwPlans;
      validationInputData["phrCertificateId"] = this.cwCertificateId;
      validationInputData["welcomeMail"] = this.InvitationForm.get('invitationStatus')?.value == "true" ? true : false
      validationInputData["welcomeMailSender"] = array || []
      validationInputData["flexgsRegistration"] = this.flexRegistration;
      validationInputData["flexgsPlans"] = this.flexPlans;
      validationInputData["flexgsMembershipId"] = this.flexCertificateId;

      this.logger.log('validationInputData', validationInputData);
      // return
      this.http
        .post(environment.apiUrl + endPoint, validationInputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {

              Swal.fire({
                title: this.lang.Info,
                // html: error.error.message ? error.error.message : error.error.error,
                html: response.message,
                // icon: "warning",
                width: "30%",
                showCancelButton: true,
                confirmButtonText: "View Member",
                cancelButtonText: 'Add Another Member'
              }).then((result) => {
                if (result.isConfirmed) {
                  const id = response.data.customer.id
                  this.logger.log({ "resp": response })
                  this.SharedService.setUserName(validationInputData.firstName + " " + validationInputData.lastName)
                  sessionStorage.setItem('memberUserName', validationInputData.firstName + " " + validationInputData.lastName);
                  this.logger.log("result.value: " + result.value, id);
                  this.router.navigate([`/manageMembers/employee/${id}/details`]);
                } else {
                  window.location.reload();
                }
              })
            } else {
              Swal.fire({ title: this.lang.Info, text: response.message || response.data.error || response.error || response.error.error })
            }
          },
          (error) => {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              // html: error.error.message ? error.error.message : error.error.error,
              html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error
                }</div>`,
              // icon: "warning",
              width: '30%',
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.value) {
                this.logger.log('result.value: ' + result.value);
              }
            });
          }
        );
    } else {
    }

  }

  enrollmentFormSubmit(value1: any) {

    let inputData: any = sessionStorage.getItem('Data');
    let validationInputData = typeof inputData != 'object' ? JSON.parse(inputData) : inputData;
    inputData = JSON.parse(inputData);
    if (this.isStudent) {
      validationInputData['plans'] = JSON.parse(sessionStorage.getItem('studentsPlansArray'));
    } else {
      let plansMain = ''

      if (this.isCorporate == true) {
        plansMain = sessionStorage.getItem("allSelectedPlans") ? JSON.parse(sessionStorage.getItem("allSelectedPlans") || '') : []

      } else {
        plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []

      }
      let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []

      validationInputData['plans'] = plansMain.concat(plansLife)

    }

    validationInputData['fusebill_paymentMethod'] = this.fusebill_paymentMethod;
    let enrollmentSummaryProvinceval: string =
      this.enrollmentFormControl['enrollmentSummaryProvince'].value;
    //this.paymentMethodSelectCC it means credit card
    if (this.paymentMethodSelectCC) {
      // validationInputData['marital_status'] = this.marital_status;
      validationInputData.signature =
        sessionStorage.getItem('signatureCC') ?? '';
    } else {
    }

    let provincelist = sessionStorage.getItem('provincelist') || '';
    if (provincelist.includes(inputData.province_id)) {
    } else {
      if (this.configresults.assign_default_form == true) {
        inputData.formId = this.configresults.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.configresults.form.id;
      } else {
      }
    }

    var fusebillCustomerAddressId = sessionStorage.getItem(
      'fusebillCustomerAddressId'
    );

    if (fusebillCustomerAddressId && fusebillCustomerAddressId.length > 0) {
      inputData['fusebillCustomerAddressId'] =
        sessionStorage.getItem('fusebillCustomerAddressId') || null;
    }
    var fusebillCustomerId = sessionStorage.getItem('fusebillCustomerId');
    if (fusebillCustomerId && fusebillCustomerId.length > 0) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem('fusebillCustomerId') || null;
    }
    console.log({ fusebillCustomerId })
    var fusebillCustomerBillingAddressId = sessionStorage.getItem(
      'fusebillCustomerBillingAddressId'
    );
    if (
      fusebillCustomerBillingAddressId &&
      fusebillCustomerBillingAddressId.length > 0
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem('fusebillCustomerBillingAddressId') || null;
    }
    var customerId = sessionStorage.getItem('customerId');

    if (customerId && customerId.length > 0) {
      inputData.customerId = sessionStorage.getItem('customerId') || null;
    }

    let statesData: any = this.configprovinceres.filter(
      (item: { shortName: any }) => {
        // console.log(item.shortName, enrollmentSummaryProvinceval, this.enrollmentFormControl['enrollmentSummaryProvince'].value, validationInputData.province, item.shortName ==
        //   (enrollmentSummaryProvinceval == ''
        //     ? validationInputData.province
        //     : this.enrollmentFormControl['enrollmentSummaryProvince'].value))
        return (
          item.shortName ==
          (enrollmentSummaryProvinceval == null || enrollmentSummaryProvinceval == ''
            ? validationInputData.province
            : this.enrollmentFormControl['enrollmentSummaryProvince'].value)
        );
      }
    );

    console.log({ statesData })


    if (
      typeof validationInputData === 'object' &&
      validationInputData !== null
    ) {
      validationInputData['marital_status'] =
        this.marital_status !== '' ? this.marital_status : '';
      validationInputData['billing_sameas_homeAddress'] = this
        .homeaddressEnrollmentVal
        ? true
        : false; //this.enrollmentFormControl['homeAddressSameasBillingAddress'].value == 'true' ? true : false;
      if (!validationInputData['billing_sameas_homeAddress']) {
        validationInputData['billing_address'] = {
          line1:
            this.enrollmentFormControl['enrollmentSummaryStreetAddress']
              .value == undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryStreetAddress']
                .value,
          line2:
            this.enrollmentFormControl['enrollmentSummaryStreetAddressLane2']
              .value == undefined
              ? ''
              : this.enrollmentFormControl[
                'enrollmentSummaryStreetAddressLane2'
              ].value,
          city:
            this.enrollmentFormControl['enrollmentSummaryCity'].value ==
              undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryCity'].value,
          state: statesData.length != 0 ? statesData[0].name : '',
          country: 'Canada',
          country_id: 1,
          countryId: 1,
          state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          fusebillCountryId: 124,
          apt:
            this.enrollmentFormControl['enrollmentSummaryApartSuite'].value ==
              undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryApartSuite'].value,
        };
      }
      else {
        validationInputData['billing_address'] = {
          // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
          // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
          line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
          line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
          city: inputData.city || '', //this.enrollmentFormControl["enrollmentSummaryCity"].value || "",
          state: inputData.province || '', //this.enrollmentFormControl["enrollmentSummaryProvince"].value || "",
          country: "Canada",
          country_id: 1,
          countryId: 1,
          state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          fusebillCountryId: 124,
          postal_zip: inputData.postal_code || '',//this.enrollmentFormControl["enrollmentSummaryPostalCode"].value || "",
          apt: inputData.apt || '',//this.enrollmentFormControl["enrollmentSummaryApartSuite"].value || "",
        };
      }
    } else {
      console.error('Data in sessionStorage is not a valid JSON object.');
    }
    this.logger.log('validationInputData: ' + JSON.stringify(validationInputData));
    console.log("billing", validationInputData['billing_address'])
    let formValid = true;

    if (this.homeaddressEnrollmentVal) {
      this.enrollmentForm
        .get('homeAddressSameasBillingAddress')
        ?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddress')
        ?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddressLane2')
        ?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
      for (let control of Object.keys(this.enrollmentForm.controls)) {
        this.enrollmentForm.get(control).clearValidators();
        this.enrollmentForm.get(control).updateValueAndValidity();
      }
    }


    if (this.isCorporate == true) {
      $('#confirmwelcomeemail').show();
    }
    else {
      if (this.enrollmentForm.valid) {
        $('#confirmwelcomeemail').show();
        return false;



        var endPoint = '/api/ap/v2/customer/registration/withBackdate';

        var accessToken = sessionStorage.getItem('accessToken');

        this.planssummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

        var total = 0;
        var amount = 0;
        var tax = 0;
        for (let i = 0; i < this.planssummarymain.length; i++) {
          total += parseFloat(this.planssummarymain[i].total);
          amount += parseFloat(this.planssummarymain[i].amount);

          tax += parseFloat(this.planssummarymain[i].tax);

        }


        let array = []

        // alert(this.InvitationForm.get('invitationEmail')?.value)


        if (this.InvitationForm.get('invitationEmail')?.value.length > 0) {
          array.push(this.InvitationForm.get('invitationEmail')?.value)
        }

        validationInputData["planAllAmount"] = amount
        validationInputData["taxAllAmount"] = tax
        validationInputData["totalAllAmount"] = total
        validationInputData["totalAmount"] = total;

        validationInputData["gsRegistration"] = this.gsRegistration;
        validationInputData["gsPlans"] = this.gsPlans;
        validationInputData["gsMembershipId"] = this.gsMembershipId;
        validationInputData["eqRegistration"] = this.eqRegistration;
        validationInputData["eqPlans"] = this.eqPlans;
        validationInputData["eqCertificateId"] = this.eqCertificateId;
        validationInputData["welcomeMail"] = this.InvitationForm.get('invitationStatus')?.value ? true : false
        validationInputData["welcomeMailSender"] = array || []

        this.logger.log('validationInputData', JSON.stringify(validationInputData));



        this.http
          .post(environment.apiUrl + endPoint, validationInputData, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (result: any) => {
              if (result.status == '200') {

                Swal.fire({
                  title: this.lang.Info,
                  // html: error.error.message ? error.error.message : error.error.error,
                  html: result.message,
                  // icon: "warning",
                  width: "30%",
                  showCancelButton: true,
                  confirmButtonText: "View Member",
                  cancelButtonText: 'Add Another Member'
                }).then((result) => {
                  if (result.value) {
                    this.router.navigate(['/manageMembers']);
                    this.logger.log("result.value: " + result.value);
                  } else {
                    window.location.reload();
                  }
                })
              } else {
                Swal.fire({ title: this.lang.Info, text: result.message || result.data.error || result.error || result.error.error })
              }
            },
            (error) => {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                // html: error.error.message ? error.error.message : error.error.error,
                html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error
                  }</div>`,
                // icon: "warning",
                width: '30%',
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.value) {
                  this.logger.log('result.value: ' + result.value);
                }
              });
            }
          );



      }
      else {
        this.enrollmentForm.markAllAsTouched()
      }
    }



  }

  public bankformsubmitdetails() {
    var formData: any = new FormData();

    let personalInfo = JSON.parse(sessionStorage.getItem('Data') ?? '');

    let inputData = {
      customerId: parseInt(sessionStorage.getItem('normalcustomerid') ?? ''),
      bankCode: this.bankPayForm.get('enrollmentSummaryBankNumber')?.value,
      branchCode: this.bankPayForm.get('enrollmentSummaryTransitNumber')?.value,
      accountNumber: this.bankPayForm.get('enrollmentSummaryAccontNumber')
        ?.value,

      amount: this._decimalPipe
        .transform(sessionStorage.getItem('totalAmount') ?? '', '1.2-2')
        ?.replace(/,/g, ''),
      totalAmount: this._decimalPipe
        ?.transform(sessionStorage.getItem('totalAmount') ?? '', '1.2-2')
        ?.replace(/,/g, ''),

      totalAmountUI: sessionStorage.getItem('totalAmountUI'),
      enrollmentDate: sessionStorage.getItem('enrollmentdate'),
      customerName: personalInfo.firstName + ' ' + personalInfo.lastName,
    };

    this.logger.log(inputData);

    var encBank = btoa(JSON.stringify(inputData));
    formData.append('session', encBank);
    formData.append('timestamp', new Date().getTime());
    formData.append('files', this.bankfile);

    //this.logger.log(this.bankfile)

    sessionStorage.setItem('session', encBank);

    this.router.navigate(['/signupcomplete']);

    return false;
  }
  public areYouInternationalStudent(value: any) {
    if (value == 'yes') {
      this.userForm.get('provincialhealth')?.reset();
      this.userForm.get('provincialhealth')?.clearValidators();
      this.userForm.get('provincialhealth')?.updateValueAndValidity();
      this.userForm.get('uhipprovincialhealth')?.reset();
      this.userForm.get('uhipprovincialhealth')?.clearValidators();
      this.userForm
        .get('uhipprovincialhealth')
        ?.setValidators([Validators.required]);

      this.checkstudenthealthcardstatus = true;
      this.checkstudenthealthcardstatus_UHIP = false;
      this.checkhealthcardstatus = false;
    } else {
      this.userForm.get('provincialhealth')?.reset();
      this.userForm.get('provincialhealth')?.clearValidators();
      this.userForm
        .get('provincialhealth')
        ?.setValidators([Validators.required]);
      this.userForm.get('uhipprovincialhealth')?.reset();
      this.userForm.get('uhipprovincialhealth')?.clearValidators();
      this.userForm.get('uhipprovincialhealth')?.updateValueAndValidity();
      this.checkstudenthealthcardstatus = false;
      this.checkstudenthealthcardstatus_UHIP = true;

      this.checkhealthcardstatusuhip = false;
    }
  }



  public havingchildrenDependentInsurence(event: any) {
    let childrenVal = event.target.value;
    this.logger.log('havingchildrenDependentInsurence: ' + childrenVal);
    if (childrenVal == 'true') {
      this.dependentchildInsurenceval = true;
      this.childFormGroup
        .get('childInfoCarrierName')
        ?.setValidators([Validators.required]);
    } else {
      this.childFormGroup.get('childInfoCarrierName')?.reset();
      this.childFormGroup.get('childInfoCarrierName')?.clearValidators();
      this.childFormGroup.get('childInfoCarrierName')?.updateValueAndValidity();
      this.dependentchildInsurenceval = false;
    }
  }

  validateDateforGraduation = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.childFormGroup) {
      let dobControl = this.childFormGroup.get('childInfoDOB');
      this.logger.log({ dobControl })

      if (dobControl) {
        let dob = new Date(dobControl.value);
        if (new Date(control.value) < dob) {
          return { validGraduationDate: true };
        }
      }
    }
    return null;
  };

  childrenminimumAgeValidator = (control: AbstractControl): { [key: string]: any } | null => {

    const birthDate = new Date(control.value);

    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();



    if (age == 55) {
      return { childrenminimumAge: false };
    }
    if (age > 21 || age < 0) {
      return { childrenminimumAge: true };
    }


    return null;

  }

  checkForGraduationDate() {
    this.logger.log("calling")
    const graduationDayControl = this.childFormGroup.get('childInfoGraduationday');
    if (graduationDayControl.value) {
      graduationDayControl.updateValueAndValidity();
    }

  }


  public enrolledunversity(event: any) {
    this.logger.log('enrolledUnv: ' + event.target.checked);
    if (event.target.checked == true) {
      this.graducationdaycheck = true;
      this.childFormGroup.get('childInfoGraduationday')?.setValidators(Validators.compose([Validators.required, this.validateDateforGraduation]));
    } else {
      this.childFormGroup.get('childInfoGraduationday')?.reset();
      this.childFormGroup.get('childInfoGraduationday')?.clearValidators();
      this.childFormGroup
        .get('childInfoGraduationday')
        ?.updateValueAndValidity();
      this.graducationdaycheck = false;
    }
  }

  closePopup(id: any) {
    $(`#${id}`).hide();
  }
  closeFormPopup(id: any, form: FormGroup) {
    this.closePopup(id);
    form.reset();
  }

  provincelist12345(event: any) {
    // alert(event.target.value)
    // if (event.target.value == 'QC') {
    //   $('#QCproviance').show();
    // }
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.logger.log('this.provincialHealthcareUrl', this.provincialHealthcareUrl)
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    // //this.logger.log(this.userForm.get('postalcode').value)
    if (this.userForm.get('postalcode')?.value) {
      if (
        this.provincialZipcodes.indexOf(
          this.userForm.get('postalcode')?.value[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.userForm.get('postalcode')?.markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
      }

      if (this.userForm.get('postalcode')?.value.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
    // alert(this.postalvalue)
  }

  // provincelist12345(event:any){
  //   alert('121212');
  // }



  public checkparentalhealthinsuarnce(value: any) {
    this.logger.log('value >' + value.target.value);
    if (value.target.value == 'false') {
      this.parentalhelathinsuranecheck = false;
    } else {
      this.parentalhelathinsuranecheck = true;
    }
  }

  public avisordisclosure() {
    ///need to check
    if (this.Shared.getlangdiscloure()) {
      if (sessionStorage.getItem('lanToken') == 'en') {
        this.disclosureAgreement = this.disclosureAgreement_dynamicData;
      } else {
        this.disclosureAgreement = this.disclosureAgreement_dynamicData;
      }
    } else {
    }
    // const model=new Modal(this.advisoranddisclousreModal.nativeElement);
    // model.show();
  }

  public childdob(value: any) {
    let dob = new Date(value.target.value);
    var res = diff_years(dob);

    if (res > 18) {
      this.childrenenrollement = true;
    } else {
      this.childrenenrollement = false;
    }
  }

  public childdsiablility(value: any) {
    // this.childendisability = value.target.checked;
  }

  public dependentchildspecialinfo() {
    // jQuery("#dependentchildspecialinfo-modal").modal("show");
  }
  public showpadaggrement() {
    return false;
    this.showSignAndAgreeOrAgree = false;
    this.PADpafaggrementModalShow();
    this.generatePADaggrement = '';
    //     if(sessionStorage.getItem("fileurl") && sessionStorage.getItem("filename") && sessionStorage.getItem("signature")){
    // this.showmodelsign()
    //     }
    //     else{

    let Data = JSON.parse(sessionStorage?.getItem('Data') || '');
    this.agreestatus = false;
    this.signaturestatus = true;
    // if(this.bankdetailsverify == true){

    //   this.bankdetailsverify =true
    // }

    // this.Shared.getMessage()
    if (this.Shared.getMessage()) {
      this.isFileUploaded = false;
    } else {
      this.isFileUploaded = true;
    }

    // alert(this.bankdetailsverify)
    this.logger.log(
      'homeAddressSameasBillingAddress ' +
      this.enrollmentForm.get('homeAddressSameasBillingAddress')?.valid
    );
    if (this.enrollmentForm.get('homeAddressSameasBillingAddress')?.valid) {
      let addressobject = {
        address1:
          this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.value ||
          Data.street_address_line1 ||
          sessionStorage.getItem('addressline1') ||
          '',
        address2:
          this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')
            ?.value ||
          Data.street_address_line2 ||
          '',
        apt:
          this.enrollmentForm.get('enrollmentSummaryApartSuite')?.value ||
          Data.apt ||
          '',
        city:
          this.enrollmentForm.get('enrollmentSummaryCity')?.value ||
          Data.city ||
          sessionStorage.getItem('billingaddresscity') ||
          '',
        province:
          this.enrollmentForm.get('enrollmentSummaryProvince')?.value ||
          Data.province ||
          this.bankPayForm.get('enrollmentSummaryProvince')?.value ||
          '',
        postalCode:
          this.enrollmentForm.get('enrollmentSummaryPostalCode')?.value ||
          Data.postal_code ||
          sessionStorage.getItem('enrollmentSummaryPostalCode') ||
          '',
        phone: Data.phone_number,
        email: Data.email,
      };
      this.logger.log(
        'addressobject: ' + JSON.stringify('addressobject: ' + addressobject)
      );

      let bankAddress = this.bankverifyDetails.address;
      let bankAdressArr = bankAddress.split(',');
      let bankCity = bankAdressArr[bankAdressArr.length - 2].replace(' ', '');
      let provincePostal = bankAdressArr[bankAdressArr.length - 1];
      let provincePostalArr = provincePostal.split(' ');
      let bankProvince = provincePostalArr[provincePostalArr.length - 3];
      let bankPostalCode =
        provincePostalArr[provincePostalArr.length - 2] +
        ' ' +
        provincePostalArr[provincePostalArr.length - 1];

      let bankobject = {
        name: this.bankverifyDetails.bank.name,
        address: this.bankverifyDetails.bank.address.split(',')[0],
        city: bankAdressArr[bankAdressArr.length - 2].replace(' ', ''),
        province: provincePostalArr[provincePostalArr.length - 3],
        postalCode:
          provincePostalArr[provincePostalArr.length - 2] +
          ' ' +
          provincePostalArr[provincePostalArr.length - 1],
      };
      this.logger.log('bankobject: ' + bankobject);

      let inputData1 = {
        bankCode: this.bankPayForm.get('enrollmentSummaryBankNumber')?.value,
        branchCode: this.bankPayForm.get('enrollmentSummaryTransitNumber')
          ?.value,
        accountNumber: this.bankPayForm.get('enrollmentSummaryAccontNumber')
          ?.value,
      };
      this.logger.log('inputData1: ' + inputData1);

      var fileExtension = '.' + this.bankfile.name.split('.').pop();

      var encBank = btoa(JSON.stringify(inputData1));
      var formData: any = new FormData();
      formData.append('firstName', Data.firstName);
      formData.append('lastName', Data.lastName);
      formData.append('address', JSON.stringify(addressobject));
      formData.append('bank', JSON.stringify(bankobject));
      formData.append(
        'files',
        this.bankfile,
        'void_cheque_' + Date.now() + fileExtension.toLowerCase()
      );
      // formData.append("files", this.bankfile.name,"void.pdf");
      formData.append('session', encBank) || '';
      formData.append('timestamp', new Date().getTime());

      // let padAggrement: string = `${environment.app.grp}api/students/generatePAD`;
      let padAggrement: string = '';

      //this.studentService.padaddgrementdetails(formData).
      this.http.post(padAggrement, formData, {}).subscribe((result: any) => {
        if (result.status == '200') {
          this.generatePADaggrement = result.data.url;
          this.logger.log('generatePADaggrement: ' + this.generatePADaggrement);
          this.generatePADaggrement =
            'https://testapi.groupbenefitz.aitestpro.com/app/server/PAD_Agreement_l_1700036759458.pdf';
          // jQuery("#PADpafaggrement-modal").modal("show");
          sessionStorage.setItem('fileurl', result.data.url);
          sessionStorage.setItem('filename', result.data.filename);
        } else {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: result.message ? result.message : result.error,
            width: '30%',
            showCancelButton: false,
            confirmButtonText: 'Ok',
          }).then((result) => {
            if (result.value) {
            } else {
              // this.router.navigate(['pages/signup-form']);
            }
          });
        }
      });
    } else {
      this.bankPayForm.markAsTouched();
      this.bankPayForm.get('enrollmentSummaryBankNumber')?.markAsTouched();
      this.bankPayForm.get('enrollmentSummaryTransitNumber')?.markAsTouched();
      this.bankPayForm.get('enrollmentSummaryAccontNumber')?.markAsTouched();
      this.bankPayForm.get('enrollmentSummaryvoidCheckUpload')?.markAsTouched();
      // this.bankPayForm.get("checkbankdetails").markAsTouched();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.markAsTouched();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddress')
        ?.markAsTouched();
      this.enrollmentForm.get('enrollmentSummaryCity')?.markAsTouched();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.markAsTouched();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.markAsTouched();

      // if (this.signaturecheck == true) {
      //   this.signaturemessage = true;
      // }
    }
  }

  dependentWithSpecialNeedsShow() {
    $('#dependentWithSpecialNeeds').show();
  }
  PADpafaggrementModalShow() {
    //see that using ViewChildren you use nativeElement
    //const modal = new Modal(this.PADpafaggrementModalpopup.nativeElement);
    //modal.show();
  }

  PADpafaggrementModalShowSign() {
    //see that using ViewChildren you use nativeElement
    //const modal = new Modal(this.PADpafaggrementModalpopupSign.nativeElement);
    //modal.show();
  }
  PADpafaggrementModalClose() {
    //see that using ViewChildren you use nativeElement
    this.logger.log('PADpafaggrementModalClose working this function');
    //const modal = new Modal(this.PADpafaggrementModalpopup.nativeElement);
    // modal.hide();

    // const modalElement = this.PADpafaggrementModalpopup.nativeElement;
    // modalElement.parentNode.removeChild(modalElement);
  }
  signaturePadagreementModalShow() {
    //see that using ViewChildren you use nativeElement
    this.clearSignature();
    this.padAgreementClearSignature();
    //const modal = new Modal(this.signaturePadagreementModalPopup.nativeElement);
    //modal.show();
  }
  padAgreementClearSignature() {
    this.padAggsignaturePadCC.clear();
    this.padAgreementSignaturePadClear = false;

    this.padAgreementSignaturemessagecc = true;
  }

  startSigning(event: any) {
    if (event.target.touched) {
      this.logger.log('sign touched');
      this.signaturemessagecc = false;
    } else {
      this.logger.log('sign not toched');
    }
    this.signaturePadClear = true;
    this.signaturemessagecc = false;

    const base64Data = this.signaturePadCC.toDataURL();
    this.signatureImgcc = base64Data;
    sessionStorage.setItem('signatureCC', this.signatureImgcc);
  }

  postSecondaryShow() {
    $('#postSecondaryStudent').show();
  }

  public padLoaded(event: any) { }
  public voidcheckupload(event: any) {
    var fileExtension = '.' + event.target.files[0].name.split('.').pop();

    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension

    // "void_cheque_"+Date.now()+fileExt
    //this.logger.log(event)
    this.isFileUploaded = true;
    this.imagedisplay = null;
    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.bankfile = event.target.files[0];
    // this.bankfile.name = (this.bankfile.name,"void_cheque_"+Date.now()+fileExtension)
    // alert(fileExtension.toLowerCase())
    this.Shared.setMessage(this.bankfile);
    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.bankfile.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);
      if (this.bankfile.size <= maxFileSize) {
        //300KB

        error = false;
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang.File_size_is_too_large_maximum_file_size_is_300kb;
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }

    if (error) {
      Swal.fire({
        title: this.lang.Error ?? 'Error',
        html: message,
        width: '50%',
        showCancelButton: false,
        confirmButtonText: 'Ok',
      }).then((result) => {
        if (result.value) {
          this.bankPayForm.get('enrollmentSummaryvoidCheckUpload')?.reset();
          this.isFileUploaded = true;
        } else {
        }
      });
    } else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      if (event.target.files[0].type == 'application/pdf') {
        // alert("1")
        this.pdfview = true;
        this.normalview = false;
      } else {
        this.pdfview = false;
        this.normalview = true;
      }

      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.logger.log('imgedisplay :', this.imagedisplay);
      };

      // let id = parseInt(sessionStorage.getItem("normalcustomerid"));
    }

    // sessionStorage.setItem("files", event.target.files[0]);
    // localStorage.setItem("files", JSON.stringify(event.target.files[0]));

    // sessionStorage.setItem("voidCheque",this.bankfile)
  }

  public spousehealthcard(event: any) {
    // alert("spousehealthcard")
    if (event.target.value == 'true') {
      this.spousehealthcardinfo = true;
      this.userForm.get('Spousenameofthecarrier')?.reset();
      this.userForm.get('Spousenameofthecarrier')?.clearValidators();
      this.userForm
        .get('Spousenameofthecarrier')
        ?.setValidators(
          Validators.compose([
            Validators.required,
          ])
        );

      this.userForm.get('spousecob')?.reset();
      this.userForm.get('spousecob')?.clearValidators();
      this.userForm.get('spousecob')?.setValidators([Validators.required]);
    } else {
      this.spousehealthcardinfo = false;

      this.userForm.get('Spousenameofthecarrier')?.reset();
      this.userForm.get('Spousenameofthecarrier')?.clearValidators();
      this.userForm.get('Spousenameofthecarrier')?.updateValueAndValidity();

      this.userForm.get('spousecob')?.reset();
      this.userForm.get('spousecob')?.clearValidators();
      this.userForm.get('spousecob')?.updateValueAndValidity();
    }
  }
  public childAddFun() {
    this.childInfoModalAddAndUpdateButton = this.lang.Add;
    this.dependentchildInsurenceval = false;
    this.childFormGroup
      .get('childInfoFirstName')
      ?.setValidators(
        Validators.compose([
          Validators.required,
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
          Validators.minLength(1),
        ])
      );
    this.childFormGroup
      .get('childInfoLastName')
      ?.setValidators(
        Validators.compose([
          Validators.required,
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
          Validators.minLength(1),
        ])
      );
    this.childFormGroup.get("childInfoDOB").setValidators(Validators.compose([Validators.required, this.childrenminimumAgeValidator]));


    // this.childFormGroup.get('childInfoGender')?.clearValidators();

    this.childFormGroup.get('DependentchildInsurence')?.clearValidators();
    this.childFormGroup
      .get('DependentchildInsurence')
      ?.setValidators(Validators.required);

    // const model=new Modal(this.childInfoModal.nativeElement);
    // model.show();
    $('#childInfoModal').show();
  }

  advisourediscloserLoaded(event: any) {
    this.pdfvisibleadvisouredisclosure = false;
  }

  public termandconditions() {
    this.logger.log('termscondition***********************');
    if (this.Shared.getlangterms()) {
      if (sessionStorage.getItem('lanToken') == 'en') {
        this.term_and_conditions = this.brokerTermsConditions;
      } else {
        this.term_and_conditions = this.brokerTermsConditions;
      }
      this.logger.log('url print: ' + this.term_and_conditions);
    } else {
    }
    // document.getElementById('termsAndConditionsModal')?.show();
    // const model=new Modal(this.termsAndConditionsModal.nativeElement);
    // model.show();
  }

  changeTextToUppercase(field: any) {
    this.logger.log('studentId field: ' + field);
    this.userForm
      .get(field)
      ?.setValue(this.userForm.controls[field].value.toUpperCase());
  }

  changeTextToUppercasePostalCode(field: any, event: any) {
    this.userForm
      .get(field)
      ?.setValue(this.userForm.controls[field].value.toUpperCase());

    this.postalvalue = event.target.value;
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
    } else {
      this.invalidpostalcodeprivince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  changeTextToUppercaseenrollmentPostalCode(field: any, event: any) {
    this.enrollmentForm
      .get(field)
      ?.setValue(this.enrollmentForm.controls[field].value.toUpperCase());
    this.postalvalue = event.target.value;
    this.logger.log('postalvalue12212: ' + this.postalvalue);
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidenrollmentpostalcodeprovince = true;
    } else {
      this.invalidenrollmentpostalcodeprovince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidenrollmentpostalcodeprovince = false;
    }
  }


  nameconvert(str) {
    // this.logger.log(str)
    if (str != null) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }

  }
  namecovertspouse(str) {
    if (str != null) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }
  }
  namecovertchild(str) {
    if (str != null) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }
  }
  public personalInfoSubmit() {
    $('#button_1').prop('disabled', true);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;

    this.memberDetails = {
      ...this.memberDetails,
      firstName: this.firstName + " " + this.lastName,
      username: this.primaryEmail,
      primaryPhone: this.primaryPhone,
      status: 'Draft',
      registrationDate: formattedDate
    }
    // console.log('this.memberDetails',this.memberDetails)
    // console.log('this.members',this.members)

    // console.log(this.userForm.get('havingspouse')?.value)
    let controls = this.userForm.controls
    this.userFormSubmitted = true
    // this.logger.log(controls)
    // this.logger.log(this.userForm.value.Dependentchildren, this.childInfoAddDataArray.length)
    let invalid = [];

    this.logger.log(invalid)
    if (this.userForm.invalid) {
      $('#button_1').prop('disabled', false);
      this.userForm.markAllAsTouched()
      const controls: any = this.userForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);

        }

      }

    }
    console.log(invalid)
 


    this.logger.log(
      'userForm validations1233 ' + JSON.stringify(this.userForm.value)
    );
    console.log('emtpy')
    // this.logger.log("userForm validations " + JSON.stringify(this.userForm));

    // this.userFormControl
    // if(this.userForm.valid){
    // this.logger.log(this.userForm);

    let userFormDetails = this.userForm.value;
    let childInfo = this.childInfoAddDataArray;

    let childInfoArray = [];

    for (let childData of childInfo) {
      let childObject: any = {
        first_name: childData.childInfoFirstName,
        last_name: childData.childInfoLastName,
        firstName: childData.childInfoFirstName,
        lastName: childData.childInfoLastName,
        gender: childData.childInfoGender || "",
        date_of_birth: moment(childData.childInfoDOB).format('YYYY-MM-DD'),
        dob: moment(childData.childInfoDOB).format('YYYY-MM-DD'),
        is_child_having_healthcard:
          childData.DependentchildInsurence == 'true' ? true : false,
        child_carrier_name: childData.childInfoCarrierName,
        enrolledInUniversity:
          childData.childPostGraduate == 'true' ? true : false,
        isDisabled: childData.childdisablility == 'true' ? true : false,
        graduationDay: childData.childPostGraduate == 'true' ? moment(childData.childInfoGraduationday).format('YYYY-MM-DD') : '',
      };
      childInfoArray.push(childObject);
    }

    this.logger.log(
      'userFormDetails.havingspouse: ' + userFormDetails.havingspouse
    );
    let spouseInfo = {};
    if (userFormDetails.havingspouse) {
      spouseInfo = {
        first_name: userFormDetails.spousefirstname,
        last_name: userFormDetails.spouselastname,
        firstName: userFormDetails.spousefirstname,
        lastName: userFormDetails.spouselastname,
        // email:userFormDetails.spouseemail || "",
        email: '',
        date_of_birth: moment(userFormDetails.spousedateofbirth).format(
          'YYYY-MM-DD'
        ),
        dob: moment(userFormDetails.spousedateofbirth).format('YYYY-MM-DD'),
        gender: userFormDetails.spousegender || "",
        is_spouse_having_healthcard:
          userFormDetails.havingspouse == 'true' ? true : false,
        spouse_carrier_name: userFormDetails.Spousenameofthecarrier,
        cobCoverage: userFormDetails.spousecob,
      };
    } else {
      spouseInfo = {};
    }

    let statesData = this.configprovinceres.filter(
      (item: { shortName: any }) => {
        return item.shortName === userFormDetails.province;
      }
    );
    let statesId: any;
    let statesName: any;
    let fusebillStateId: any
    if (statesData.length > 0) {
      statesId = statesData[0].id;
      fusebillStateId = parseInt(statesData[0].fusebillId),
        statesName = statesData[0].name;
    } else {
      statesId = '';
      fusebillStateId = '';
      statesName = '';
    }

    this.logger.log('state id: ' + statesData);
    this.logger.log('state id: ' + JSON.stringify(statesData)); //STUDENT

    let phrDetails = {
      "dateOfArrival": this.datePipe.transform(userFormDetails.dateOfArrival, "yyyy-MM-dd") || "",
      "countryOfOrigin": userFormDetails.countryOrigin || "",
      "isLandedImmigrant": Boolean(userFormDetails.isEmployeeImigrant) || "",
      "coverageRequired": Boolean(userFormDetails.coverageRequiredOfEmployee) || "",
      "applyingForLandingStatus": userFormDetails.applylandedstaus ? Boolean(userFormDetails.applylandedstaus) : false,
      ...(this.showlandeddependentDetails == true ? {
        "dependentDetails": {
          "coverageRequired": Boolean(userFormDetails.coverageRequiredOfDependents) || "",
          "dateOfArrival": userFormDetails.coverageRequiredOfDependents == "true" ? this.datePipe.transform(userFormDetails.dependentdateOfArrival, "yyyy-MM-dd") : '',
          "countryOfOrigin": userFormDetails.coverageRequiredOfDependents == "true" ? userFormDetails.dependentcountryOrigin : '',
          "isLandedImmigrant": userFormDetails.coverageRequiredOfDependents == "true" ? Boolean(userFormDetails.dependentLandedImigrant) : false,
          "applyingForLandingStatus": userFormDetails.dependentMorethan3years ? Boolean(userFormDetails.dependentMorethan3years) : false,
          "stayFor3Months": userFormDetails.coverageRequiredOfDependents == "true" ? Boolean(userFormDetails.dependentMorethan3years) : false
        }
      } : {})
    }

    let personalInfoData = {
      isStudent: this.isStudent, //userFormDetails.memberType == 'STUDENT' ? true : false,
      brokerId: parseInt(userFormDetails.brokername),
      fusebillCustomerId: this.userForm.get('fusbillId').value || null,
      recaptchaCheck: false,
      g_recaptcha_response: 'test',
      planEnrollmentDate: this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'), //userFormDetails.planEnrollmentDate,
      enrollmentDate: this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'), //userFormDetails.planEnrollmentDate,
      EnrollmentDate: this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'), //userFormDetails.planEnrollmentDate,

      first_name: userFormDetails.givenname,
      firstName: userFormDetails.givenname,
      last_name: userFormDetails.lastname,
      lastName: userFormDetails.lastname,
      email: userFormDetails.email,
      phone_number: userFormDetails.phonenumber,
      street_address_line1: userFormDetails.streetaddress,
      street_address_line2:
        userFormDetails.streetaddressline2 == undefined
          ? ''
          : userFormDetails.streetaddressline2,
      city: userFormDetails.city,
      province: userFormDetails.province,
      province_id: statesId,
      country: 'Canada',
      state: statesName,
      country_id: 1,
      state_id: statesId,
      countryId: 1,
      stateId: statesId,
      fusebillCountryId: 124,
      fusebillStateId: fusebillStateId,
      postal_code: userFormDetails.postalcode,
      date_of_birth: moment(userFormDetails.dateofbirth).format('YYYY-MM-DD'),
      // date_of_hiring : moment(userFormDetails.dateofhire).format('YYYY-MM-DD'),
      dob: moment(userFormDetails.dateofbirth).format('YYYY-MM-DD'),
      gender: userFormDetails.gender || "",
      universityName: 'AUSU',
      enrolmentProgramName: '',
      date_of_hiring: this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'),//userFormDetails.planEnrollmentDate,
      working_20hours: true,
      weeklyHours: 0,
      hours_per_week: 40, //userFormDetails.hoursperweek==undefiend?''userFormDetails.hoursperweek:
      foreignStudent: userFormDetails.foreignStudent == 'true' ? true : false,
      isUHIP: userFormDetails.uhipprovincialhealth == 'true' ? true : false,
      coveredParentalHealthInsurance:
        userFormDetails.parentalinsurance == 'true' ? true : false,
      provincial_health_coverage:
        userFormDetails.provincialhealth == 'true' ? true : false,
      work_visa: '',
      having_spouse: userFormDetails.havingspouse == 'true' ? true : false,
      spouse_details: userFormDetails.havingspouse == 'false' ? {} : spouseInfo,
      having_dependent_children:
        userFormDetails.Dependentchildren == 'true' ? true : false,
      no_of_children:
        userFormDetails.Dependentchildren == 'true'
          ? this.noOfChildrenChangedValue
          : 0,
      children_details: childInfoArray.length > 0 ? childInfoArray : '',
      signature: 'digiSign',
      fusebillCustomer: true,
      formId: parseInt(userFormDetails.formrname), //this.formid,
      termsandconditions: '', //userFormDetails.termsandconditions,
      disclouseradvisor: true,

      currency: 'CAD',
      currencySymbol: '$',
      apt:
        userFormDetails.apt_suite == undefined ? '' : userFormDetails.apt_suite,
      studentId: userFormDetails.studentId,
      beneficiaries_details: [],
      employeeKey: '',
      employeeGeneric: true,
      isCorporate: this.FormbrokerType == 'CORPORATE' ? true : false,

    };

    if (this.showExtrafeilds == true) {
      personalInfoData['phrDetails'] = phrDetails
    }
    if (this.waddellForm) {
      personalInfoData['waddell'] = true;
    }
    else {
      personalInfoData['waddell'] = false;
    }


    if (this.isCorporate) {
      personalInfoData["workingProvince"] = userFormDetails.workingProvince,
        personalInfoData["working_province_id"]= this.working_provincelistid

    }



    this.logger.log('personalInfoData: ' + JSON.stringify(personalInfoData));

    this.applicantfirstname = this.nameconvert(userFormDetails.givenname);
    //API calling https://testapi.groupbenefitz.aitestpro.com/api/students/validation
    let dependent_info = true;
    if (this.userForm.get('Dependentchildren')?.value === 'true') {
      if (this.childTableRowsLength > 0) dependent_info = true;
      else dependent_info = false;
    } else {
      dependent_info = true;
    }
    let workinghours = true;
    if (this.isStudent || this.waddellForm) {
      workinghours = true;
    } else {
      workinghours = JSON.parse(this.userForm.get('workinghours').value);
    }

    this.logger.log(this.userForm.valid, workinghours, this.invalidpostalcodeprivince, this.checkhealthcardstatus, dependent_info)
    if (
      this.userForm.valid &&
      !this.invalidpostalcodeprivince && !this.checkhealthcardstatus &&
      dependent_info && workinghours
    ) {
      //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/customer/plans
      // let validationdata:any =''
      let validationdata: any = `${environment.apiUrl}/api/ap/customer/v3/plans`;

      // if(this.customerPlansInActive == true){
      //   validationdata = `${environment.apiUrl}/api/ap/v3/member/registration`;

      // }else{
      //   validationdata = `${environment.apiUrl}/api/ap/customer/v3/plans`;

      // }


      var accessToken = sessionStorage.getItem('accessToken');
      //this.studentService.validation(personalInfoData)

      this.http
        .post(validationdata, personalInfoData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (result: any) => {
            this.logger.log('json result: ' + JSON.stringify(result));
            $('#button_1').prop('disabled', false);
            if (result.status == '200') {
              this.allFormData = {}
              this.formData = {}
              sessionStorage.setItem('plansummaryLife', '[]');
              sessionStorage.setItem('planssummarymainLife', '[]');
              sessionStorage.setItem('plansummary', '[]');
              sessionStorage.setItem('plansummarymain', '[]');
              sessionStorage.setItem('selectedPlans', '');
              sessionStorage.setItem('plansummaryopt', '[]');
              sessionStorage.setItem('studentsPlansArray', '[]');
              sessionStorage.setItem('allproducts', '[]');
              sessionStorage.setItem('totalAmount', '');
              sessionStorage.setItem('totalAmountUI', '');
              sessionStorage.setItem('planDetailsArray', '[]');
              //   'plansummary',
              //   'selectedPlans',
              //   'plansummarymain',
              //   'plansummaryopt',
              //   'studentsPlansArray',
              //   'allproducts',
              //   'totalAmount',
              //   'totalAmountUI',
              //   'planDetailsArray',
              this.mainarray = []
              this.mainarrayValues = [];
              this.mainarrayFinal = [];
              this.companypaidproductid = []

              if (this.isCorporate == true) {
                sessionStorage.setItem(
                  "corporateStateId",
                  result.data.workingProvince.id
                );
                sessionStorage.setItem(
                  "corporateStateName",
                  result.data.workingProvince.name
                );
                sessionStorage.setItem(
                  "companyStateId",
                  result.data.corporateProvince.id
                );
              }

              this.allFormData = {}
              this.formData = {}

              let countrydetails = sessionStorage.getItem('countrydetails');
              let provincelist = sessionStorage.getItem('provincelist');

              this.specialpackages = result.data.packages;
              this.countrydetails = result.data.countries;
              this.packagesInBlocks = result.data.blocks;

              setTimeout(() => {


                if (this.isCorporate == true) {
                  let companyplans = this.convertpackagesToPlans2(
                    this.packagesInBlocks
                  )[1];
                  let baseplans = this.convertpackagesToPlans2(this.specialpackages)[1];
                  this.calculateBasePlanDeltasforCCplans(
                    this.packagesInBlocks.coveredByCompany,
                    baseplans,
                    companyplans
                  );
                  this.calculateBasePlanCPplans(
                    this.packagesInBlocks.paidByCompany,
                    baseplans,
                    companyplans
                  );

                  this.mainarrayValues = this.cobminedcommonfunction(
                    // this.packagesInBlocks.paidByCompany,
                    this.modifiedBlocksPaidByCompany,
                    this.modifiedBlocksCoveredByCompany,
                    this.packagesInBlocks.paidByEmployee
                  );

                  let allPackages = [];
                  for (let key in this.mainarrayValues) {
                    //this.consoleMessage(key)
                    allPackages.push(this.mainarrayValues[key]);
                  }
                  // this.mainarray = allPackages;





                  let filteredMainArray = allPackages
                    .map((element: any) => {
                      // Map the groups
                      let filteredGroups = element.groups.map((group: any) => {
                        // Map the plans
                        let filteredPlans = group.plans.map((plan: any) => {
                          // Filter the productAddonss


                          let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                            (acc: any, key) => {

                              // Filter the products where display is true
                              let filteredProducts = plan.productAddonss[key].map((product: any) => {
                                // Check if the 'display' key exists and is true
                                if (product.hasOwnProperty('display') && product.display) {
                                  return product; // Keep the object as-is if display is true
                                }
                                const newProduct = {};
                                // console.log("Product replaced with empty object:", product, "New product:", newProduct);
                                return newProduct;
                              });
                              const containsOnlyEmptyObjects = filteredProducts.every(
                                (product: any) => Object.keys(product).length === 0
                              );

                              if (containsOnlyEmptyObjects) {
                                console.log("filteredProducts contains only empty objects.");
                              } else {
                                acc[key] = filteredProducts;
                                console.log("filteredProducts contains non-empty objects.");
                              }
                              // if (filteredProducts.length > 0) {
                              //   acc[key] = filteredProducts;
                              // }
                              return acc;
                            },
                            {}
                          );
                          return {
                            ...plan,
                            productAddonss: filteredProductAddonss,
                          };
                        }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

                        return {
                          ...group,
                          plans: filteredPlans,
                        };
                      }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

                      return {
                        ...element,
                        groups: filteredGroups,
                      };
                    })
                    .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


                  console.log(filteredMainArray)

                  this.mainarrayFinal = filteredMainArray

                  console.log(this.mainarrayFinal)

                  // this code needs to comment for single single in
                  this.mainarrayFinal.forEach((element: any) => {
                    element.groups.forEach((group: any) => {
                      group.plans.forEach((plan: any) => {
                        if (plan.productAddonss) {
                          Object.keys(plan.productAddonss).forEach((key) => {
                            // plan.productAddonss[key].forEach((product) => {
                            const keys = ['planCoverage'];
                            const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                              self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                            );
                            plan.productAddonss[key] = filteredData
                            // });
                          });
                        }
                      });

                    });
                  });

                  this.mainarrayFinal.forEach((element: any) => {
                    element.groups.forEach((group: any) => {
                      if (group.categorization.paidByCompany == 1) {
                        group.plans.forEach((plan: any) => {
                          let pl = { ...plan, ...group.categorization }
                          Object.keys(plan.productAddonss).forEach((key) => {
                            let productLength = plan.productAddonss[key]?.display
                            let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length

                            plan.productAddonss[key].forEach((product: any) => {

                              if (pl.isBundle) {
                                this.companypaidproductid.push(pl);
                              }
                              else {
                                this.companypaidproductid.push(product.planlevel);
                              }


                              const dom: HTMLElement = this.elementRef.nativeElement;

                              const plan: any = dom.querySelector("#plancheck" + product.id);

                              if (plan) {
                                plan.checked = false;
                              }
                              // $("#plancheck" + product.id).prop("checked", false);
                            });
                          });
                        });
                      }

                      setTimeout(() => {
                        if (group.categorization.coveredByCompany == 1) {
                          group.plans.forEach((plan: any) => {
                            Object.keys(plan.productAddonss).forEach((key) => {
                              plan.productAddonss[key].forEach((product: any) => {
                                // $("#plancheck" + product.id).prop("checked", false);
                                const dom: HTMLElement = this.elementRef.nativeElement;

                                const plan: any = dom.querySelector("#plancheck" + product.id);

                                if (plan) {
                                  plan.checked = false;
                                }
                              });
                            });
                          });
                        }
                        if (group.categorization.paidByEmployee == 1) {
                          group.plans.forEach((plan: any) => {

                            if (plan.productAddonss) {
                              Object.keys(plan.productAddonss).forEach((key) => {
                                plan.productAddonss[key].forEach((product: any) => {
                                  // $("#plancheck" + product.id).prop("checked", false);
                                  const dom: HTMLElement = this.elementRef.nativeElement;

                                  const plan: any = dom.querySelector("#plancheck" + product.id);

                                  if (plan) {
                                    plan.checked = false;
                                  }
                                });
                              });
                            }
                          });
                        }
                      }, 1000);
                    });
                  });

                  this.autoSelectCompanyPaidPlans();
                }

                this.selectedTab = this.customerPlansInActive ? 'tab3' : 'tab2';
                this.planAmount = 0;
                this.tab1Img = true;
                // let removeItems = [
                //   'plansummary',
                //   'selectedPlans',
                //   'plansummarymain',
                //   'plansummaryopt',
                //   'studentsPlansArray',
                //   'allproducts',
                //   'totalAmount',
                //   'totalAmountUI',
                //   'planDetailsArray',
                // ];
                // let sessionStorageKeys = Object.keys(sessionStorage);

                // sessionStorageKeys.forEach((key) => {
                //   if (removeItems.includes(key)) {
                //     sessionStorage.removeItem(key);
                //   }
                // });

                sessionStorage.setItem('Data', JSON.stringify(personalInfoData));
                sessionStorage.setItem('countrydetails', countrydetails ?? '');
                sessionStorage.setItem('provincelist', provincelist ?? '');
                sessionStorage.setItem('stateid', result.data.province.id);
                sessionStorage.setItem(
                  'maritalStatus',
                  result.data.customer.maritalStatus
                );
                sessionStorage.setItem(
                  'planDetailsArray',
                  JSON.stringify(this.specialpackages)
                );
                sessionStorage.setItem(
                  'enrollmentdate',
                  personalInfoData.planEnrollmentDate
                );

              }, 2000);
              // sessionStorage.setItem("completeapplicantinfo", this.completeapplicantinfo);
              this.marital_status = result.data.customer.maritalStatus;
              const elements =
                this.elementRef.nativeElement.getElementsByClassName(
                  'imgdisplay1'
                );
              for (let i = 0; i < elements.length; i++) {
                elements[i].style.display = 'block';
                elements[i].style.display = 'inline';
              }
              // this.applicantSpousename = personalInfoData['spouse_details']['first_name'] || "";
              let childarry: any = [];
              this.childInfoAddDataArray.forEach((element: any) => {
                childarry.push(element.childInfoFirstName);
              });
              this.applicantChildrenname = childarry.toString() || '';
              this.logger.log("userFormDetails", userFormDetails)
              if (
                userFormDetails.havingspouse == 'true' &&
                userFormDetails.Dependentchildren == 'true'
              ) {
                this.completeapplicantinfo =
                  this.lang.Based_on_the_information_provided_you_your_spouse + " "
                  + this.namecovertspouse(userFormDetails.spousefirstname) + " " + this.lang.and_your_dependent_s + " " + this.namecovertchild(this.applicantChildrenname) +
                  " " +
                  this.lang.are_eligible_to_apply_for_the_following_plans;
              }

              // return false;
              else if (userFormDetails.havingspouse == 'true') {
                this.completeapplicantinfo =
                  this.lang.Based_on_the_information_provided_you_your_spouse + " " +
                  this.namecovertspouse(userFormDetails.spousefirstname) +
                  " " +
                  this.lang.are_eligible_to_apply_for_the_following_plans;
              } else if (userFormDetails.Dependentchildren == 'true') {
                this.completeapplicantinfo =
                  this.lang.Based_on_the_information_provided_you_and_your_dependent_s +
                  " " +
                  this.namecovertchild(this.applicantChildrenname) +
                  " " +
                  this.lang.are_eligible_to_apply_for_the_following_plans;
              } else {
                this.completeapplicantinfo = this.lang.Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans;
              }
              this.logger.log('this.completeapplicantinfo', this.completeapplicantinfo);

              this.completeapplicantinfo = this.completeapplicantinfo.replace(
                'you',
                this.applicantfirstname
              );
              this.completeapplicantinfo = this.completeapplicantinfo.replace(/your/g, 'his');

              // if (this.waddellForm) {
              //   setTimeout(() => {
              //     this.paymentpage(3)
              //   }, 100);

              // }

            } else {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: result.message ? result.message : result.error,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.value) {
                } else {
                }
              });
            }
          },
          (error) => {
            this.logger.log(this.lang.Error ?? 'Error', error);
            if (
              error.error.errorCode == 'GBS_CV_0009_A' ||
              error.error.errorCode == 'GBS_CV_0010'
            ) {
              //"GBS_CV_0010"
              this.logger.log(this.lang.Error ?? 'Error', error); //409
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                // html: error.error.message ? error.error.message : error.error.error,
                html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error
                  }</div>`,
                // icon: "warning",
                // width: "30%",
                showCancelButton: true,
                confirmButtonText: 'Visit Portal',

                // text:'codes',
              }).then((result) => {
                if (result.value) {
                  let link =
                    error.error.customerportalLink != undefined ||
                      error.error.customerportalLink != null ||
                      error.error.customerportalLink != ''
                      ? error.error.customerportalLink
                      : error.error.data.customerportalLink;

                  window.open(link);
                  // let url=this.location['origin']
                  // this.router.navigate([url+'/portal/']);
                  // this.router.navigate(['/portal/']);
                  if (
                    error.error.message.includes('incomplete') ||
                    error.error.message.includes(
                      'The email address already exists'
                    )
                  ) {
                    let formLink = sessionStorage.getItem('formlink');
                    // sessionStorage.clear();

                    // this.router.navigate([formLink]);
                    // window.location.reload();
                  }
                } else {
                }
              });
            } else {
              this.logger.log(this.lang.Error ?? 'Error', error); //409
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                // html: error.error.message ? error.error.message : error.error.error,
                html: `<div class="custom-content">${error.error.error.message
                  ? error.error.error.message
                  : error.error.error.error
                  }</div>`,
                // icon: "warning",
                width: '30%',
                showCancelButton: false,
                // confirmButtonText: "Visit Portal",
              }).then((result) => {
                if (result.value) {
                  // let link=error.error.customerportalLink!=undefined||
                  // error.error.customerportalLink!=null||error.error.customerportalLink!=""?
                  // error.error.customerportalLink:error.error.data.customerportalLink;

                  // window.open(link);
                  // let url=this.location['origin']
                  // this.router.navigate([url+'/portal/']);
                  // this.router.navigate(['/portal/']);
                  if (
                    error.error.message.includes('incomplete') ||
                    error.error.message.includes(
                      'The email address already exists'
                    )
                  ) {
                    let formLink = sessionStorage.getItem('formlink');
                    // sessionStorage.clear();

                    // this.router.navigate([formLink]);
                    // window.location.reload();
                  }
                } else {
                }
              });
            }
          }
        );
    } else {
      this.scrollToFirstInvalidControl1();
      const invalid = [];
      const controls = this.userForm.controls;

      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      this.userForm.markAllAsTouched()
      this.logger.log(invalid)

    }
  }

  // public autoSelectCompanyPaidPlans() {

  //   console.log(this.companypaidproductid)
  //   var result = this.companypaidproductid.reduce((unique: any, o: any) => {
  //     if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
  //       unique.push(o);
  //     }
  //     return unique;
  //   }, []);
  //   console.log(result);

  //   // this.companypaidproductid.forEach((element, index) => {

  //   this.companypaidproductid.forEach((element: any, index: any) => {

  //     if (element.planCoverageUI) {
  //       setTimeout(() => {
  //         const dom: HTMLElement = this.elementRef.nativeElement;
  //         const plan: any = dom.querySelector("#plancheck" + element.planId + ".coverage" + element.planCoverage);

  //         console.log(plan)

  //         this.renderer.selectRootElement("#plancheck" + element.planId + ".coverage" + element.planCoverage).click()
  //         //Rakesh Remove


  //         // $("#plancheck" + element.id).click();




  //       }, 100);
  //     }
  //     else {
  //       setTimeout(() => {
  //         const dom: HTMLElement = this.elementRef.nativeElement;
  //         const plan: any = dom.querySelector("#plancheck" + element.id);

  //         console.log(plan)

  //         this.renderer.selectRootElement("#plancheck" + element.id).click()
  //         //Rakesh Remove


  //         // $("#plancheck" + element.id).click();




  //       }, 100);
  //     }


  //   });


  //   setTimeout(() => {
  //     let selectplans =
  //       JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

  //     //this.consoleMessage(selectplans)

  //     console.log(selectplans)
  //     selectplans.forEach((element: any) => {
  //       if (element.paidByCompany == 1) {
  //         element.products.forEach((product: any, index: any) => {
  //           const dom: HTMLElement = this.elementRef.nativeElement;
  //           const plan: any = dom.querySelector("#plancheck" + product.id);

  //           if (plan) {
  //             plan.disabled = true;
  //           }
  //         })

  //       }
  //     });
  //   }, 2000);
  //   this.mainarray.forEach((element: any) => {
  //     element.groups.forEach((group: any) => {
  //       group.plans.forEach((plan: any) => {
  //         Object.keys(plan.productAddonss).forEach((key) => {
  //           // plan.productAddonss[key].forEach((product) => {
  //           const keys = ['planCoverage'];
  //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
  //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
  //           );
  //           plan.productAddonss[key] = filteredData
  //           // });
  //         });
  //       });

  //     });
  //   });
  //   //this.consoleMessage(this.mainarray)

  //   this.mainarray.forEach((element: { groups: any[]; }) => {
  //     element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
  //       // //this.consoleMessage(element.groups)
  //       if (element.groups.length == 1) {
  //         // //this.consoleMessage(group)
  //         if (group.categorization.paidByCompany == 1) {
  //           group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
  //             Object.keys(plan.productAddonss).forEach((key) => {
  //               plan.productAddonss[key].forEach((product: { id: any; }) => {
  //                 this.disabledcompanypaidproductid.push({ id: product.id });
  //                 const dom: HTMLElement = this.elementRef.nativeElement;

  //                 const plan: any = dom.querySelector("#plancheck" + product.id);

  //                 if (plan) {
  //                   plan.checked = false;
  //                 }
  //                 // $("#plancheck" + product.id).prop("checked", false);
  //               });
  //             });
  //           });
  //         }
  //       }
  //     });
  //   });


  //   this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       const plan: any = dom.querySelector("#plancheck" + element.id);

  //       // plan.disabled=true
  //     }, 100);
  //   });
  //   // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
  //   //   for (const cpPackage of packagesInBlocks.paidByCompany) {
  //   //     for (const cpGroup of cpPackage.groupsCP) {
  //   //       for (const cpPlan of cpGroup.plans) {

  //   //         for(const product1 in cpPlan.productAddonss){
  //   //           //this.consoleMessage(product1)
  //   //           //this.consoleMessage(cpPlan.productAddonss[product1])
  //   //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

  //   //         }

  //   //       }
  //   //     }
  //   //   }
  //   // }
  //   // this.toastrService.success("Company paid plans are all selected", "");
  // }
  public autoSelectCompanyPaidPlans() {

    // console.log(this.companypaidproductid)
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);

    // this.companypaidproductid.forEach((element, index) => {

    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()



        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    targetElement.click();
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }

          // Object.keys(element.productAddonss).forEach((key) => {
          //   element.productAddonss[key].forEach((product: any) => {
          //    //console.log(product)
          //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
          //    //console.log(coverage)
          //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
          //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
          //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

          //     if(coverage!="DIRECT"){
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

          //     }
          //     else{
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
          //     }

          //   })
          // })

        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }



      }, 100);

    });


    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

      //this.consoleMessage(selectplans)

      //console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    // this.mainarrayFinal.forEach((element: any) => {
    //   element.groups.forEach((group: any) => {
    //     group.plans.forEach((plan: any) => {
    //       if (plan.productAddonss) {
    //         Object.keys(plan.productAddonss).forEach((key) => {
    //           // plan.productAddonss[key].forEach((product) => {
    //           const keys = ['planCoverage'];
    //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
    //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
    //           );
    //           plan.productAddonss[key] = filteredData
    //           // });
    //         });
    //       }
    //     });

    //   });
    // });
    //this.consoleMessage(this.mainarray)

    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

        // plan.disabled=true
      }, 100);
    });
    // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
    //   for (const cpPackage of packagesInBlocks.paidByCompany) {
    //     for (const cpGroup of cpPackage.groupsCP) {
    //       for (const cpPlan of cpGroup.plans) {

    //         for(const product1 in cpPlan.productAddonss){
    //           //this.consoleMessage(product1)
    //           //this.consoleMessage(cpPlan.productAddonss[product1])
    //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

    //         }

    //       }
    //     }
    //   }
    // }
    // this.toastrService.success("Company paid plans are all selected", "");

  }
  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    //this.consoleMessage("pacakges");
    //all_plans
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
            //this.consoleMessage("else");
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }

  // calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

  //   //console.log(ccplanspackages)
  //   let modifiedCCplanPackages = [];
  //   //console.log(baseplans)
  //   for (let i = 0; i < ccplanspackages?.length; i++) {
  //     let modifiedCCPackage = ccplanspackages[i];
  //     //this.consoleMessage(ccplanspackages[i].name)
  //     //this.consoleMessage(ccplanspackages[i].id)
  //     let CCplansgroups = ccplanspackages[i].groupsCC;

  //     modifiedCCPackage.groupsCC = [];
  //     for (let CCplangroup of CCplansgroups) {
  //       let modifiedCCgroup = CCplangroup;

  //       let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

  //       let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

  //       // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

  //       if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
  //         selectedCoverage = "DIRECT"
  //       }
  //       if (selectedCoverage != "DIRECT") {
  //         selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
  //       }

  //       //console.log(selectedCoverage)
  //       let CCplans = CCplangroup.plans;
  //       //console.log(CCplangroup)

  //       modifiedCCgroup.plans = [];
  //       for (let CCplan of CCplans) {
  //         let modifiedCCplan = CCplan;
  //         //this.consoleMessage(CCplan.id);
  //         //this.consoleMessage(CCplan.isBundle);
  //         //this.consoleMessage(CCplan.name);

  //         CCplan.planLevel_parentId = CCplangroup.parentId;

  //         let payroll = true;
  //         let EmployeeChoice = 0;

  //         if (
  //           this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
  //         ) {
  //           if (EmployeeChoice == 2) {
  //             payroll = false;
  //           }
  //         } else {
  //           if (
  //             this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
  //               CCplan.planLevel
  //             )
  //           ) {
  //             if (EmployeeChoice == 2) {
  //               payroll = false;
  //             }
  //           }
  //         }
  //         let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
  //         //console.log(CCplan)
  //         //console.log(CCplan.productAddonss[CCplan.name])

  //         if (CCplan.isBundle) {
  //           //this.consoleMessage("BundlePlan")

  //           //this.consoleMessage(baseplans)
  //           //console.log(baseplans)
  //           var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
  //             //this.consoleMessage(plan)
  //             //cp_plans

  //             //this.consoleMessage(CCplan.packageId,plan.packageId)
  //             //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
  //             //this.consoleMessage(CCplan.planLevel,plan.planLevel)

  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           //this.consoleMessage(filtered_base_plans);

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           let selectedBaseplanProduct: any;
  //           let selectedBaseplanProductsArray: any = [];
  //           let selectedCompanyplanProduct: any;
  //           let selectedCompanyplanProductsArray: any = [];


  //           //console.log("length" + filtered_base_plans.length)
  //           //console.log(filtered_base_plans)
  //           //console.log(filtered_compnay_plans)

  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 1) {
  //             selectedBasePlan = filtered_base_plans[0];
  //             selectedCompnayPlan = filtered_compnay_plans[0];
  //           } else {


  //             var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
  //               return (
  //                 CCplan.id == plan.id
  //               );
  //             });
  //             var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


  //               return (
  //                 CCplan.id == plan.id
  //               );
  //             });
  //             selectedBasePlan = filtered_base_plans2[0];
  //             selectedCompnayPlan = filtered_compnay_plans2[0];
  //           }

  //           //console.log(selectedBasePlan)
  //           //console.log(selectedCompnayPlan)
  //           //console.log("name" + selectedBasePlan?.name)
  //           if (selectedBasePlan) {
  //             // //this.consoleMessage(selectedBasePlan)
  //             // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
  //             selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
  //             let selectedBaseplanProductsArray2 = [];
  //             //  //this.consoleMessage(CCplan.packageId)
  //             if (CCplan.packageId == 5 || CCplan.packageId == 10) {
  //               selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
  //               for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
  //                 selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
  //               }

  //               let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
  //               // //this.consoleMessage(selectedBaseplanProductsArray)

  //               if (remainigProdcuts > 0) {
  //                 for (let i = 0; i < remainigProdcuts; i++) {
  //                   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
  //                 }
  //               }
  //               selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //             else {

  //               // Direct Coverage Method
  //               // setTimeout(() => {
  //               if (selectedCoverage == "DIRECT") {
  //                 selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //                 //console.log(selectedBaseplanProductsArray)
  //               }

  //               // Selective single Coverage Method
  //               if (selectedCoverage == "SINGLE") {
  //                 selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //               }
  //               // Selective Couple Coverage Method

  //               if (selectedCoverage == "COUPLE") {
  //                 selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //               }
  //               //  // Selective Family Coverage Method
  //               if (selectedCoverage == "FAMILY") {
  //                 selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //               }

  //               //console.log(selectedBaseplanProductsArray)
  //               // }, 1000)

  //               // let productCoverageFound = false;
  //               // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

  //               //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
  //               //       productCoverageFound = true
  //               //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
  //               //       break;
  //               //     }


  //               //   }
  //               //   if (!productCoverageFound) {



  //               //     selectedBasePlan = {};
  //               //     selectedBaseplanProduct = {};
  //               //     selectedBaseplanProduct.calculatedTax = {};
  //               //     selectedBaseplanProduct.calculatedTax.price = 0;
  //               //     selectedBaseplanProduct.calculatedTax.tax = 0;
  //               //     selectedBaseplanProduct.calculatedTax.total = 0;
  //               //     selectedBaseplanProduct.name = "NA";
  //               //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
  //               //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



  //               //   }

  //               // }
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //               // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //           }
  //           else {
  //             //console.log("elseStatement")
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";

  //             for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               selectedBaseplanProductsArray.push(selectedBaseplanProduct);
  //             }
  //           }


  //           //console.log(selectedBaseplanProductsArray)
  //           if (selectedCompnayPlan) {
  //             // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
  //             selectedCompanyplanProductsArray =
  //               selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
  //             // //this.consoleMessage(selectedCompanyplanProductsArray)
  //             // //this.consoleMessage(selectedCompnayPlan.name)

  //             let selectedCompanyplanProductsArray2 = [];

  //             if (CCplan.packageId == 5 || CCplan.packageId == 10) {
  //               selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
  //               for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
  //                 selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
  //               }
  //               //this.consoleMessage(selectedCompanyplanProductsArray)

  //               let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
  //               // //this.consoleMessage(selectedBaseplanProductsArray)

  //               if (remainigProdcuts > 0) {
  //                 for (let i = 0; i < remainigProdcuts; i++) {
  //                   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
  //                 }
  //               }
  //               selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
  //               //this.consoleMessage(selectedCompanyplanProductsArray)

  //             }
  //             else {

  //               //console.log(selectedCCplanProductarray)
  //               // let productCoverageFound = false;
  //               // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

  //               //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
  //               //       productCoverageFound = true
  //               //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
  //               //       break;
  //               //     }


  //               //   }
  //               //   if (!productCoverageFound) {


  //               //     selectedCompanyplanProduct = {};
  //               //     selectedCompanyplanProduct.calculatedTax = {};
  //               //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
  //               //     selectedCompanyplanProduct.name = "NA";
  //               //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
  //               //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



  //               //   }

  //               // }
  //               // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

  //               // // setTimeout(() => {
  //               if (selectedCoverage == "DIRECT") {
  //                 selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //                 //console.log(selectedBaseplanProductsArray)
  //               }

  //               // Selective single Coverage Method
  //               if (selectedCoverage == "SINGLE") {
  //                 selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //               }
  //               // Selective Couple Coverage Method

  //               if (selectedCoverage == "COUPLE") {
  //                 selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //               }
  //               //  // Selective Family Coverage Method
  //               if (selectedCoverage == "FAMILY") {
  //                 selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //               }


  //               // // }, 1000)


  //               //console.log(selectedCompanyplanProductsArray)


  //             }


  //           } else {
  //             selectedCompanyplanProduct = {};
  //             selectedCompanyplanProduct.calculatedTax = {};
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
  //             for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               selectedCompanyplanProductsArray.push(
  //                 selectedCompanyplanProduct
  //               );
  //             }
  //             //console.log(selectedCompanyplanProductsArray)
  //             //this.consoleMessage(selectedCompanyplanProductsArray)
  //           }


  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }

  //           modifiedCCplan.products = []



  //           for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //             let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
  //             //console.log(selectedBaseplanProduct)
  //             let selectedCompanyplanProduct =
  //               selectedCompanyplanProductsArray[i];
  //             let selectedCCplanProduct = selectedCCplanProductarray[i];
  //             //console.log(selectedCCplanProduct)
  //             //console.log(selectedCompanyplanProductsArray[i])
  //             let companyTax =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos
  //                 .length > 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos
  //                 .length > 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );


  //             let employeeTax =
  //               selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCCplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             //console.log(deltaplanPrice)


  //             //console.log(selectedBaseplanProduct.calculatedTax.price)

  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               // companyTax = employeeTax
  //               companyTax = 0  ////when there is no base planproduct
  //               // companyTaxPercentage = employeeTaxPercentage
  //               companyTaxPercentage = "0%" //when there is no base planproduct

  //             }
  //             //Delete plan Total Price and Total Combination
  //             if (deltaplanPrice < 0) {
  //               deltaplanPrice = 0
  //               baseplanPrice = adjustWith2DecimalsForUI(
  //                 selectedCCplanProduct.calculatedTax.price
  //               );
  //               baseplanTaxorg = adjustWith2DecimalsForUI(
  //                 selectedCCplanProduct.calculatedTax.tax
  //               );
  //               baseplanTax = adjustWith2DecimalsForUI(
  //                 baseplanPrice * companyTax
  //               );
  //               baseplanTotalorg = adjustWith2DecimalsForUI(
  //                 selectedCCplanProduct.calculatedTax.total
  //               );
  //               baseplanTotal = adjustWith2DecimalsForUI(
  //                 baseplanPrice + baseplanTax
  //               );
  //             }
  //             // let deltaplanTax = adjustWith2DecimalsForUI(
  //             //   deltaplanPrice *
  //             //   (this.deltaCompanyTax ? companyTax : employeeTax)
  //             // );
  //             let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );
  //             let combinedplanPrice = adjustWith2DecimalsForUI(
  //               baseplanPrice + deltaplanPrice
  //             );
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
  //             let planName = `${CCplan.name} (${upgradeText})`;
  //             let compnayShareStatement = `${CCplan.name} Contribution`;
  //             let employeeShareStatement = `${CCplan.name} upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id, //0
  //               planName: selectedBasePlan.name, //NA
  //               planLevelId: selectedBasePlan.planLevel, //0
  //               amount: baseplanPrice, //0
  //               amountUI: `$${baseplanPrice}`, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId,
  //               packageName: selectedBasePlan.packageName,
  //               packageId: selectedBasePlan.packageId,
  //             };





  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               selectedCoverage
  //             };

  //             //this.consoleMessage(obj)

  //             //console.log(obj)
  //             let ccProduct: any = {}
  //             ccProduct.upgradeCalculation = obj;
  //             modifiedCCplan.products.push(ccProduct)
  //             modifiedCCplan.upgradeCalculation = obj;

  //             //console.log(modifiedCCplan)
  //           }

  //         }
  //         else {

  //           var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           //this.consoleMessage(filtered_base_plans)

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           //console.log("length" + filtered_base_plans.length)
  //           //console.log(filtered_base_plans)
  //           //console.log(filtered_compnay_plans)
  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 1) {
  //             selectedBasePlan = filtered_base_plans[0];
  //             selectedCompnayPlan = filtered_compnay_plans[0];
  //           } else {
  //             //this.consoleMessage(filtered_base_plans.length)
  //           }

  //           let selectedbaseplanproduct: any;
  //           let selectedBaseplanProduct: any;

  //           if (selectedBasePlan) {
  //             for (let planname in selectedBasePlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedBasePlan.productAddonss[planname])
  //               let products = selectedBasePlan.productAddonss[planname];
  //               //console.log("length" + products.length)
  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedbaseplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 selectedbaseplanproduct = products[products.length - 1]; //
  //                 /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
  //                 Selecting last product(highest) in this case */
  //                 //this.consoleMessage(products.length)
  //               }
  //             }
  //             //this.consoleMessage(selectedbaseplanproduct)
  //             selectedBaseplanProduct = selectedbaseplanproduct;

  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
  //           } else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";
  //           }

  //           let CCplanProduct;

  //           for (let planname in CCplan.productAddonss) {
  //             let products = CCplan.productAddonss[planname];
  //             //console.log("length" + products.length)

  //             if (products.length == 0) {
  //             } else if (products.length == 1) {
  //               CCplanProduct = products[0];
  //               // selectedCompnayPlan= filtered_compnay_plans[0]
  //             } else {
  //               CCplanProduct = products[products.length - 1]; //
  //               /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
  //               Selecting last product(highest) in this case */
  //               //this.consoleMessage(products.length)
  //             }
  //           }
  //           let selectedCCplanProduct = CCplanProduct;


  //           let selectedcompanyplanproduct: any;
  //           let selectedCompanyplanProduct: any;

  //           if (selectedCompnayPlan) {
  //             for (let planname in selectedCompnayPlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
  //               let products = selectedCompnayPlan.productAddonss[planname];

  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedcompanyplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 selectedcompanyplanproduct = products[products.length - 1]; //
  //                 /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
  //                 Selecting last product(highest) in this case */
  //               }
  //             }
  //             selectedCompanyplanProduct = selectedcompanyplanproduct;

  //             //this.consoleMessage("CompanyTax")
  //             //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
  //             //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
  //           } else {
  //             selectedCompanyplanProduct = {};
  //             selectedCompanyplanProduct.calculatedTax = {};
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
  //           }

  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }
  //           let companyTax =
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //               0
  //               ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRate
  //               : 0;
  //           let companyTaxPercentage =
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //               0
  //               ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRatePercentage
  //               : 0;
  //           let baseplanPrice = adjustWith2DecimalsForUI(
  //             selectedBaseplanProduct.calculatedTax.price
  //           );
  //           let baseplanTaxorg = adjustWith2DecimalsForUI(
  //             selectedBaseplanProduct.calculatedTax.tax
  //           );
  //           let baseplanTax = adjustWith2DecimalsForUI(
  //             baseplanPrice * companyTax
  //           );
  //           let baseplanTotalorg = adjustWith2DecimalsForUI(
  //             selectedBaseplanProduct.calculatedTax.total
  //           );
  //           let baseplanTotal = adjustWith2DecimalsForUI(
  //             baseplanPrice + baseplanTax
  //           );
  //           let employeeTax =
  //             selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //               ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRate
  //               : 0;
  //           let employeeTaxPercentage =
  //             selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //               ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRatePercentage
  //               : 0;

  //           let deltaplanPrice = adjustWith2DecimalsForUI(
  //             selectedCCplanProduct.calculatedTax.price -
  //             selectedBaseplanProduct.calculatedTax.price
  //           );

  //           //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
  //           //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //           //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
  //           if (selectedBaseplanProduct.name == 'NA') {
  //             //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //             companyTax = employeeTax
  //             companyTaxPercentage = employeeTaxPercentage
  //           }
  //           let deltaplanTax = adjustWith2DecimalsForUI(
  //             deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
  //           );
  //           // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

  //           let deltaplanTotal = adjustWith2DecimalsForUI(
  //             deltaplanPrice + deltaplanTax
  //           );

  //           let combinedplanPrice = baseplanPrice + deltaplanPrice;
  //           let combinedplanbasePrice = baseplanPrice;
  //           let combinedplanDeltaprice = deltaplanPrice;
  //           let combinedplanTax = adjustWith2DecimalsForUI(
  //             baseplanTax + deltaplanTax
  //           );
  //           let combinedplanCompanyTax = baseplanTax;
  //           let combinedplanEmployeeTax =
  //             adjustWith2DecimalsForUI(deltaplanTax);
  //           let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //           let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //             ? companyTaxPercentage
  //             : employeeTaxPercentage;
  //           let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
  //           let combinedplanTotal = adjustWith2DecimalsForUI(
  //             baseplanTotal + deltaplanTotal
  //           );

  //           let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
  //           let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
  //           let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
  //           let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
  //           let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //           let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //           let type;

  //           if (payroll) {
  //             type = "Split with payroll deduction";
  //           } else {
  //             type = "Split with direct pay";
  //           }
  //           let basePlanDetails = {
  //             planId: selectedBasePlan.id || 0, //0
  //             planName: selectedBasePlan.name || "NA", //NA
  //             planLevelId: selectedBasePlan.planLevel || 0, //0
  //             amount: baseplanPrice || 0, //0
  //             amountUI: `$${baseplanPrice}` || 0, //0
  //             tax: baseplanTax,
  //             total: baseplanTotal,
  //             taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //             totalUI: `$${baseplanTotal}`,
  //             planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //             planFrequencyID: selectedBasePlan.frqMonthly || "",
  //             planFusebillID: selectedBasePlan.fusebillId || "",
  //             products: [selectedBaseplanProduct],
  //             planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
  //             packageName: selectedBasePlan.packageName || "",
  //             packageId: selectedBasePlan.packageId || 0,
  //           };
  //           let obj = {
  //             companyTax,
  //             companyTaxPercentage,
  //             baseplanPrice,
  //             baseplanTaxorg,
  //             baseplanTax,
  //             baseplanTotalorg,
  //             baseplanTotal,
  //             employeeTax,
  //             employeeTaxPercentage,
  //             deltaplanPrice,
  //             deltaplanTax,
  //             deltaplanTotal,
  //             combinedplanPrice,
  //             combinedplanbasePrice,
  //             combinedplanDeltaprice,
  //             combinedplanTax,
  //             combinedplanCompanyTax,
  //             combinedplanEmployeeTax,
  //             combinedplanCompanyTaxPercentage,
  //             combinedplanemployeeTaxPercentage,
  //             combinedplanTotal,
  //             payroll,
  //             scenario,
  //             planName,
  //             compnayShareStatement,
  //             employeeShareStatement,
  //             planDescription,
  //             planDescription2,
  //             type,
  //             basePlanDetails,
  //             combinedplanemployeeTaxPercentageorg,
  //           };

  //           //this.consoleMessage(obj)
  //           modifiedCCplan.upgradeCalculation = obj;
  //         }
  //         modifiedCCgroup.plans.push(modifiedCCplan);
  //       }
  //       modifiedCCPackage.groupsCC.push(modifiedCCgroup);
  //     }

  //     modifiedCCplanPackages.push(modifiedCCPackage);
  //   }

  //   this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

  //   //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
  // }
  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    //console.log(ccplanspackages)
    let modifiedCCplanPackages = [];
    //console.log(baseplans)
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      //this.consoleMessage(ccplanspackages[i].name)
      //this.consoleMessage(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

        // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        //console.log(selectedCoverage)
        let CCplans = CCplangroup.plans;
        //console.log(CCplangroup)

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;
          //this.consoleMessage(CCplan.id);
          //this.consoleMessage(CCplan.isBundle);
          //this.consoleMessage(CCplan.name);

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {
            //this.consoleMessage("BundlePlan")

            //this.consoleMessage(baseplans)
            //console.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
              //this.consoleMessage(plan)
              //cp_plans

              //this.consoleMessage(CCplan.packageId,plan.packageId)
              //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.consoleMessage(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            //console.log("length" + filtered_base_plans.length)
            //console.log(filtered_base_plans)
            //console.log(filtered_compnay_plans)

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            //console.log(selectedBasePlan)
            //console.log(selectedCompnayPlan)
            //console.log("name" + selectedBasePlan?.name)
            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method
                // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                //console.log(selectedBaseplanProductsArray)
                // }, 1000)

                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {



                //     selectedBasePlan = {};
                //     selectedBaseplanProduct = {};
                //     selectedBaseplanProduct.calculatedTax = {};
                //     selectedBaseplanProduct.calculatedTax.price = 0;
                //     selectedBaseplanProduct.calculatedTax.tax = 0;
                //     selectedBaseplanProduct.calculatedTax.total = 0;
                //     selectedBaseplanProduct.name = "NA";
                //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                //   }

                // }
                // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                //this.consoleMessage(selectedBaseplanProductsArray)
              }
            }
            else {
              //console.log("elseStatement")
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            //console.log(selectedBaseplanProductsArray)
            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                //this.consoleMessage(selectedCompanyplanProductsArray)

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                //this.consoleMessage(selectedCompanyplanProductsArray)

              }
              else {

                //console.log(selectedCCplanProductarray)
                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {


                //     selectedCompanyplanProduct = {};
                //     selectedCompanyplanProduct.calculatedTax = {};
                //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                //     selectedCompanyplanProduct.name = "NA";
                //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                //   }

                // }
                // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

                // // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)


                //console.log(selectedCompanyplanProductsArray)


              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              //console.log(selectedCompanyplanProductsArray)
              //this.consoleMessage(selectedCompanyplanProductsArray)
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              //console.log(selectedBaseplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              //console.log(selectedCCplanProduct)
              //console.log(selectedCompanyplanProductsArray[i])
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              //console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                // companyTax = employeeTax
                companyTax = 0  ////when there is no base planproduct
                // companyTaxPercentage = employeeTaxPercentage
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans)

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
              // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              //   selectedCompanyplanProductsArray.push(
              //     selectedCompanyplanProduct
              //   );
              // }
              //this.consoleMessage("CompanyTax")
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          //           modifiedCCgroup.plans = Array.from(new Set(modifiedCCgroup.plans.map((item:any) => JSON.stringify(item)))
          // ).map((str:any) => JSON.parse(str));
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
    if (selectedBaseplanProduct.name == 'NA') {
      //this.consoleMessage("No Base plan/product for this upgrade plans/product")
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );
    // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );
      //console.log(deltaplanPrice)


      //console.log(selectedBaseplanProduct.calculatedTax.price)

      if (selectedBaseplanProduct.name == 'NA') {
        //this.consoleMessage("No Base plan/product for this upgrade plans/product")
        // companyTax = employeeTax
        companyTax = 0  ////when there is no base planproduct
        // companyTaxPercentage = employeeTaxPercentage
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      // let deltaplanTax = adjustWith2DecimalsForUI(
      //   deltaplanPrice *
      //   (this.deltaCompanyTax ? companyTax : employeeTax)
      // );
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };

      //this.consoleMessage(obj)

      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

      //console.log(modifiedCCplan)
    }

    return modifiedCCplan
  }
  // calculateBasePlanCPplans(cpplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

  //   //console.log(cpplanspackages)


  //   let modifiedCPplanPackages: any = [];
  //   for (let i = 0; i < cpplanspackages?.length; i++) {
  //     let modifiedCPPackage = cpplanspackages[i];

  //     let CPplansgroups = cpplanspackages[i].groupsCP;

  //     modifiedCPPackage.groupsCP = [];
  //     for (let CPplangroup of CPplansgroups) {
  //       let modifiedCPgroup = CPplangroup;
  //       let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
  //       if (selectedCoverage == "null") {
  //         selectedCoverage = "DIRECT"
  //       }
  //       if (selectedCoverage != "DIRECT") {
  //         selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
  //       }

  //       //console.log(selectedCoverage)


  //       if (selectedCoverage == "DIRECT") {
  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup)
  //         if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
  //           modifiedCPplanPackages.push(modifiedCPPackage)
  //         }
  //         continue;
  //       }
  //       let CPplans = CPplangroup.plans;

  //       //console.log(CPplangroup)

  //       modifiedCPgroup.plans = [];
  //       baseplans = []
  //       for (let CPplan of CPplans) {
  //         let modifiedCPplan = CPplan;


  //         CPplan.planLevel_parentId = CPplangroup.parentId;

  //         let payroll = true;
  //         let EmployeeChoice = 0;

  //         if (
  //           this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
  //         ) {
  //           if (EmployeeChoice == 2) {
  //             payroll = false;
  //           }
  //         } else {
  //           if (
  //             this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
  //               CPplan.planLevel
  //             )
  //           ) {
  //             if (EmployeeChoice == 2) {
  //               payroll = false;
  //             }
  //           }
  //         }
  //         console.log(CPplan)
  //         let selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
  //         //console.log(CPplan)
  //         //console.log(CPplan.productAddonss[CPplan.name])


  //         for (let i = 0; i < selectedCPplanProductarray.length; i++) {

  //           for (let j = 0; j < selectedCPplanProductarray.length; j++) {
  //             if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

  //               baseplans.push(selectedCPplanProductarray[i])
  //             }

  //           }

  //         }

  //         if (CPplan.isBundle) {

  //           //console.log(baseplans)
  //           var filtered_base_plans = baseplans



  //           //this.consoleMessage(filtered_base_plans);

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           let selectedBaseplanProduct: any;
  //           let selectedBaseplanProductsArray = [];
  //           let selectedCompanyplanProduct: any;
  //           let selectedCompanyplanProductsArray: any = [];

  //           //console.log("length" + filtered_base_plans.length)

  //           selectedBasePlan = filtered_base_plans[0];

  //           //console.log(selectedBasePlan)

  //           if (selectedBasePlan) {
  //             // //this.consoleMessage(selectedBasePlan)
  //             // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
  //             selectedBaseplanProductsArray = [selectedBasePlan];
  //             let selectedBaseplanProductsArray2 = [];
  //             //  //this.consoleMessage(CCplan.packageId)
  //             if (CPplan.packageId == 5 || CPplan.packageId == 10) {

  //               // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
  //               // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
  //               //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
  //               // }
  //               // // //this.consoleMessage(selectedBaseplanProductsArray)
  //               // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //             else {

  //               // Direct Coverage Method

  //               // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


  //               // Selective single Coverage Method

  //               //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

  //               // Selective Couple Coverage Method
  //               if (selectedCoverage != "DIRECT") {
  //                 selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
  //               }
  //               //  // Selective Family Coverage Method


  //             }
  //           }
  //           else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";

  //             for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //               selectedBaseplanProductsArray.push(selectedBaseplanProduct);
  //             }
  //           }



  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }

  //           modifiedCPplan.products = []

  //           for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //             let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
  //             //console.log(selectedBaseplanProduct)
  //             let selectedCPplanProduct = selectedCPplanProductarray[i];
  //             //console.log(selectedCPplanProduct)
  //             let coverage = selectedCPplanProduct.planCoverage


  //             if (selectedCoverage == coverage) {

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;
  //             }

  //             //console.log(selectedCPplanProduct)
  //             let selectedCompanyplanProduct =
  //               selectedCompanyplanProductsArray[i];


  //             let companyTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );



  //             let employeeTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCPplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             //console.log(deltaplanPrice)


  //             //console.log(selectedBaseplanProduct.calculatedTax.price)

  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             //Delete plan Total Price and Total Combination
  //             if (deltaplanPrice <= 0) {
  //               deltaplanPrice = 0
  //               /*      baseplanPrice = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.price
  //                   );
  //                    baseplanTaxorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.tax
  //                   );
  //                    baseplanTax = adjustWith2DecimalsForUI(
  //                     baseplanPrice * companyTax
  //                   );
  //                    baseplanTotalorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.total
  //                   );
  //                    baseplanTotal = adjustWith2DecimalsForUI(
  //                     baseplanPrice + baseplanTax
  //                   ); */

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;

  //             }


  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice *
  //               (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );
  //             let combinedplanPrice = adjustWith2DecimalsForUI(
  //               baseplanPrice + deltaplanPrice
  //             );
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
  //             let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
  //             let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id, //0
  //               planName: selectedBasePlan.name, //NA
  //               planLevelId: selectedBasePlan.planLevel, //0
  //               amount: baseplanPrice, //0
  //               amountUI: `$${baseplanPrice}`, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId,
  //               packageName: selectedBasePlan.packageName,
  //               packageId: selectedBasePlan.packageId,
  //             };





  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage,
  //               selectedCoverage
  //             };

  //             //this.consoleMessage(obj)

  //             //console.log(selectedCoverage)
  //             //console.log(coverage)

  //             //console.log(obj)
  //             let cpProduct: any = {}
  //             cpProduct.upgradeCalculation = obj;
  //             modifiedCPplan.products.push(cpProduct)
  //             // modifiedCPplan.upgradeCalculation = obj;

  //             // if(selectedCoverage == coverage){

  //             // }else{
  //             //   cpProduct.upgradeCalculation = obj;
  //             //   modifiedCPplan.products.push(cpProduct)
  //             // }

  //             //console.log(modifiedCPplan)
  //           }

  //         }
  //         else {
  //           //this.consoleMessage("Not a BundlePlan")

  //           //this.consoleMessage(baseplans)



  //           filtered_base_plans = baseplans

  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           //console.log("length" + filtered_base_plans.length)
  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 0) {
  //             selectedBasePlan = filtered_base_plans[0];
  //           } else {
  //             //this.consoleMessage(filtered_base_plans.length)
  //           }

  //           let selectedbaseplanproduct: any;
  //           let selectedBaseplanProduct: any;

  //           if (selectedBasePlan) {
  //             for (let planname in selectedBasePlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedBasePlan.productAddonss[planname])
  //               let products = selectedBasePlan.productAddonss[planname];
  //               //console.log("length" + products.length)
  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedbaseplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 //this.consoleMessage(products.length)
  //               }
  //             }
  //             //this.consoleMessage(selectedbaseplanproduct)
  //             selectedBaseplanProduct = selectedbaseplanproduct;

  //           } else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";
  //           }

  //           let CCplanProduct;

  //           for (let planname in CPplan.productAddonss) {
  //             let products = CPplan.productAddonss[planname];
  //             //console.log("length" + products.length)

  //             if (products.length == 0) {
  //             } else if (products.length == 1) {
  //               CCplanProduct = products[0];
  //               // selectedCompnayPlan= filtered_compnay_plans[0]
  //             } else {
  //               //this.consoleMessage(products.length)
  //             }
  //           }
  //           let selectedCCplanProduct = CCplanProduct;


  //           let selectedcompanyplanproduct: any;
  //           let selectedCompanyplanProduct: any;

  //           if (selectedCompnayPlan) {

  //             let upgradeText;
  //             let upgradepaymentText;
  //             if (payroll) {
  //               upgradeText = "Employee upgraded using payroll deduction";
  //               upgradepaymentText = "using payroll deduction";
  //               //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //             } else {
  //               upgradeText = "Employee upgraded using Direct payment";
  //               upgradepaymentText = "using Direct payment";
  //             }
  //             let companyTax =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );
  //             let coverage = selectedCCplanProduct.planCoverage
  //             let employeeTax =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCCplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );

  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );

  //             let combinedplanPrice = baseplanPrice + deltaplanPrice;
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
  //             let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
  //             let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id || 0, //0
  //               planName: selectedBasePlan.name || "NA", //NA
  //               planLevelId: selectedBasePlan.planLevel || 0, //0
  //               amount: baseplanPrice || 0, //0
  //               amountUI: `$${baseplanPrice}` || 0, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
  //               packageName: selectedBasePlan.packageName || "",
  //               packageId: selectedBasePlan.packageId || 0,
  //             };
  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage
  //             };

  //             //this.consoleMessage(obj)
  //             // modifiedCPplan.upgradeCalculation = obj;
  //           }
  //         }
  //         modifiedCPgroup.plans.push(modifiedCPplan);

  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup);
  //       }
  //       //console.log(modifiedCPPackage)
  //       modifiedCPplanPackages.push(modifiedCPPackage);
  //     }

  //     this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

  //     console.log(this.modifiedBlocksPaidByCompany)

  //     //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
  //   }
  // }
  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;

        //console.log(CPplangroup)

        modifiedCPgroup.plans = [];
        let baseplans = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
          let selectedCPplanProductarray: any = CPplan.productAddonss[CPplan.name];


          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)

          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)
            //console.log(CPplan.productAddonss[CPplan.name])

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans



            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];

            //console.log("length" + filtered_base_plans.length)

            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

                // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                // }
                // // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method

                // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


                // Selective single Coverage Method

                //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              } else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              //console.log(selectedCoverage)
              //console.log(coverage)

              //console.log(obj)
              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
              // modifiedCPplan.upgradeCalculation = obj;

              // if(selectedCoverage == coverage){

              // }else{
              //   cpProduct.upgradeCalculation = obj;
              //   modifiedCPplan.products.push(cpProduct)
              // }

              //console.log(modifiedCPplan)
            }

          }
          else {
            //this.consoleMessage("Not a BundlePlan")

            //this.consoleMessage(baseplans)



            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            //console.log("length" + filtered_base_plans.length)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                //console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  //this.consoleMessage(products.length)
                }
              }
              //this.consoleMessage(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];
              //console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
                //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

              //this.consoleMessage(obj)
              // modifiedCPplan.upgradeCalculation = obj;
            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        //console.log(modifiedCPPackage)
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

      //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
    }
  }
  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

        //console.log(selectedCCplanProductarray[i])
        //console.log(selectedBaseplanProductsArray[j])

        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        //console.log("ElseDirectCoveragemETHOD")
        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    //console.log(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        //console.log(selectedBaseplanProductsArray[j])
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }


  public capitalize(str: String) {
    if (str) {
      // return str.charAt(0).toUpperCase() + str.slice(1);
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }

  getallCPplansIntoPackage(cppackages, mainarray) {
    let packagesArray = [];

    for (let cppackage of cppackages) {
      let packObj = cppackage;
      packObj.groups = cppackage.groupsCP;
      packagesArray.push(packObj);
    }

    return packagesArray;
  }
  getallEPplansIntoPackage(eppackages) {
    let packagesArray = [];

    for (let eppackage of eppackages) {
      let packObj = eppackage;
      packObj.groups = eppackage.groupsEP;

      packagesArray.push(packObj);
    }

    return packagesArray;
  }

  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    //this.consoleMessage(commonPackages)
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        //this.consoleMessage(pckg)
        pckg.groups = pckg.groupsCC;

        //this.consoleMessage(pckg.groups)
        //this.consoleMessage(pckg.groupsCC)

        if (commonPackages && commonPackages[pckg.id]) {
          //this.consoleMessage(commonPackages[pckg.id])
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }
  combineArrays(A, B) {
    let C = [];
    let found = false;
    for (let i = 0; i < A.length; i++) {
      const objA = A[i];
      const objB = B.find((obj) => obj.id === objA.id);
      // find matching object in B using id as key
      let groups = objA.groupsCP;
      // initialize groups with groupsCP from A
      if (objB) {
        // if matching object found in B, add both arrays to groups
        groups = [...objA.groupsCP, ...objB.groupsCC];
        found = true;
      }
      const newObj = { ...objA, groups };
      // create new object with updated groups property
      C.push(newObj);
      // push new object to C array
    }
    if (!found) {
      //this.consoleMessage(C)
      //this.consoleMessage(B)
      C = C.concat(B);
    }
    return C;
  }

  combineArrays1(A, B) {
    let C = [];
    let found = false;
    for (let i = 0; i < A.length; i++) {
      const objA = A[i];
      const objB = B.find((obj) => obj.id === objA.id);
      // find matching object in B using id as key
      let groups = objA.groups;

      // initialize groups with groupsCP from A
      if (objB) {
        // if matching object found in B, add both arrays to groups
        groups = [...objA.groups, ...objB.groups];
        found = true;
      }

      const newObj = { ...objA, groups };
      // create new object with updated groups property
      C.push(newObj);

      // push new object to C array
    }
    if (!found) {
      C = C.concat(B);
    }

    return C;
  }
  public isGroupsNotEmpty(groups: any): boolean {

    return groups && Object.keys(groups).length > 0;
  }
  checkEmailValidation(e: any) {
    this.logger.log('asasassasasa');
    let val = e.currentTarget.value;
    let notAlloewdSecvence = ['"', '(', ')', '.', ',', ':', ';', '<', '>', '@', '[', ']'];
    if (e.key == val.charAt(val.length - 1)) {
      if (notAlloewdSecvence.includes(val.charAt(val.length - 1))) {
        return false;
      }
    }

    else {
      return true;
    }
  }

  private scrollToFirstInvalidControl1() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector(
        'form .ng-invalid'
      );
    // //this.logger.log(firstInvalidControl);
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  public uhipprovincialhealth(value: any) {
    this.logger.log('value: ' + value);
    if (value.target.value == 'true') {
      //const modal = new Modal(this.checkphcpstatusModal.nativeElement);//checkuhipstatusModal
      //modal.show();

      this.checkhealthcardstatusuhip = false;
    } else {

      $('#checkuhipstatusModalStudent').show();
      this.checkhealthcardstatusuhip = true;
    }
  }

  selectTab(tabName: string): void {


    this.selectedTab = tabName;

    this.planssummary = JSON.parse(sessionStorage.getItem("plansummarymain"));
    //this.logger.log(this.planssummary);


    if (tabName == 'tab1') {
      this.userFormSubmitted = false;
      this.plansError = false
      this.plancheckboxcheck = 100000
      const elements =
        this.elementRef.nativeElement.getElementsByClassName('imgdisplay1');
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
        // elements[i].style.display = 'inline';
      }
      const elements1 =
        this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
      for (let i = 0; i < elements1.length; i++) {
        elements1[i].style.display = 'none';
        // elements1[i].style.display = 'inline';
      }
    }

    if (tabName == 'tab2') {
      // this.cartcheckvalue=false;
      if (this.isStudent) {
        const elements =
          this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
        for (let i = 0; i < elements.length; i++) {
          elements[i].style.display = 'none';
          // elements[i].style.display = 'inline';
        }
        sessionStorage.removeItem('studentsPlansArray');
        // this.planAmount = 0;
        sessionStorage.removeItem('totalAmount');

        sessionStorage.setItem('totalAmount', this.planAmount);
        setTimeout(() => {
          let selectedstudentPlans = JSON.parse(
            sessionStorage.getItem('allproducts') ?? '[]'
          );
          // selectedstudentPlans.forEach((element: any) => {
          //   document.getElementById("plancheck" + element.id)?.click();
          //   // $('#plancheck'+element.id).click();
          // });
          sessionStorage.setItem('allproducts', '');
        }, 100);
      }
      else {
        // return false;
        this.planssummary = JSON.parse(sessionStorage.getItem("plansummary"));
        let obj = {};

        if (this.isCorporate == true) {

          let data: any = JSON.parse(sessionStorage.getItem("plansummary") || '[]');
          let obj = {};

          // if (data) {

          //   data.forEach((element: any, index: any) => {
          //     obj = {
          //       planid: element.id,
          //     };

          //     setTimeout(() => {

          //       const dom: HTMLElement = this.elementRef.nativeElement;
          //       const plan: any = dom.querySelector("#plancheck" + element.id);


          //       if (element.options && element.options.length > 0) {

          //         if (element.isBundle) {
          //           // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


          //           // this.renderer.setProperty(planCheck, 'checked', true);
          //           const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
          //           this.renderer.setProperty(plan, 'checked', true);

          //           if (element.paidByCompany == 1) {
          //             const dom: HTMLElement = this.elementRef.nativeElement;
          //             // const plan: any = dom.querySelector("#plancheck" + element.id);




          //             if (element.coverage) {
          //               const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
          //               if (plan) {
          //                 plan.disabled = true;
          //               }
          //             }
          //             else {
          //               const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
          //               if (plan) {
          //                 plan.disabled = true;
          //               }
          //             }
          //           }


          //         } else {
          //           element.products.forEach((products: any, index: any) => {
          //             // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


          //             // this.renderer.setProperty(planCheck, 'checked', true);
          //             if (element.coverage) {
          //               const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


          //               this.renderer.setProperty(plan, 'checked', true);
          //             }
          //             else {
          //               const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
          //               this.renderer.setProperty(planCheck, 'checked', true);

          //             }

          //             if (element.paidByCompany == 1) {
          //               const dom: HTMLElement = this.elementRef.nativeElement;
          //               // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


          //               if (element.coverage) {
          //                 const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
          //                 if (plan) {
          //                   plan.disabled = true;
          //                 }
          //               }
          //               else {
          //                 const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
          //                 if (plan) {
          //                   plan.disabled = true;
          //                 }
          //               }
          //             }


          //           })
          //         }

          //       }

          //       else {

          //         if (element.isBundle) {
          //           const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);


          //           this.renderer.setProperty(plan, 'checked', true);
          //           // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

          //           // // console.log(planCheck)
          //           // this.renderer.setProperty(planCheck, 'checked', true);

          //           if (element.paidByCompany == 1) {
          //             const dom: HTMLElement = this.elementRef.nativeElement;
          //             if (element.coverage) {
          //               const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
          //               if (plan) {
          //                 plan.disabled = true;
          //               }
          //             }
          //             else {
          //               const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
          //               if (plan) {
          //                 plan.disabled = true;
          //               }
          //             }
          //           }


          //         }
          //         else {
          //           element.products.forEach((products: any, index: any) => {
          //             // $("#plancheck" + products.id).click();
          //             // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
          //             //   console.log(planCheck)
          //             // this.renderer.setProperty(planCheck, 'checked', true);
          //             if (element.coverage) {
          //               const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


          //               this.renderer.setProperty(plan, 'checked', true);
          //             }
          //             else {
          //               const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
          //               this.renderer.setProperty(planCheck, 'checked', true);

          //             }
          //             if (element.paidByCompany == 1) {
          //               const dom: HTMLElement = this.elementRef.nativeElement;
          //               if (element.coverage) {
          //                 const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
          //                 if (plan) {
          //                   plan.disabled = true;
          //                 }
          //               }
          //               else {
          //                 const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
          //                 if (plan) {
          //                   plan.disabled = true;
          //                 }
          //               }
          //             }
          //           })
          //         }
          //       }

          //       // $("#plancheck" + element.id).prop("checked", true);
          //       // plan.checked =true
          //     }, 100);

          //     // this.plancheckarray.push(element.id)
          //   });

          // }

          if (data) {

            data.forEach((element: any, index: any) => {
              obj = {
                planid: element.id,
              };

              setTimeout(() => {

                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);


                if (element.options && element.options.length > 0) {

                  if (element.isBundle) {
                    // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


                    // this.renderer.setProperty(planCheck, 'checked', true);
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                    this.renderer.setProperty(plan, 'checked', true);

                    if (element.paidByCompany == 1) {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      // const plan: any = dom.querySelector("#plancheck" + element.id);




                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                      else {
                        const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                    }
                    if (element.disallowedPlanLevels != null) {
                      let disallowed_plans = element.disallowedPlanLevels.split(',');
                      const dom1: HTMLElement = this.elementRef.nativeElement;
                      for (let i = 0; i < disallowed_plans.length; i++) {
                        // console.log(disallowed_plans[i]);
                        // console.log(disallowed_plans[i]);
                        setTimeout(() => {
                          let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                          console.log(elem)
                          elem.forEach((products: any, index: any) => {
                            if (products != null) {
                              if (!products.disabled) {

                                products.disabled = true
                              }
                            }
                          })

                        }, 100);

                      }
                    }

                  } else {
                    element.products.forEach((products: any, index: any) => {
                      // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


                      // this.renderer.setProperty(planCheck, 'checked', true);
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                        this.renderer.setProperty(plan, 'checked', true);
                      }
                      else {
                        const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                        this.renderer.setProperty(planCheck, 'checked', true);

                      }

                      if (element.paidByCompany == 1) {
                        const dom: HTMLElement = this.elementRef.nativeElement;
                        // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


                        if (element.coverage) {
                          const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                        else {
                          const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                      }


                    })
                    if (element.disallowedPlanLevels != null) {
                      let disallowed_plans = element.disallowedPlanLevels.split(',');
                      const dom1: HTMLElement = this.elementRef.nativeElement;
                      for (let i = 0; i < disallowed_plans.length; i++) {
                        // console.log(disallowed_plans[i]);
                        // console.log(disallowed_plans[i]);
                        setTimeout(() => {
                          let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                          console.log(elem)
                          elem.forEach((products: any, index: any) => {
                            if (products != null) {
                              if (!products.disabled) {

                                products.disabled = true
                              }
                            }
                          })

                        }, 100);

                      }
                    }
                  }

                }

                else {

                  if (element.isBundle) {
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                    // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

                    // // //console.log(planCheck)
                    // this.renderer.setProperty(planCheck, 'checked', true);

                    if (element.paidByCompany == 1) {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                      else {
                        const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                    }

                    if (element.disallowedPlanLevels != null) {
                      let disallowed_plans = element.disallowedPlanLevels.split(',');
                      const dom1: HTMLElement = this.elementRef.nativeElement;
                      for (let i = 0; i < disallowed_plans.length; i++) {
                        // console.log(disallowed_plans[i]);
                        // console.log(disallowed_plans[i]);
                        setTimeout(() => {
                          let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                          console.log(elem)
                          elem.forEach((products: any, index: any) => {
                            if (products != null) {
                              if (!products.disabled) {

                                products.disabled = true
                              }
                            }
                          })

                        }, 100);

                      }
                    }
                  }
                  else {
                    element.products.forEach((products: any, index: any) => {
                      // $("#plancheck" + products.id).click();
                      // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      //   //console.log(planCheck)
                      // this.renderer.setProperty(planCheck, 'checked', true);
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                        this.renderer.setProperty(plan, 'checked', true);
                      }
                      else {
                        const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                        this.renderer.setProperty(planCheck, 'checked', true);

                      }
                      if (element.paidByCompany == 1) {
                        const dom: HTMLElement = this.elementRef.nativeElement;
                        if (element.coverage) {
                          const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                        else {
                          const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                      }
                    })

                    if (element.disallowedPlanLevels != null) {
                      let disallowed_plans = element.disallowedPlanLevels.split(',');
                      const dom1: HTMLElement = this.elementRef.nativeElement;
                      for (let i = 0; i < disallowed_plans.length; i++) {
                        // console.log(disallowed_plans[i]);
                        // console.log(disallowed_plans[i]);
                        setTimeout(() => {
                          let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                          console.log(elem)
                          elem.forEach((products: any, index: any) => {
                            if (products != null) {
                              if (!products.disabled) {

                                products.disabled = true
                              }
                            }
                          })

                        }, 100);

                      }
                    }
                  }
                }

                // $("#plancheck" + element.id).prop("checked", true);
                // plan.checked =true
              }, 100);

              // this.plancheckarray.push(element.id)
            });

          }

          let dataLife: any = JSON.parse(sessionStorage.getItem("plansummaryLife") || '[]');

          if (dataLife) {

            dataLife.forEach((element: any, index: any) => {

              setTimeout(() => {

                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector("#planCheckLife" + element.planCoverage+"-"+coverage);



                element.products.forEach((products: any, index: any) => {
                  // $("#plancheck" + products.id).click();
                  if (element.coverage == 'MEMBER') {
                    element.coverage = 'MEMBER'
                    const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                    this.renderer.setProperty(planCheck, 'checked', true);
                  } else {
                    element.coverage = 'SPOUSE'
                    const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                    this.renderer.setProperty(planCheck, 'checked', true);
                    const planCheck1 = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + 'MEMBER', true);

                    this.renderer.setProperty(planCheck1, 'checked', true);
                  }

                })


                // $("#plancheck" + element.id).prop("checked", true);
                // plan.checked =true
              }, 100);

              // this.plancheckarray.push(element.id)
            });

          }


        }
        else {

          let data: any = JSON.parse(sessionStorage.getItem("plansummary") || '[]');
          let obj = {};

          if (data) {

            data.forEach((element: any, index: any) => {
              obj = {
                planid: element.id,
              };

              setTimeout(() => {

                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);


                if (element.options && element.options.length > 0) {

                  if (element.isBundle) {
                    // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


                    // this.renderer.setProperty(planCheck, 'checked', true);
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                    this.renderer.setProperty(plan, 'checked', true);

                    if (element.paidByCompany == 1) {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      // const plan: any = dom.querySelector("#plancheck" + element.id);




                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                      else {
                        const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                    }


                  } else {
                    element.products.forEach((products: any, index: any) => {
                      // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


                      // this.renderer.setProperty(planCheck, 'checked', true);
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                        this.renderer.setProperty(plan, 'checked', true);
                      }
                      else {
                        const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                        this.renderer.setProperty(planCheck, 'checked', true);

                      }

                      if (element.paidByCompany == 1) {
                        const dom: HTMLElement = this.elementRef.nativeElement;
                        // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


                        if (element.coverage) {
                          const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                        else {
                          const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                      }


                    })
                  }

                }

                else {

                  if (element.isBundle) {
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                    // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

                    // // console.log(planCheck)
                    // this.renderer.setProperty(planCheck, 'checked', true);

                    if (element.paidByCompany == 1) {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                      else {
                        const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                        if (plan) {
                          plan.disabled = true;
                        }
                      }
                    }


                  }
                  else {
                    element.products.forEach((products: any, index: any) => {
                      // $("#plancheck" + products.id).click();
                      // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      //   console.log(planCheck)
                      // this.renderer.setProperty(planCheck, 'checked', true);
                      if (element.coverage) {
                        const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                        this.renderer.setProperty(plan, 'checked', true);
                      }
                      else {
                        const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                        this.renderer.setProperty(planCheck, 'checked', true);

                      }
                      if (element.paidByCompany == 1) {
                        const dom: HTMLElement = this.elementRef.nativeElement;
                        if (element.coverage) {
                          const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                        else {
                          const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                          if (plan) {
                            plan.disabled = true;
                          }
                        }
                      }
                    })
                  }
                }

                // $("#plancheck" + element.id).prop("checked", true);
                // plan.checked =true
              }, 100);

              // this.plancheckarray.push(element.id)
            });

          }



          let dataLife: any = JSON.parse(sessionStorage.getItem("plansummaryLife") || '[]');

          if (dataLife) {

            dataLife.forEach((element: any, index: any) => {

              setTimeout(() => {

                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector("#planCheckLife" + element.planCoverage+"-"+coverage);



                element.products.forEach((products: any, index: any) => {
                  // $("#plancheck" + products.id).click();
                  if (element.coverage == 'MEMBER') {
                    element.coverage = 'MEMBER'
                    const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                    this.renderer.setProperty(planCheck, 'checked', true);
                  } else {
                    element.coverage = 'SPOUSE'
                    const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                    this.renderer.setProperty(planCheck, 'checked', true);
                    const planCheck1 = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + 'MEMBER', true);

                    this.renderer.setProperty(planCheck1, 'checked', true);
                  }
                  // if(element.coverage=='MEMBER'){
                  //   element.coverage='MEMBER'
                  // }else{
                  //   element.coverage='SPOUSE'
                  // }
                  // const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage+"-"+element.coverage, true);

                  // // console.log(planCheck)
                  // this.renderer.setProperty(planCheck, 'checked', true);
                })


                // $("#plancheck" + element.id).prop("checked", true);
                // plan.checked =true
              }, 100);

              // this.plancheckarray.push(element.id)
            });

          }
        }

      }
    }
  }

  termAndConditionsLoading(event: any) {
    this.pdfvisibletermsandcodionsmodel = false;
  }
  AdviserDisclosureloading(event: any) {
    this.pdfvisibleadvisouredisclosure = false;
  }

  padAgrementLoading(event: any) {
    this.padAgrementLoad = false;
  }

  padAgrementWithOutSignLoading(evenr: any) {
    this.withSignLoad = false;
  }
  get userFormControl() {
    // this.logger.log("form controls: "+this.userForm)
    return this.userForm.controls;
  }
  get childInfoControl() {
    return this.childFormGroup.controls;
  }

  public closeprovinceinfo() {
    this.userFormControl['province'].reset();
    this.userFormControl['province'].setValue('');
    //  document?.getElementById('Province')?.value='';
    const elements =
      this.elementRef.nativeElement.getElementsByClassName('ProvinceClass');
    for (let i = 0; i < elements.length; i++) {
      elements.value = '';
    }
  }
  public childrenPopupClose() {
    $('#childInfoModal').hide();
    this.childFormGroup.reset();

    this.childFormGroup.clearValidators();
    this.childFormGroup.updateValueAndValidity();
    this.childFormGroup.get('childInfoGender')?.setValue('Select');
    this.graducationdaycheck = false;
  }

  public getSliderBackground(
    rangeValue: any,
    maxRange: any,
    stepCount: any,
    defaultRange: any
  ): any {
    const percentage = (rangeValue / maxRange) * 100;
    let gradientColor = "white";


    // if (percentage >= 8 && stepCount === 25000) {
    //   gradientColor = "green";
    // }
    // return `linear-gradient(to right, ${gradientColor} ${percentage}%, white ${percentage}%)`;



    if (rangeValue <= defaultRange) {
      this.greenValue = (defaultRange / maxRange) * 100;
      this.names = [
        { label: 'Guaranteed', position: this.greenValue },    // Display "Start" at 0%
        { label: 'Pending', position: 100 - this.greenValue }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = false
      return `linear-gradient(to right, green ${(defaultRange / maxRange) * 100}%, lightgray 0%)`;
    } else if (rangeValue > defaultRange) {
      const greenPart = adjustWith2DecimalsForUI((defaultRange / maxRange) * 100);
      console.log(greenPart)
      this.yellowValue = adjustWith2DecimalsForUI((100 - greenPart) * 100);
      // const yellowPart = ((rangeValue - defaultRange) / 4.5) + greenPart;
      const yellowPart = adjustWith2DecimalsForUI((rangeValue / maxRange) * 100)

      console.log(yellowPart)
      this.names = [
        { label: 'Guaranteed', position: greenPart },    // Display "Start" at 0%
        { label: 'Pending', position: yellowPart }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = true
      return `linear-gradient(to right,  green 0%,
      green ${greenPart}%,
      yellow ${greenPart}%,
      yellow ${yellowPart}%,
      lightgray  ${yellowPart}%,
      lightgray  100%) `;

    }
  }

  public isDataAvailable(type: string, category: string, feild?: string): boolean {
    // console.log(this.allFormData)
    // console.log(type)
    // console.log(category)
    // console.log(feild)
    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouseDataa(type: string, category: string, feild?: string): boolean {


    // const bool = feild?this.allFormData[type] && this.allFormData[type][category]:false;
    // return bool

    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouse(type: string, category: string, feild?: string): boolean {

    if (this.allFormData[type]) {
      console.log(this.allFormData[type]['member'])
    }

    if (this.allFormData[type] && this.allFormData[type]['member']) {
      return false
    }
    else {
      return true
    }


  }
  public generateTicks(maxRange: any, stepCount: any): any[] {
    const ticks = [];
    const totalTicks = maxRange / stepCount;

    for (let i = 0; i <= totalTicks; i++) {
      ticks.push(i * stepCount);
    }

    return ticks;
  }

  public updateTotal(data: any) {
    const memberPremium =
      data.member && data.member.premium > 0 ? data.member.premium : 0;
    const spousePremium =
      data.spouse && data.spouse.premium > 0 ? data.spouse.premium : 0;
    const dependentPremium =
      data.dependent && data.dependent.premium > 0 ? data.dependent.premium : 0;
    const total = memberPremium + spousePremium + dependentPremium;

    return total;
  }
  public updateFormData(
    type: string,
    category: string,
    newData: any,
    remove: boolean = false
  ): void {


    if (this.lastUpdatedType !== type) {
      this.formData = this.allFormData[type]
        ? { ...this.allFormData[type] }
        : {};
    }

    let updatedFormData = { ...this.formData };
    let shouldUpdateTotal = false;
    console.log(updatedFormData)
    if (remove) {
      delete updatedFormData[category];
      delete updatedFormData.total;
    } else if (typeof newData === "object" && newData !== null) {
      updatedFormData[category] = { ...updatedFormData[category], ...newData };
      shouldUpdateTotal = "coverage" in newData || category === "dependent" || "isSmoker" in newData;
    } else {
      updatedFormData[category] = newData;
    }

    if (
      shouldUpdateTotal &&
      ["member", "spouse", "dependent"].includes(category)
    ) {
      updatedFormData.total = this.updateTotal(updatedFormData);
    }

    this.formData = updatedFormData;
    this.allFormData[type] = { ...this.formData };
    // this.allFormData = { ...this.allFormData, [type]: this.formData };
    this.lastUpdatedType = type;
    console.log("formData:", this.allFormData);


  }

  public calculateAge(dob: string) {
    const today = new Date();
    const birthDate = new Date(dob);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  public updatePremium(
    type: string,
    category: string,
    newIsSmokerValue: string
  ) {

    //  if (this.allFormData[type][category]) {
    //   const isSmokerValue = event.target.value=== "yes" ? "smoker" : "nonSmoker";

    //   console.log(isSmokerValue)
    //   let gender:any = this.userForm.value.gender?.toLowerCase()
    //   let value: any = 0;
    //   console.log(this.allFormData[type][category]["coverage"])
    //   value=this.allFormData[type][category]["coverage"][gender][isSmokerValue]
    //   console.log(value)
    //   const premium = (this.allFormData[type][category]["coverage"].maximumCoverageWithoutEvidence * value) / 1000;
    //   console.log(parseFloat(premium.toFixed(2)))
    //   this.updateFormData(type, category, {
    //     isSmoker: isSmokerValue,
    //     premium: parseFloat(premium.toFixed(2))
    //   });
    // }

    console.log(this.allFormData)
    // const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence;

    const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence / 25000;
    const isSmoker = newIsSmokerValue === "yes" ? "smoker" : "nonSmoker";
    let value: any = 0;
    let gender: any = this.userForm.value.gender?.toLowerCase()
    let spouseGender: any = this.userForm.value.spousegender?.toLowerCase()

    console.log(spouseGender)

    if (category === "member") {
      value = this.allFormData[type][category]["coverage"]["price"][gender][isSmoker]
    }

    if (category === "spouse") {
      value = this.allFormData[type][category]["coverage"]["price"][spouseGender][isSmoker]
    }
    console.log({ value })

    this.updateFormData(type, category, { constant: value });

    if (coverage > 0) {
      // const premium = (coverage * value) / 1000;

      const premium = (coverage * value);
      return parseFloat(premium.toFixed(2));
    }
    console.log("formData:", this.allFormData);
    return 0;

  }

  public updateDependentPremium(type: string, category: string, coverage: number) {
    // const constant = coverage > 5000 ? 2.56 : 1.28;
    // this.updateFormData(type, category, { constant: constant });

    // const p =
    //   (constant * coverage) / 1000;
    // return parseFloat(p.toFixed(2));
  }
  public handleRadioChange(event: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, value: any): void {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let isSmokerValue = event.target.value;
    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let smokerCheck: any = ''

    if (isSmokerValue == "no") {
      smokerCheck = false
    }
    else {
      smokerCheck = true
    }

    this.rangeValues = []


    this.allFormData[type][category].coverage = value

    if (this.allFormData[type][category]) {

      this.updateFormData(type, category, {
        isSmoker: isSmokerValue,
        premium: this.updatePremium(type, category, isSmokerValue),
      });
    }

    console.log(this.allFormData)
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}

    if (category == "member") {
      lifeCoverage = "MEMBER"
    }
    else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }







    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
    let spousePrice: any;
    if (this.allFormData[type]['spouse']) {
      spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
    }


    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(
            this.userForm.value.planEnrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };

      if (this.isCorporate == true) {
        obj["categorization"] = {
          paidByCompany: 0,
          coveredByCompany: 0,
          paidByEmployee: 1,
        }
      }

      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')


      if (category == "member") {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          // "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):this.allFormData[type]["member"].coverage.defaultRange,

          "guaranteedAcceptanceAmount": adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant)),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }

        memberObj["guaranteedAcceptanceTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax)
        memberObj["guaranteedAcceptanceTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total)

        memberObj["pendingApprovalTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax)
        memberObj["pendingApprovalTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total)

        obj["member"] = memberObj
        obj["spouse"] = {}
        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.userForm.value.planEnrollmentDate
              ? this._CustomDatePipe.transform(
                this.userForm.value.planEnrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.userForm.value.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).total
        }
      }
      else {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),

          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.userForm.value.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj


        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total

      }

      let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails
      obj1.products.push(this.productobj);

      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }


    /*
    Form Here the code works for auto slection of Smoker in Life and critical vice versa
     */

    plansummaryLife.forEach((element: any, index: any) => {


      if (category == "member") {

        if (element.member.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "member" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }
      if (category == "spouse") {


        if (element.spouse.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "spouse" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }




    })
  }

  public handleRangeChange(value: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, event: any, data: any): void {
    // console.log(value)
    // console.log(type)
    // console.log(event)
    // console.log(data)


    if (data.maximumCoverageWithoutEvidence == 0) {
      data.maximumCoverageWithoutEvidence = 25000
    }
    this.allFormData[type][category].coverage = data

    // this.sliderValue = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence


    this.rangeValues = [];




    if (this.allFormData[type][category]) {
      this.updateFormData(type, category, {
        // coverage: value,
        isSmoker: this.allFormData[type][category].isSmoker,
        premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
      });
    }
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}
    if (category == "member") {
      lifeCoverage = "MEMBER"
    } else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }

    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');


    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(
            this.userForm.value.planEnrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (this.isCorporate == true) {
        obj["categorization"] = {
          paidByCompany: 0,
          coveredByCompany: 0,
          paidByEmployee: 1,
        }
      }
      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      // console.log(this.allFormData)
      // console.log(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence )
      // console.log(this.allFormData[type]["member"].coverage.defaultRange)
      // console.log((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)

      // console.log(((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant)

      let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
      let spousePrice: any;
      if (this.allFormData[type]['spouse']) {
        spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
      }
      // console.log(price)
      // console.log(price*this.allFormData[type]["member"].constant)
      // console.log(product.taxesDataJSON)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]))
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total)
      if (category == "member") {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,


          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        obj["member"] = memberObj
        obj["spouse"] = {}

        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.userForm.value.planEnrollmentDate
              ? this._CustomDatePipe.transform(
                this.userForm.value.planEnrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.userForm.value.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total
        }




      }
      else {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.userForm.value.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj

        // let price = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000):0*this.allFormData[type]["member"].constant

        //   console.log(price)
        //   console.log(this.calculateTaxForProductTaxesData(price,product.taxesDataJSON??[]))
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total
        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

      }


      console.log(memberObj["pendingApprovalTax"])
      let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSguranteeAcceptanceAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSpendingApprovalAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails


      obj1.products.push(this.productobj);
      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }
  }
  public calculateTaxForProductTaxesData(price: number, taxesData: any) {
    // this.console.log(taxesData)
    // [{"tax_name":"PST","tax_code":"0002","plan_product_id":177927,"tax_description":"PST on Health Insurance","business_tax_number":"709505879TR0001","tax_rate":0.09,"tax_sku":"pstonhealthinsurance"}]
    let calculatedTax: any = {}
    let tax: any = 0;
    let planProductIds: any = []
    let planProductInfos: any = []
    if (taxesData && taxesData != undefined && taxesData != null && taxesData != "null") {
      for (const taxData of taxesData) {
        tax += adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductIds.push(taxData.plan_product_id);
        let planProductInfo: any = {};
        // planProductInfo.name = taxData.tax_description + " " + (taxData.business_tax_number ?? "");
        planProductInfo.name = taxData.tax_name;
        planProductInfo.description = taxData.tax_description;
        planProductInfo.price = adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductInfo.planProductUniqueId = taxData.plan_product_id;
        planProductInfo.isIncluded = true;
        planProductInfo.taxRate = taxData.tax_rate;
        planProductInfo.taxRatePercentage = adjustWith2DecimalsForUI((taxData.tax_rate) * 100) + "%";
        planProductInfos.push(planProductInfo);
      }
    }

    let total = adjustWith2DecimalsForUI(price + tax)
    calculatedTax.price = adjustWith2DecimalsForUI(price);
    calculatedTax.tax = adjustWith2DecimalsForUI(tax);
    calculatedTax.total = adjustWith2DecimalsForUI(total);

    calculatedTax.planProductIds = planProductIds;
    calculatedTax.planProductInfos = planProductInfos;

    return calculatedTax;

  }

  public transformData() {
    let transformedData: any = [];
    let id = 12;

    Object.keys(this.allFormData).forEach(key => {
      const plan = this.allFormData[key];
      if (plan.total > 0) {
        const hasMember: boolean = plan.hasOwnProperty('member');

        const hasSpouse = plan.hasOwnProperty('spouse');
        const hasChildren = plan.hasOwnProperty('dependent');

        const transformedObject: any = {
          name: key.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          id: id++,
          havingSpouse: hasSpouse,
          havingChildren: hasChildren,
          total: plan.total,
        }

        transformedObject.member = {}

        if (hasMember && plan.member.premium > 0) {
          transformedObject.member = {
            isSmoker: plan.member.isSmoker,
            total: plan.member.premium,
            units: plan.member.coverage,
            // placeOfBirth: plan.member.PlaceOfBirth,
            premium: plan.member.constant
          }
        }

        transformedObject.spouse = {}

        if (hasSpouse && plan.spouse.premium > 0) {
          transformedObject.spouse = {
            isSmoker: plan.spouse.isSmoker,
            total: plan.spouse.premium,
            units: plan.spouse.coverage,
            // placeOfBirth: plan.spouse.PlaceOfBirth,
            premium: plan.spouse.constant

          };
        }

        transformedObject.dependent = []

        if (hasChildren && plan.dependent.premium > 0) {
          const dep = this.signUpData.childrenDetails.map((d: any) => {
            return {
              childFirstName: d.childFirstName,
              childLastName: d.childLastName,
              //  total: plan.dependent.premium/this.signUpData.childrenDetails.length,
              total: plan.dependent.premium,
              units: plan.dependent.coverage,
              premium: plan.dependent.constant,
              // placeOfBirth:
              //   plan.dependent[`${d.childFirstName}-${d.childLastName}`],
            };
          });

          transformedObject.dependent = dep;
          transformedObject.dependent.allDependentPremium = {
            total: plan.dependent.premium,
            units: plan.dependent.coverage,
            premium: plan.dependent.constant
          }

        }

        transformedData.push(transformedObject);
      }
    });

    return transformedData;
  }
  public onCheckboxChangeP(
    event: any,
    type: string,
    category: string,
    key1: string,
    value1: any,
    key2?: string,
    value2?: any
  ): void {

    console.log(this.allFormData)


    console.log(value1)
    console.log(value1?.member)
    // console.log(value1?.spouse)
    if (category == 'member') {
      this.updateFormData(type, 'member', { coverage: value1.member })
    }
    if (category == 'spouse') {
      if (this.userForm.value.having_spouse === 'true') {
        this.updateFormData(type, 'spouse', { coverage: value1.spouse });
      }
    }



    let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    if (event.target.checked) {
      this.updateFormData(type, category, { [key1]: value1 });
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan: any = dom.querySelector("." + category + "-" + type + "-no");
      console.log(plan)
      setTimeout(() => {
        // plan.click()
      }, 100);


    } else {

      console.log(type)
      console.log(category)
      this.updateFormData(type, category, {}, true);

      if (category == 'spouse') {
        this.updateFormData(type, 'member', {}, true);


        const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'MEMBER', true);
        this.renderer.setProperty(planCheck, 'checked', false);
      }
      if (category == 'member') {
        this.updateFormData(type, 'spouse', {}, true);

        planSummaryLife.forEach((element: any, index: any) => {

          if (element.coverage == 'MEMBER & SPOUSE') {
            const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'SPOUSE', true);
            this.renderer.setProperty(planCheck, 'checked', false);
          }

        })

      }
      this.unselectplanLife(event)
    }


  }

  public onInputChangeP(e: Event, type: string, category: string): void {
    const inputElement = e.target as HTMLInputElement;
    if (inputElement && this.allFormData[type][category]) {
      const obj = { [inputElement.name]: inputElement.value };
      this.updateFormData(type, category, obj);
    }
  }




  public handleRangeChangeForDependent(
    value: any,
    type: string,
    category: string
  ): void {
    // if (this.allFormData[type][category]) {
    //   this.updateFormData(type, category, {
    //     // coverage: value,
    //     premium: this.updateDependentPremium(type, category, value),
    //   });
    // }
  }

  public onCheckboxChangestudent(
    e: any,
    plan: any,
    planname: any,
    planid: any,
    productname: any,
    product: any,
    index: any
  ) {

    this.plansnexttab = false;
    let plansproductarray: any = [];
    let allproductsarray: { name: any }[] = [];
    let plansproductarray1 = [];
    let allproductsarray1 = [];

    if (e.target.checked) {
      if (productname == 'Health Plan') {
        this.cartcheckvalue = true;
      }
      if (sessionStorage.getItem('studentsPlansArray')) {
        plansproductarray = JSON.parse(
          sessionStorage.getItem('studentsPlansArray') ?? '[]'
        );
      } else {
        plansproductarray = [];
      }
      if (sessionStorage.getItem('allproducts')) {
        allproductsarray = JSON.parse(
          sessionStorage.getItem('allproducts') ?? '[]'
        );
      } else {
        allproductsarray = [];
      }
      if (plansproductarray.length == 0) {
        let productobj = {
          id: product.id,
          productId: product.productId,
          name: product.name,
          planProductId: product.planProductId,
          price: product.price1 || product.price,
          tax: product.calculatedTax?.toString()
            ? product.calculatedTax?.tax.toString()
            : '0',
          total: product.calculatedTax?.toString()
            ? product.calculatedTax?.total.toString()
            : '0',
          tax_details:
            product.bundledTaxes && product.bundledTaxes.length > 0
              ? product.bundledTaxes
              : product.taxesDataJSON,
          calculatedTax: product?.calculatedTax,
          bundledProducts: product.bundledProducts,
          planCoverage: product.planCoverage,
        };
        let obj: any = {
          packageId: plan.packageId,
          packageName: '',
          planproductname: productobj.name,
          planPrice: parseFloat(productobj.price),
          calculatedTax: parseFloat(product.calculatedTax?.price),
          groupid: plan.planLevel,
          groupName: '',
          id: planid,
          name: planname,
          planLevel: plan.planLevel,
          fusebillPlanID: parseInt(plan.fusebillId),
          planFrequencyID: parseInt(plan.frqMonthly),
          isBundle: plan.isBundle,
          bundledProducts: [],
          products: [],
          version: plan.version
        };
        obj.products.push(productobj);
        allproductsarray.push(productobj);
        plansproductarray.push(obj);
        sessionStorage.setItem(
          'studentsPlansArray',
          JSON.stringify(plansproductarray)
        );
        sessionStorage.setItem('allproducts', JSON.stringify(allproductsarray));
      } else {
        let index: any = this.getindexofplan(product.name);
        if (index != 'false') {
          const checkbox = document.getElementById(
            'plancheck' + plansproductarray[index].products[0].id
          ) as HTMLInputElement | null;
          if (checkbox != null) {
            checkbox.checked = false;
          }

          let productobj = {
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: product.price1 || product.price,
            tax: product.calculatedTax?.toString()
              ? product.calculatedTax?.taxtoString()
              : 0,
            total: product.calculatedTax?.toString()
              ? product.calculatedTax?.total.toString()
              : 0,
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: product?.calculatedTax,
            bundledProducts: product.bundledProducts,
            planCoverage: product.planCoverage,
          };
          let obj: any = {
            packageId: plan.packageId,
            packageName: '',

            planproductname: productobj.name,

            groupid: plan.planLevel,
            groupName: '',
            id: planid,
            name: planname,
            planLevel: plan.planLevel,
            fusebillPlanID: parseInt(plan.fusebillId),
            planFrequencyID: parseInt(plan.frqMonthly),
            isBundle: plan.isBundle,
            bundledProducts: [],
            products: [],
            version: plan.version

          };

          for (let k = 0; k < allproductsarray.length; k++) {
            if (
              allproductsarray[k].name ==
              plansproductarray[index].planproductname
            ) {
              allproductsarray.splice(k, 1);
            }
          }

          plansproductarray.splice(index, 1);
          obj.products.push(productobj);
          allproductsarray.push(productobj);
          plansproductarray.push(obj);
          sessionStorage.setItem(
            'studentsPlansArray',
            JSON.stringify(plansproductarray)
          );
          sessionStorage.setItem(
            'allproducts',
            JSON.stringify(allproductsarray)
          );
        } else {
          this.logger.log('product not exist');

          let productobj = {
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: product.price1 || product.price,
            tax: product.calculatedTax?.toString()
              ? product.calculatedTax?.tax.toString()
              : 0,
            total: product.calculatedTax?.toString()
              ? product.calculatedTax?.total.toString()
              : 0,
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: product.calculatedTax,
            bundledProducts: product.bundledProducts,
            planCoverage: product.planCoverage,
          };
          let obj: any = {
            packageId: plan.packageId,
            packageName: '',

            planproductname: productobj.name,

            groupid: plan.planLevel,
            groupName: '',
            id: planid,
            name: planname,
            planLevel: plan.planLevel,
            fusebillPlanID: parseInt(plan.fusebillId),
            planFrequencyID: parseInt(plan.frqMonthly),
            isBundle: plan.isBundle,
            bundledProducts: [],
            products: [],
            version: plan.version

          };
          obj.products.push(productobj);
          allproductsarray.push(productobj);
          plansproductarray.push(obj);
          sessionStorage.setItem(
            'studentsPlansArray',
            JSON.stringify(plansproductarray)
          );
          sessionStorage.setItem(
            'allproducts',
            JSON.stringify(allproductsarray)
          );
        }
      }
    } else {
      if (planname.includes('Health Benefits')) {
        // this.AddOnsChecked=false;

        let selectedstudentPlans = JSON.parse(
          sessionStorage.getItem('allproducts') ?? '[]'
        );

        selectedstudentPlans.forEach((element: any) => {
          document.getElementById('plancheck' + element.id)?.click();
          // $('#plancheck'+element.id).click();
        });

        sessionStorage.setItem('studentsPlansArray', '[]');
        sessionStorage.setItem('allproducts', '[]');
      }

      if (sessionStorage.getItem('studentsPlansArray')) {
        plansproductarray = JSON.parse(
          sessionStorage.getItem('studentsPlansArray') ?? '[]'
        );
      } else {
        plansproductarray = [];
      }
      if (sessionStorage.getItem('allproducts')) {
        allproductsarray = JSON.parse(
          sessionStorage.getItem('allproducts') ?? '[]'
        );
      } else {
        allproductsarray = [];
      }
      let studentPlansremove = JSON.parse(
        sessionStorage.getItem('studentsPlansArray') ?? '[]'
      );
      let studentAllProductArrayremove = JSON.parse(
        sessionStorage.getItem('allproducts') ?? '[]'
      );
      for (let i = 0; i < studentPlansremove.length; i++) {
        if (studentPlansremove[i].name === planname) {
          for (let j = 0; j < studentPlansremove[i].products.length; j++) {
            this.logger.log(studentPlansremove[i].products[j].name);

            this.logger.log(product.name);
            if (studentPlansremove[i].products[j].name === product.name) {
              studentPlansremove.splice(i, 1);
              for (let k = 0; k < studentAllProductArrayremove.length; k++) {
                if (studentAllProductArrayremove[k].id == product.id) {
                  studentAllProductArrayremove.splice(k, 1);

                  // studentPlansremove.splice(i,1);
                }
              }
              sessionStorage.setItem(
                'studentsPlansArray',
                JSON.stringify(studentPlansremove)
              );
              this.logger.log('here');
              sessionStorage.setItem(
                'allproducts',
                JSON.stringify(studentAllProductArrayremove)
              );
            }

            break;
          }
        }
      }

      for (let i = 0; i < studentAllProductArrayremove.length; i++) {
        if (studentAllProductArrayremove[i].name === product.name) {
          studentAllProductArrayremove.splice(i, 1);

          sessionStorage.setItem(
            'allproducts',
            JSON.stringify(studentAllProductArrayremove)
          );
        }
      }
    }
    setTimeout(() => {
      this.logger.log('setTimeout');

      this.allproducts = JSON.parse(
        sessionStorage.getItem('allproducts') ?? '[]'
      );

      var total = this.allproducts.reduce(
        (acc: any, calculatedTax: { total: any }) => {
          return acc + parseFloat(calculatedTax.total);
        },
        0
      );
      this.logger.log(total);
      this.planAmount = this._decimalPipe
        ?.transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      this.cartcheckvalue = this.planAmount > 0 ? true : false;
      if (this.allproducts.length > 0) {
        for (let i = 0; i < this.allproducts.length; i++) {
          if (this.allproducts[i].name == 'Health Plan') {
            this.cartcheckvalue = false;
            //  if (this.paymenttab == 1) {
            //  } else {

            //       this.paymenttab = 0

            //     }
            break;
          } else {
            this.cartcheckvalue = true;
          }
        }
      } else {
        this.cartcheckvalue = true;

        // this.paymenttab = 1
      }
    }, 100);
  }
  public getindexofplan(obj: any) {

    console.log(obj)
    let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    for (let i = 0; i < plansproductarray.length; i++) {
      if (obj.isBundle == false) {
        if (plansproductarray[i].id == obj.id) {

          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                // plan.disabled = false;
              }
            })

          }
          return i;
        }
      } else {
        if (plansproductarray[i].id == obj.id) {
          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                plan.disabled = false;
              }
            })

          }
          return i;
        }
      }
    }
  }
  // public getindexofplan(name: any) {
  //   let plansproductarray = JSON.parse(
  //     sessionStorage.getItem('studentsPlansArray') ?? '[]'
  //   );
  //   for (let i = 0; i < plansproductarray.length; i++) {
  //     this.logger.log(plansproductarray[i].products);
  //     this.logger.log(name);
  //     if (plansproductarray[i].products[0].name == name) {
  //       this.logger.log('Rakesh');
  //       return i;
  //     }
  //   }
  //   return 'false';
  // }
  public unselectplanLife(elementcv: any) {

    // this.planCoverageName = ''
    // this.insuranceplanid =''
    console.log(elementcv)

    let plandetails = elementcv.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryLife(obj);
  }
  public addtoplansummaryLife(obj: any, obj1: any) {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplansLife(obj.id, plansummaryLife.length);
    plansummaryLife.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymainLife = [];
    this.planssummaryopt = [];

    plansummaryLife.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymainLife.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'planssummarymainLife',
      JSON.stringify(this.planssummarymainLife)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    this.planCoverafeFunction();
    if (plansummaryLife.length > 0 || planSummaryData.length > 0) {
      this.plansnexttab = false;
    } else {
      this.plansnexttab = true;
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }
  public removeplansummaryLife(obj: any) {

    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(planSummary);

    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplansLife(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {

        planSummary.splice(index, 1);
        ////this.consoleMessage("afterremove")
        ////this.consoleMessage(planSummary)
      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)

      sessionStorage.setItem('selectedPlansLife', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymainLife = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymainLife.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'planssummarymainLife',
        JSON.stringify(this.planssummarymainLife)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummaryLife', JSON.stringify(planSummary));
      let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

      if (planSummary.length > 0 || planSummaryData.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      this.planCoverafeFunction();
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);
  }
  public addtoslectplansLife(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlansLife', JSON.stringify(selectedPlans));
  }
  public getslectedplansLife(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }
  toggleItem(item: any): void {
    item.expanded = !item.expanded;
  }
  toggleItem1(item: any): void {
    item.expanded = !item.expanded;
  }
  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }
  toggleItem3(item: any): void {
    item.expanded = !item.expanded;
  }



  public isProvincialPlanInc: boolean = true
  public showExtrafeilds: boolean = false

  public landedimmigrantStatus(value) {
    if (value.target.value == "true") {
      this.showlandedimgratestatus = false;
      this.userForm.get('applylandedstaus').clearValidators();
      this.userForm.get('applylandedstaus').updateValueAndValidity();
    } else {
      this.showlandedimgratestatus = true;

      this.userForm.get('applylandedstaus').setValidators(Validators.required);
      this.userForm.get('applylandedstaus').updateValueAndValidity();
    }
    this.logger.log({ show: this.showlandedimgratestatus })
  }

  public spouseinfo(event: any) {

    console.log(event.target.value)
    console.log(typeof event.target.value)
    if (event.target.value == "true") {
      this.spouseinformation = true;
      if (this.showExtrafeilds) {
        this.showlandeddependentDetails = true
        this.userForm.get('coverageRequiredOfDependents').setValidators(Validators.required);
      }


      this.userForm.get('spousefirstname')?.reset();
      this.userForm.get('spousefirstname')?.clearValidators();
      this.userForm.get('spousefirstname')?.setValidators(Validators.compose([Validators.required, Validators.minLength(1),
        // Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")
      ]));
      this.userForm.get('spouselastname')?.reset();
      this.userForm.get('spouselastname')?.clearValidators();
      this.userForm.get('spouselastname')?.setValidators(Validators.compose([Validators.required, Validators.minLength(1),
        // Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")
      ]))
      this.userForm.get('spousegender')?.reset();
      this.userForm.get('spousegender')?.clearValidators();
      this.userForm.get('spousegender')?.setValidators([Validators.required]);

      // this.userForm.get('spousedateofbirth')?.reset();
      this.userForm.get('spousedateofbirth')?.clearValidators();
      this.userForm.get('spousedateofbirth')?.setValidators(Validators.compose([Validators.required]));

      this.userForm.get('spousehealthcard')?.reset();
      this.userForm.get('spousehealthcard')?.clearValidators();
      this.userForm.get('spousehealthcard')?.setValidators([Validators.required]);

    } else {
      if (!this.childrenhealthinformation) {
        this.showlandeddependentDetails = false
        $("#coverageRequiredOfDependentsno").click();
        this.userForm.get('coverageRequiredOfDependents').reset();
        this.userForm.get('dependentdateOfArrival').reset();
        this.userForm.get('dependentcountryOrigin').reset();
        this.userForm.get('dependentLandedImigrant').reset();
        this.userForm.get('dependentapplylandedstaus').reset();
        this.userForm.get('dependentMorethan3years').reset();
        this.userForm.get('coverageRequiredOfDependents').clearValidators();
        this.userForm.get('coverageRequiredOfDependents').updateValueAndValidity();
      }
      this.logger.log(this.childrenhealthinformation)

      this.spouseinformation = false;
      this.spousehealthcardinfo = false;
      this.userForm.get('spousefirstname')?.reset();
      this.userForm.get('spousefirstname')?.clearValidators();
      this.userForm.get('spousefirstname')?.updateValueAndValidity();

      this.userForm.get('spouselastname')?.reset();
      this.userForm.get('spouselastname')?.clearValidators();
      this.userForm.get('spouselastname')?.updateValueAndValidity();

      this.userForm.get('spousegender')?.reset();
      this.userForm.get('spousegender')?.clearValidators();
      this.userForm.get('spousegender')?.updateValueAndValidity();

      // this.userForm.get('spousedateofbirth')?.reset();
      this.userForm.get('spousedateofbirth')?.clearValidators();
      this.userForm.get('spousedateofbirth')?.updateValueAndValidity();

      this.userForm.get('spousehealthcard')?.reset();
      this.userForm.get('spousehealthcard')?.clearValidators();
      this.userForm.get('spousehealthcard')?.updateValueAndValidity();

    }
  }

  public havingchildren(event: any) {
    this.logger.log("havingchildren: ");
    if (event.target.value == "true") {
      this.childrenhealthinformation = true;
      this.logger.log(this.noOfChildrenChangedValue);
      this.userForm.get('noofchildren').setValue(this.noOfChildrenChangedValue);
      console.log(this.showExtrafeilds)

      if (this.showExtrafeilds == true) {
        this.showlandeddependentDetails = true;
        this.userForm.get('coverageRequiredOfDependents').setValidators(Validators.required);
        this.logger.log(this.userForm.controls)
      }

      // this.userForm.get('childrenDetails')?.clearValidators();
      // this.userForm.get('childrenDetails')?.updateValueAndValidity();
    } else {
      this.childrenhealthinformation = false;
      // this.logger.log(!this.userForm.value.havingspouse || this.userForm.value.havingspouse == null)
      // this.logger.log("dependentstatus", this.showlandeddependentDetails)
      console.log(this.userForm.controls)

      if (this.userForm.value.havingspouse == "false" || this.userForm.value.havingspouse == null) {
        console.log(this.userForm.value.havingspouse)
        this.showlandeddependentDetails = false;
      }

      this.childInfoAddDataArray.shift();
      this.childTableRowsLength = this.childInfoAddDataArray.length;

      this.userForm.get('noofchildren')?.clearValidators();
      this.userForm.get('noofchildren')?.updateValueAndValidity();
      $("#coverageRequiredOfDependentsno").click();

      this.userForm.get('coverageRequiredOfDependents').reset();
      this.userForm.get('dependentdateOfArrival').reset();
      this.userForm.get('dependentcountryOrigin').reset();
      this.userForm.get('dependentLandedImigrant').reset();
      this.userForm.get('dependentapplylandedstaus').reset();
      this.userForm.get('dependentMorethan3years').reset();
      this.userForm.get('coverageRequiredOfDependents').clearValidators();
      this.userForm.get('coverageRequiredOfDependents').updateValueAndValidity();

    }
    // this.logger.log(this.userForm.value.childrenDetails)
  }

  public dependentCoverage(value) {
    if (value.target.value == "true") {
      this.showdependentdetails = true;
      this.userForm.get('dependentdateOfArrival').setValidators(Validators.required);
      this.userForm.get('dependentLandedImigrant').setValidators(Validators.required);
      this.userForm.get('dependentMorethan3years').setValidators(Validators.required);
      this.userForm.get('dependentcountryOrigin').setValidators(Validators.required);

    } else {
      this.showdependentdetails = false;
      this.userForm.get('dependentdateOfArrival').clearValidators();
      this.userForm.get('dependentdateOfArrival').updateValueAndValidity();


      this.userForm.get('dependentLandedImigrant').clearValidators();
      this.userForm.get('dependentLandedImigrant').updateValueAndValidity();

      this.userForm.get('dependentapplylandedstaus').clearValidators();
      this.userForm.get('dependentapplylandedstaus').updateValueAndValidity();


      this.userForm.get('dependentMorethan3years').clearValidators();
      this.userForm.get('dependentMorethan3years').updateValueAndValidity();

      this.userForm.get('dependentcountryOrigin').clearValidators();
      this.userForm.get('dependentcountryOrigin').updateValueAndValidity();
      // this.checkhealthcardstatus = true;
    }
  }

  public dependentLandedImigrant(value) {
    if (value.target.value == "true") {
      this.showdependentlandedstatus = false;
      this.userForm.get('dependentapplylandedstaus').clearValidators();
      this.userForm.get('dependentapplylandedstaus').updateValueAndValidity();

    } else {
      this.showdependentlandedstatus = true;

      this.userForm.get('dependentapplylandedstaus').setValidators(Validators.required);
    }
  }
  clearPHRValidators() {
    this.userForm.get('dateOfArrival').clearValidators();
    this.userForm.get('dateOfArrival').updateValueAndValidity();
    this.userForm.get('isEmployeeImigrant').clearValidators();
    this.userForm.get('isEmployeeImigrant').updateValueAndValidity();
    this.userForm.get('applylandedstaus').clearValidators();
    this.userForm.get('applylandedstaus').updateValueAndValidity();
    this.userForm.get('countryOrigin').clearValidators();
    this.userForm.get('countryOrigin').updateValueAndValidity();
    this.userForm.get('coverageRequiredOfEmployee').clearValidators();
    this.userForm.get('coverageRequiredOfEmployee').updateValueAndValidity();
  }

  // provincialhealth(e: any) {
  //   if (e.target.value == "false") {
  //     if (!this.isProvincialPlanInc) {
  //       this.checkhealthcardstatus = true;
  //       $('#checkuhipstatusModal').modal('show');
  //       this.clearPHRValidators()
  //     }
  //     else {
  //       this.showExtrafeilds = true
  //       if (this.childrenhealthinformation) {
  //         this.showlandeddependentDetails = true //dependent covergae
  //       }
  //       this.userForm.get('dateOfArrival').setValidators(Validators.required);
  //       this.userForm.get('isEmployeeImigrant').setValidators(Validators.required);
  //       this.userForm.get('countryOrigin').setValidators(Validators.required);
  //       this.userForm.get('coverageRequiredOfEmployee').setValidators(Validators.required);
  //     }
  //   } else {
  //     this.checkhealthcardstatus = false
  //     this.showExtrafeilds = false
  //     this.showlandeddependentDetails = false
  //     this.clearPHRValidators()

  //   }


  public checkchildDob(event: any) {
    if (event.target.value == "Invalid date") {
      this.childFormGroup.get('childInfoDOB').reset();
      this.childFormGroup.get('childInfoDOB').markAsTouched();
    }

  }
  public checkDateOfBirth(event: any) {
    const inputDate = new Date(event.target.value);
    console.log(event.target.value)
    if (event.target.value == "Invalid date") {
      this.userForm.controls["dateofbirth"].reset();
      this.userForm.controls["dateofbirth"].markAsTouched();
    }

    // if (inputDate.getTime() === this.maxDate.getTime()) {
    //   inputDate.setDate(inputDate.getDate() - 1);
    // }

    // this.userForm.controls["dateofbirth"].setValue(inputDate);


  }

  public checkDateOfHire(event: any) {
    if (event.target.value == "Invalid date") {
      this.userForm.controls["dateofhire"].reset();
      this.userForm.controls["dateofhire"].markAsTouched();
    }
  }
  public checkDateOfArrival(event: any) {
    if (event.target.value == "Invalid date") {
      this.userForm.controls["dateOfArrival"].reset();
      this.userForm.controls["dateOfArrival"].markAsTouched();
    }
  }
  public checkSpouseDateofBirth(event: any) {
    const inputDate = new Date(event.target.value);
    if (event.target.value == "Invalid date") {
      this.userForm.get("spousedateofbirth").reset();
      this.userForm.get("spousedateofbirth").markAsTouched();
    }

    // if (inputDate.getTime() === this.maxDate.getTime()) {
    //   inputDate.setDate(inputDate.getDate() - 1);
    //   console.log('Decreased Input Date:', inputDate);
    // }

    // this.userForm.controls["spousedateofbirth"].setValue(inputDate);
  }
  public checkDateOfADependentArrival(event: any) {
    if (event.target.value == "Invalid date") {
      this.userForm.controls["dependentdateOfArrival"].reset();
      this.userForm.controls["dependentdateOfArrival"].markAsTouched();
    }
  }
  public checkDateOfgraducation(event: any) {
    if (event.target.value == "Invalid date") {
      this.childFormGroup.get('childInfoGraduationday').reset();
      this.childFormGroup.get('childInfoGraduationday').markAsTouched();
    }
  }
  numbersOnly(event) {
    const key = event.key || String.fromCharCode(event.keyCode);
    console.log({ key },event.target.value)
    // Check if the key is an alphabetical character (A-Z or a-z) or a space
    if (/(^[0-9 \-]+$)/.test(key)) {
      return true;
    } else {
      return false;
    }
  }
  public provincialhealth(event: any) {

    if (event.target.value == 'true') {

      this.checkhealthcardstatus = false
      this.showExtrafeilds = false
      this.showlandeddependentDetails = false
      this.clearPHRValidators()
    } else {
      if (!this.isStudent) {
        if (!this.isProvincialPlanInc) {
          this.checkhealthcardstatus = true;
          $('#checkuhipstatusModal').modal('show');
          $('#checkuhipstatusModalStudent').modal('hide');
          this.clearPHRValidators()
          this.userForm.get('provincialhealth').setValidators(Validators.required);
        }
        else {
          this.checkhealthcardstatus = false;
          this.showExtrafeilds = true
          if (this.childrenhealthinformation) {
            this.showlandeddependentDetails = true
            this.userForm.get('coverageRequiredOfDependents').setValidators(Validators.required);

          }
          this.userForm.get('provincialhealth')?.clearValidators();
          this.userForm.get('provincialhealth')?.updateValueAndValidity();
          this.userForm.get('dateOfArrival').setValidators(Validators.required);
          this.userForm.get('isEmployeeImigrant').setValidators(Validators.required);
          this.userForm.get('countryOrigin').setValidators(Validators.required);
          this.userForm.get('coverageRequiredOfEmployee').setValidators(Validators.required);
        }

      }
      else {
        this.logger.log('Student')
        $('#checkuhipstatusModal').modal('hide');
        $('#checkuhipstatusModalStudent').modal('show');
        this.checkhealthcardstatus = true;
      }

      this.logger.log('false no');


    }

  }

  pipeFunction = (
    a: KeyValue<string, [string]>,
    b: KeyValue<string, [string]>
  ): number => {
    return 0;
  };

  public paymentpage(tabId: number) {


    if (this.isCorporate == true) {
      // this.logger.log(this.planAmount, "PlanAmount")
      // this.plansError = this.planAmount == 0.00 ? true : false
      // if (this.plansError) {
      //   return
      // }

      // this.paymentfirstname = this.userFormControl?.['givenname'].value;
      // this.paymentfirstname = this.userFormControl?.['lastname'].value;
      // this.paymentemail = this.userFormControl?.['email'].value.toLowerCase();
      // let endPoint = `/api/ap/customer/validatePlans`;
      // let url = `${environment.apiUrl}${endPoint}`;
      // let data: any = [];
      // var accessToken = sessionStorage.getItem('accessToken');


      // let plansMain = sessionStorage.getItem("allSelectedPlans") ? JSON.parse(sessionStorage.getItem("allSelectedPlans") || '') : []
      // let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
      // data = { plans: plansMain.concat(plansLife) };

      // console.log(data)
      // // let ifPhr = this.specialpackages.filter((pack: any) => (pack.id == 10))
      // // let phrPlanSelected = data.plans.filter((p: any) => (p.packageId == 10))
      // // let healthPlanSelected = data.plans.filter((p: any) => (p.packageId == 1))
      // // console.log(ifPhr, phrPlanSelected, healthPlanSelected)
      // // if (ifPhr.length > 0 && phrPlanSelected.length <= 0) {
      // //   if (healthPlanSelected.length > 0) {
      // //     Swal.fire({
      // //       title: this.lang.Info,
      // //       text: "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan.",
      // //     })
      // //     console.log("entering")
      // //     return
      // //   }
      // //   else {
      // //     Swal.fire({
      // //       title: this.lang.Info,
      // //       text: "Please select a Provincial Health Replacement Plan.",
      // //     })
      // //     console.log("entering")
      // //     return
      // //   }

      // // }


      // this.http
      //   .post(url, data, {
      //     headers: {
      //       Authorization: 'Bearer ' + accessToken,
      //       'Content-Type': 'application/json',
      //     },
      //   })
      //   .subscribe(
      //     (Response: any) => {
      //       if (Response.status == '200') {
      //         this.homeaddresscheckvalue = false;
      //         this.homeaddressEnrollmentVal = false;
      //         let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
      //         let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []

      //         this.planssummarymain = plansMain.concat(plansLife)

      //         this.planssummaryopt = JSON.parse(
      //           sessionStorage.getItem('plansummaryopt') ?? '[]'
      //         );

      //         let healthplan = [];
      //         let healthplanvol = [];
      //         this.studentplanssummarymain =
      //           JSON.parse(
      //             sessionStorage.getItem('plansummarymain') ?? '[]'
      //           ).sort((a: { id: any }, b: { id: any }) => a.id - b.id) || '';

      //         const combinedArray = [];
      //         const groupedByParent: any = {};

      //         for (const obj of this.studentplanssummarymain) {
      //           const name = obj.name;

      //           const products = obj.products;
      //           if (!groupedByParent[name]) {
      //             groupedByParent[name] = [];
      //           }
      //           groupedByParent[name] = groupedByParent[name].concat(products);
      //         }

      //         for (const name in groupedByParent) {
      //           combinedArray.push({ name, products: groupedByParent[name] });
      //         }
      //         if (this.isStudent)
      //           this.planssummarymain = JSON.parse(sessionStorage.getItem('studentsPlansArray'))
      //         else {
      //           let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
      //           let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []

      //           this.planssummarymain = plansMain.concat(plansLife)
      //           this.planssummarymain = this.planssummarymain.sort((a, b) => a.packageId - b.packageId) || "";
      //           this.finalenrollemntsummary = this.planssummarymain
      //           this.studentplanssummarymain1 = combinedArray;
      //         }
      //         setTimeout(() => {
      //           if (this.isStudent) {
      //             this.allproducts = JSON.parse(
      //               sessionStorage.getItem('allproducts') ?? '[]'
      //             );
      //             var total = 0;
      //             for (let i = 0; i < this.allproducts.length; i++) {
      //               total += this.allproducts[i].calculatedTax?.total;
      //             }
      //             this.logger.log(total);
      //             this.planAmount = this._decimalPipe
      //               ?.transform(total, '1.2-2')
      //               ?.replace(/,/g, '');
      //             sessionStorage.setItem('totalAmount', this.planAmount);
      //             this.cartcheckvalue = this.planAmount > 0 ? true : false;
      //           } else {
      //             let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
      //             let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []

      //             this.allproducts = plansMain.concat(plansLife)
      //             var total = 0;
      //             for (let i = 0; i < this.allproducts.length; i++) {
      //               total += this.allproducts[i].total;
      //             }
      //             console.log("totalAmount" + total);
      //             this.planAmount = this._decimalPipe
      //               ?.transform(total, '1.2-2')
      //               ?.replace(/,/g, '');
      //             sessionStorage.setItem('totalAmount', this.planAmount);
      //             this.cartcheckvalue = this.planAmount > 0 ? true : false;
      //           }

      //           // alert(this.planAmount)
      //         }, 1000);
      //         this.savedGs = false;
      //         this.savedEq = false;
      //         this.savedCw = false;
      //         this.savedKIX = false;
      //         this.savedWADDELL = false;
      //         this.gsPlans = Response.data.gsPlans;
      //         this.eqPlans = Response.data.eqPlans;
      //         this.cwPlans = Response.data?.phrPlan;
      //         this.kixPlans = Response.data?.kixcarePlan;
      //         this.waddellPlans = Response.data?.waddellPlan;

      //         //iS replated to greenShield plans

      //         if (this.gsPlans) {
      //           this.showGreenShiled = false;
      //           this.greenShiledForm.reset();
      //           $('#gsPlans').show();

      //         } else if (this.eqPlans) {
      //           this.showEquitable = false;
      //           this.EquitableForm.reset();
      //           $('#eqPlans').show();
      //         }
      //         else {
      //           this.gsRegistration = false;
      //           this.gsPlans = false;
      //           this.gsMembershipId = '';
      //           this.eqRegistration = false;
      //           this.eqPlans = false
      //           this.eqCertificateId = '';
      //         }

      //         if (this.cwPlans) {
      //           this.showCowan = false;
      //           this.cowanForm.reset();
      //           $('#cwPlans').show();
      //         }
      //         else {
      //           this.cwRegistraion = false;
      //           this.cwPlans = false
      //           this.cwCertificateId = '';

      //         }

      //         if (this.kixPlans) {
      //           this.showKixcarePlans = false;
      //           this.KixCareForm.reset();

      //           $('#kixPlans').show();

      //         }
      //         else {
      //           this.kixRegistration = false;
      //           this.kixPlans = false
      //           // this.kixCertificateId = '';
      //         }
      //         if (this.waddellPlans) {
      //           this.showWaddellPlans = false;
      //           this.waddellPlanForm.reset();

      //           $('#waddellPlans').show();

      //         }
      //         else {
      //           this.waddellRegistration = false;
      //           this.waddellPlans = false
      //           // this.kixCertificateId = '';
      //         }

      //         if (!this.gsPlans && !this.eqPlans && !this.cwPlans && !this.kixPlans && !this.waddellPlans) {
      //           this.selectedTab = "tab3"
      //         }
      //         console.log(this.selectedTab)
      //         // this.isCowanPresent = this.cwPlans && this.savedCw;
      //         // this.isHealthPresent = (this.gsPlans && this.savedGs) || (this.eqPlans && this.savedEq);

      //         // if ((this.gsPlans || this.eqPlans || this.cwPlans) && (this.isHealthPresent || this.isCowanPresent)) {
      //         //   this.selectedTab = 'tab3';
      //         // }



      //         setTimeout(() => {
      //           this.signaturePadCC = new SignaturePad(
      //             this.signaturePadCanvasEl?.nativeElement
      //           );
      //           this.padAggsignaturePadCC = new SignaturePad(
      //             this.padAgreementSignaturePadCanvasEl?.nativeElement
      //           );
      //         }, 1000);

      //         this.enrollmentForm.reset();
      //         // this.creditCardForm.reset();
      //         this.enrollmentForm
      //           .get('enrollmentSummaryExpirymonth')
      //           ?.setValue('');
      //         this.enrollmentForm
      //           .get('enrollmentSummaryExpiryyear')
      //           ?.setValue('');
      //         this.bankPayForm.reset();
      //         this.paymentMethodSelectCC = true;
      //         this.enrollmentBankDetailedVerify = false;
      //         this.bankDetailsNames = '';
      //         const elements =
      //           this.elementRef.nativeElement.getElementsByClassName(
      //             'imgdisplay2'
      //           );
      //         for (let i = 0; i < elements.length; i++) {
      //           elements[i].style.display = 'block';
      //           elements[i].style.display = 'inline';
      //         }
      //         sessionStorage.setItem('paymentMethod', 'CC');
      //         this.logger.log('***********tab3: ' + this.studentplanssummarymain1);

      //         this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
      //           this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
      //             "message": "Corporates information has been updated. Please refresh screen."
      //           }, {
      //             headers: {
      //               Authorization: 'Bearer ' + accessToken,
      //               'Content-Type': 'application/json',
      //             }
      //           }).subscribe((res) => {
      //             console.log({ res })
      //           })
      //         })

      //         // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
      //         //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
      //         //     "message": "Corporates information has been updated. Please refresh screen."
      //         //   }, { headers: {
      //         //     Authorization: 'Bearer ' + accessToken,
      //         //     'Content-Type': 'application/json',
      //         //   } }).subscribe((res)=>{
      //         //     console.log({res})
      //         //   })
      //         // })

      //       } else {
      //         Swal.fire({ title: this.lang.Info, text: Response.data.message })
      //       }
      //     },
      //     (error) => {
      //       if (error.value) {
      //         Swal.fire({ title: this.lang.Error??'Error', text: error.error });
      //         // this.router.navigate(["error"]);
      //       } else {
      //         Swal.fire({ title: this.lang.Error??'Error', text: error.error });
      //       }
      //     }
      //   );
      let benficiryData = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]');
      let inputData = JSON.parse(sessionStorage.getItem('Data') || '[]');
      let Data = JSON.parse(sessionStorage.getItem('plansummarymain') || '[]');
      let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
      let phrPlanSelected = Data.filter((p: any) => p.packageId == 10);
      let healthPlanSelected = Data.filter((p: any) => p.packageId == 1);
      let iafgDataSelectedPlan = iafgData.filter((p: any) => p.packageId == 13);
      let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);
      let benficiaryList = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]')
      this.paymentemail = inputData.email || this.userForm.get('email')?.value
      this.paymentfirstname = this.capitalize(inputData.firstName) || this.userForm.get('firstName')?.value;
      this.paymentlastName = this.capitalize(inputData.lastName) || this.userForm.get('lastName')?.value

      let iafgTermplanSpouseCheck = iafgData.filter((p: any) => p.coverage == 'MEMBER & SPOUSE');


      let completeExecutiveplan = Data.filter((p: any) => p.planLevel == 18);
      let lavieplancheck = Data.filter((p: any) => p.planproductname.includes("La Vie"));
      // alert(this.FormbrokerType)

      if (completeExecutiveplan.length > 0) {
        if (completeExecutiveplan && completeExecutiveplan[0].options && completeExecutiveplan[0].options.length > 0) {

        } else {
          // this.planOptionsModel = true
          this.showoptions = true;
          $('#showplanoptions-modal').modal('show');

          return false
        }
      }

      if (lavieplancheck && lavieplancheck.length > 0) {
        if (completeExecutiveplan && completeExecutiveplan.length > 0) {

        }
        else {
          Swal.fire({
            title: this.lang.Info,
            text: "Select Complete Executive Care Plan along with La Vie"
          })
          return false
        }

      }
      if (iafgTermplanCheck && iafgTermplanCheck.length > 0) {

        if (this.addbenificaryData.length > 0) {
          this.benficiary = false;

          const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
            const compositeKey = `${obj.customerType}_${obj.type}`;
            if (!acc[compositeKey]) {
              acc[compositeKey] = 0;
            }
            acc[compositeKey] += parseFloat(obj.percentage);
            return acc;
          }, {});

          let beneficiaryError = "";
          for (const key in validateBeneficiaries) {
            if (validateBeneficiaries.hasOwnProperty(key)) {
              const [customerType, type] = key.split("_");
              //console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

              if (validateBeneficiaries[key] != 100) {
                beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
              }
            }
          }




          if (beneficiaryError != "") {
            this.benficiaryCount = true
            this.benficiaryCountMessage = "Distributed percentages must equal 100%, and not more"
            return false;
          }

          else {
            this.benficiary = false
            if (iafgTermplanSpouseCheck.length > 0) {

              if (sessionStorage.getItem("Spousesignature") || "") {
                // this.gotosumamrypageLogic()
              } else {
                this.showSpouseSignature = true
                // this.signatureNeeded = this.signaturePad.isEmpty();


              }
            }
          }


        }


        else {
          this.benficiary = true;
          if (this.addbenificaryData.length > 0) {

          } else {
            this.showBenificiaryForm = true
          }


          return false;

        }

      } else {
        this.addbenificaryData = []
        // this.gotosumamrypageLogic()
      }
      if (inputData.provincial_health_coverage == false) {

        if (phrPlanSelected.length > 0) {
          if (healthPlanSelected.length > 0) {
            if (iafgDataSelectedPlan.length > 0) {

              if (healthPlanSelected.length > 0) {

                if (iafgTermplanCheck.length > 0) {

                  var total = 0;
                  for (let i = 0; i < benficiryData.length; i++) {
                    total += parseFloat(benficiryData[i].percentage);
                  }

                  if (!this.beneficiaryError) {
                    this.benficiary = false
                    this.showbenificaryTable = false;
                    this.gotosumamrypageLogic()
                  } else {
                    this.benficiary = true
                    this.showbenificaryTable = true;
                    this.showaddmorebenficiary = true;

                  }

                }
                else {
                  this.gotosumamrypageLogic()
                }



              }
              else {
                Swal.fire({ title: this.lang.Info, text: "Please select a Health & Dental Insurance Plan along with a Life or Critical Insurance Plan." })

              }
            }
            else {
              this.gotosumamrypageLogic()
            }
          }
          else {
            Swal.fire({ title: this.lang.Info, text: "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan." })


          }

        }


        else {
          if (healthPlanSelected.length > 0) {
            Swal.fire({ title: this.lang.Info, text: "Please select a Provincial Health Replacement Plan." })



          }
          else {
            Swal.fire({ title: this.lang.Info, text: "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan." })

          }


        }
      }
      else {

        if (iafgDataSelectedPlan.length > 0) {

          if (healthPlanSelected.length > 0) {

            if (iafgTermplanCheck.length > 0) {

              var total = 0;
              for (let i = 0; i < benficiryData.length; i++) {
                total += parseFloat(benficiryData[i].percentage);
              }

              if (!this.beneficiaryError) {
                this.benficiary = false
                this.showbenificaryTable = false;


                this.gotosumamrypageLogic()
              } else {
                this.benficiary = true
                this.showbenificaryTable = true;
                this.showaddmorebenficiary = true;

              }

            }
            else {

              this.gotosumamrypageLogic()
            }



          }
          else {
            // this.ShowModelPopup = true
            // this.ShowModelPopupMessage = this.lang.Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan;
            // this.ShowModelPopupTitle = this.lang.Info
            this.gotosumamrypageLogic()
          }
        }
        else {
          this.gotosumamrypageLogic()
        }

      }
    }
    else {

      let endPoint = `/api/ap/customer/validatePlans`;
      let url = `${environment.apiUrl}${endPoint}`;
      let data: any = [];
      var accessToken = sessionStorage.getItem('accessToken');
      if (this.isStudent) {
        data = {
          plans: JSON.parse(sessionStorage.getItem('studentsPlansArray')),
        };
      } else {
        let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
        let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
        data = { plans: plansMain.concat(plansLife) };


      }
      this.logger.log(this.planAmount, "PlanAmount")
      this.plansError = this.planAmount == 0.00 ? true : false
      if (this.plansError) {
        return
      }

      this.paymentfirstname = this.userFormControl?.['givenname'].value;
      this.paymentfirstname = this.userFormControl?.['lastname'].value;
      this.paymentemail = this.userFormControl?.['email'].value.toLowerCase();

      console.log(data)
      let ifPhr = this.specialpackages.filter((pack: any) => (pack.id == 10))
      let phrPlanSelected = data.plans.filter((p: any) => (p.packageId == 10))
      let healthPlanSelected = data.plans.filter((p: any) => (p.packageId == 1))
      let iafgTermplanCheck = data.plans.filter((p: any) => p.planLevel == 44);
      let iafgDataSelectedPlan = data.plans.filter((p: any) => p.packageId == 13);
      let inputData = JSON.parse(sessionStorage.getItem('Data') || '[]');
      let completeExecutiveplan = data.plans.filter((p: any) => p.planLevel == 18);
      let lavieplancheck = data.plans.filter((p: any) => p.planproductname.includes("La Vie"));
      // alert(this.FormbrokerType)

      if (completeExecutiveplan.length > 0) {
        if (completeExecutiveplan && completeExecutiveplan[0].options && completeExecutiveplan[0].options.length > 0) {

        } else {
          // this.planOptionsModel = true
          // alert("1")
          this.showoptions = true;
          $('#showplanoptions-modal').modal('show');

          return false
        }
      }

      if (lavieplancheck && lavieplancheck.length > 0) {
        if (completeExecutiveplan && completeExecutiveplan.length > 0) {

        }
        else {


          Swal.fire({
            title: this.lang.Info,
            text: "Select Complete Executive Care Plan along with La Vie"
          })
          return false
        }

      }
      if (inputData.waddell != true && this.FormbrokerType != "ASSOCIATION") {
        if (inputData.provincial_health_coverage == false) {

          if (phrPlanSelected.length > 0) {
            if (healthPlanSelected.length > 0) {
              if (iafgDataSelectedPlan.length > 0) {

                if (healthPlanSelected.length > 0) {

                  if (iafgTermplanCheck.length > 0) {
                    this.gotosumamrypageLogic()
                    // var total = 0;
                    // for (let i = 0; i < benficiryData.length; i++) {
                    //   total += parseFloat(benficiryData[i].percentage);
                    // }

                    // if(!this.beneficiaryError){
                    //   this.benficiary =false
                    //   this.showbenificaryTable =false;
                    //   this.gotosumamrypageLogic()
                    // }else{
                    //   this.benficiary =true
                    //   this.showbenificaryTable=true;
                    //   this.showaddmorebenficiary =true;

                    // }

                  }
                  else {
                    this.gotosumamrypageLogic()
                  }



                }
                else {
                  Swal.fire({
                    title: this.lang.Info,
                    text: this.lang.Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan,
                  })
                  console.log("entering")
                  return

                }
              }
              else {
                this.gotosumamrypageLogic()
              }
            }
            else {
              Swal.fire({
                title: this.lang.Info,
                text: this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan,
              })
              console.log("entering")
              return
            }

          }


          else {
            if (healthPlanSelected.length > 0) {


              Swal.fire({
                title: this.lang.Info,
                text: this.lang.Please_select_a_Provincial_Health_Replacement_Plan,
              })
              console.log("entering")
              return
            }
            else {
              Swal.fire({
                title: this.lang.Info,
                text: this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan,
              })
              console.log("entering")
              return
            }


          }
        }
        else {

          if (iafgDataSelectedPlan.length > 0) {

            if (healthPlanSelected.length > 0) {

              if (iafgTermplanCheck.length > 0) {
                this.gotosumamrypageLogic()
                // var total = 0;
                // for (let i = 0; i < benficiryData.length; i++) {
                //   total += parseFloat(benficiryData[i].percentage);
                // }

                // if(!this.beneficiaryError){
                //   this.benficiary =false
                //   this.showbenificaryTable =false;



                // }else{
                //   this.benficiary =true
                //   this.showbenificaryTable=true;
                //   this.showaddmorebenficiary =true;

                // }

              }
              else {

                this.gotosumamrypageLogic()
              }



            }
            else {
              Swal.fire({
                title: this.lang.Info,
                text: this.lang.Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan,
              })
              console.log("entering")
              return
            }
          }
          else {
            this.gotosumamrypageLogic()
          }

        }
      }
      else {
        this.gotosumamrypageLogic()
      }


      // if (ifPhr.length > 0 && phrPlanSelected.length <= 0) {
      //   if (healthPlanSelected.length > 0) {
      //     Swal.fire({
      //       title: this.lang.Info,
      //       text: this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan,
      //     })
      //     console.log("entering")
      //     return
      //   }
      //   else {
      //     Swal.fire({
      //       title: this.lang.Info,
      //       text: this.lang.Please_select_a_Provincial_Health_Replacement_Plan,
      //     })
      //     console.log("entering")
      //     return
      //   }

      // }



    }

    //  $("#planSelectionInfo").css("display", "block");
    // $('#personalinfocheck').css("dispaly","none");
  }


  gotosumamrypageLogic() {
    let endPoint = `/api/ap/customer/validatePlans`;
    let url = `${environment.apiUrl}${endPoint}`;
    let data: any = [];
    var accessToken = sessionStorage.getItem('accessToken');
    if (this.isStudent) {
      data = {
        plans: JSON.parse(sessionStorage.getItem('studentsPlansArray')),
      };
    } else {
      let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
      let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
      data = { plans: plansMain.concat(plansLife) };


    }
    this.http
      .post(url, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (Response: any) => {
          if (Response.status == '200') {
            this.homeaddresscheckvalue = false;
            this.homeaddressEnrollmentVal = false;
            this.planssummarymain =
              JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]') ||
              '';
            this.planssummaryopt = JSON.parse(
              sessionStorage.getItem('plansummaryopt') ?? '[]'
            );

            let healthplan = [];
            let healthplanvol = [];
            this.studentplanssummarymain =
              JSON.parse(
                sessionStorage.getItem('plansummarymain') ?? '[]'
              ).sort((a: { id: any }, b: { id: any }) => a.id - b.id) || '';

            const combinedArray = [];
            const groupedByParent: any = {};

            for (const obj of this.studentplanssummarymain) {
              const name = obj.name;

              const products = obj.products;
              if (!groupedByParent[name]) {
                groupedByParent[name] = [];
              }
              groupedByParent[name] = groupedByParent[name].concat(products);
            }

            for (const name in groupedByParent) {
              combinedArray.push({ name, products: groupedByParent[name] });
            }
            if (this.isStudent)
              this.planssummarymain = JSON.parse(sessionStorage.getItem('studentsPlansArray'))
            else {
              let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
              let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
              this.planssummarymain = plansMain.concat(plansLife)
              this.planssummarymain = this.planssummarymain.sort((a, b) => a.packageId - b.packageId) || "";
              this.finalenrollemntsummary = this.planssummarymain
              this.studentplanssummarymain1 = combinedArray;
            }
            setTimeout(() => {
              if (this.isStudent) {
                this.allproducts = JSON.parse(
                  sessionStorage.getItem('allproducts') ?? '[]'
                );
                var total = 0;
                for (let i = 0; i < this.allproducts.length; i++) {
                  total += this.allproducts[i].calculatedTax?.total;
                }
                this.logger.log("totalAmount" + total);
                this.planAmount = this._decimalPipe
                  ?.transform(total, '1.2-2')
                  ?.replace(/,/g, '');
                sessionStorage.setItem('totalAmount', this.planAmount);
                this.cartcheckvalue = this.planAmount > 0 ? true : false;
              } else {
                let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
                let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
                this.allproducts = plansMain.concat(plansLife)
                // this.allproducts = JSON.parse(
                //   sessionStorage.getItem('plansummarymain') ?? '[]'
                // );
                var total = 0;
                for (let i = 0; i < this.allproducts.length; i++) {
                  total += this.allproducts[i].total;
                }
                this.logger.log("totalAmount" + total);
                this.planAmount = this._decimalPipe
                  ?.transform(total, '1.2-2')
                  ?.replace(/,/g, '');
                sessionStorage.setItem('totalAmount', this.planAmount);
                this.cartcheckvalue = this.planAmount > 0 ? true : false;
              }

              // alert(this.planAmount)
            }, 1000);
            this.savedGs = false;
            this.savedEq = false;
            this.savedCw = false;
            this.savedKIX = false;
            this.savedWADDELL = false;
            this.gsPlans = Response.data.gsPlans;
            this.eqPlans = Response.data.eqPlans;
            this.cwPlans = Response.data?.phrPlan;
            this.kixPlans = Response.data?.kixcarePlan;
            this.flexPlans = Response.data?.flexgsPlan;
            this.waddellPlans = Response.data?.waddellPlan
            //iS replated to greenShield plans

            if (this.gsPlans) {
              this.showGreenShiled = false;
              this.greenShiledForm.reset();
              $('#gsPlans').show();

            } else if (this.eqPlans) {
              this.showEquitable = false;
              this.EquitableForm.reset();
              $('#eqPlans').show();
            }
            else {
              this.gsRegistration = false;
              this.gsPlans = false;
              this.gsMembershipId = '';
              this.eqRegistration = false;
              this.eqPlans = false
              this.eqCertificateId = '';
            }

            if (this.cwPlans) {
              this.showCowan = false;
              this.cowanForm.reset();
              $('#cwPlans').show();
            }
            else {
              this.cwRegistraion = false;
              this.cwPlans = false
              this.cwCertificateId = '';

            }

            if (this.kixPlans) {
              this.showKixcarePlans = false;
              this.KixCareForm.reset();
              $('#kixPlans').show();
            }
            else {
              this.kixRegistration = false;
              this.kixPlans = false
              // this.kix = '';

            }

            if (this.waddellPlans) {

              this.showWaddellPlans = false;
              this.waddellPlanForm.reset();

              $('#waddellPlans').show();

            }
            else {
              this.waddellRegistration = false;
              this.waddellPlans = false
              // this.kixCertificateId = '';
            }
            if (this.flexPlans) {
              this.showFlexPlans = false;
              this.FlexForm.reset();

              $('#flexPlans').show();

            }
            else {
              this.flexRegistration = false;
              this.flexPlans = false
              // this.kixCertificateId = '';
            }



            if (!this.gsPlans && !this.eqPlans && !this.cwPlans && !this.kixPlans && !this.waddellPlans && !this.flexPlans) {
              this.selectedTab = "tab3"
            }
            console.log(this.selectedTab)
            // this.isCowanPresent = this.cwPlans && this.savedCw;
            // this.isHealthPresent = (this.gsPlans && this.savedGs) || (this.eqPlans && this.savedEq);

            // if ((this.gsPlans || this.eqPlans || this.cwPlans) && (this.isHealthPresent || this.isCowanPresent)) {
            //   this.selectedTab = 'tab3';
            // }



            setTimeout(() => {
              this.signaturePadCC = new SignaturePad(
                this.signaturePadCanvasEl?.nativeElement
              );
              this.padAggsignaturePadCC = new SignaturePad(
                this.padAgreementSignaturePadCanvasEl?.nativeElement
              );
            }, 1000);

            this.enrollmentForm.reset();
            // this.creditCardForm.reset();
            this.enrollmentForm
              .get('enrollmentSummaryExpirymonth')
              ?.setValue('');
            this.enrollmentForm
              .get('enrollmentSummaryExpiryyear')
              ?.setValue('');
            this.bankPayForm.reset();
            this.paymentMethodSelectCC = true;
            this.enrollmentBankDetailedVerify = false;
            this.bankDetailsNames = '';
            const elements =
              this.elementRef.nativeElement.getElementsByClassName(
                'imgdisplay2'
              );
            for (let i = 0; i < elements.length; i++) {
              elements[i].style.display = 'block';
              elements[i].style.display = 'inline';
            }
            sessionStorage.setItem('paymentMethod', 'CC');
            this.logger.log('***********tab3: ' + this.studentplanssummarymain1);

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {})
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((response) => { })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((response) => { })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((response) => { })

            // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
            //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
            //     "message": "Corporates information has been updated. Please refresh screen."
            //   }, { headers: {
            //     Authorization: 'Bearer ' + accessToken,
            //     'Content-Type': 'application/json',
            //   } }).subscribe((res)=>{
            //     console.log({res})
            //   })
            // })
          } else {
            Swal.fire({ title: this.lang.Info, text: Response.data.message })
          }
        },
        (error) => {
          if (error.value) {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error });
            // this.router.navigate(["error"]);
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error });
          }
        }
      );
  }
  // public gotosumamrypageLogic() {

  //     this.paymentfirstname = this.userFormControl?.['givenname'].value;
  //     this.paymentfirstname = this.userFormControl?.["lastname"].value;
  //     this.paymentemail = this.userFormControl?.["email"].value.toLowerCase();

  //     // if (sessionStorage.getItem("homeAddress") == "true") {
  //     //   this.homeaddresscheckvalue = true;
  //     //   this.aptcheck = this.userForm.get("apt_suite").value;
  //     //   this.streetaddress = this.userForm.get("streetaddress").value;
  //     //   this.streetaddress2 = this.userForm.get("streetaddressline2").value;
  //     //   this.city = this.userForm.get("city").value;
  //     //   this.province = this.userForm.get("province").value;
  //     //   this.postalcode = this.userForm.get("postalcode").value;

  //     //   this.paymentForm.get("aptcheck").disable();
  //     //   this.paymentForm.get("streetaddress").disable();
  //     //   this.paymentForm.get("streetaddressline2").disable();
  //     //   this.paymentForm.get("city").disable();
  //     //   this.paymentForm.get("province").disable();
  //     //   this.paymentForm.get("postalcode").disable();
  //     // }
  //     // this.paymenttab = 0;

  //     // jQuery("html, body").scrollTop(0);


  //     //'



  //     this.homeaddresscheckvalue = false;
  //     this.homeaddressEnrollmentVal = false;
  //     this.planssummarymain = JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]") || "";
  //     this.planssummaryopt = JSON.parse(sessionStorage.getItem("plansummaryopt") ?? "[]");

  //     let healthplan = []
  //     let healthplanvol = []
  //     this.studentplanssummarymain =
  //       JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]").sort((a: { id: any; }, b: { id: any; }) => a.id - b.id) || "";

  //     const combinedArray = [];
  //     const groupedByParent: any = {};

  //     for (const obj of this.studentplanssummarymain) {

  //       const name = obj.name;

  //       const products = obj.products;
  //       if (!groupedByParent[name]) {
  //         groupedByParent[name] = [];
  //       }
  //       groupedByParent[name] = groupedByParent[name].concat(products);
  //     }

  //     for (const name in groupedByParent) {
  //       combinedArray.push({ name, products: groupedByParent[name] });
  //     }

  //     this.studentplanssummarymain1 = combinedArray;
  //     setTimeout(() => {
  //       this.allproducts = JSON.parse(sessionStorage.getItem("allproducts") ?? "[]");
  //       var total = 0;
  //       for (let i = 0; i < this.allproducts.length; i++) {
  //         total += this.allproducts[i].calculatedTax?.total;
  //       }
  //       this.logger.log(total);
  //       this.planAmount = this._decimalPipe?.transform(total, "1.2-2")?.replace(/,/g, "");
  //       sessionStorage.setItem("totalAmount", this.planAmount);
  //       this.cartcheckvalue = this.planAmount > 0 ? true : false;
  //       // alert(this.planAmount)
  //     }, 1000);


  //     setTimeout(() => {
  //       this.signaturePadCC = new SignaturePad(this.signaturePadCanvasEl?.nativeElement);
  //       this.padAggsignaturePadCC = new SignaturePad(this.padAgreementSignaturePadCanvasEl?.nativeElement);
  //     }, 1000);

  //     this.enrollmentForm.reset();
  //     // this.creditCardForm.reset();
  //     this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.setValue('');
  //     this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.setValue('');
  //     this.bankPayForm.reset();
  //     this.paymentMethodSelectCC = true;
  //     this.enrollmentBankDetailedVerify = false;
  //     this.bankDetailsNames = "";
  //     const elements = this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
  //     for (let i = 0; i < elements.length; i++) {
  //       elements[i].style.display = 'block';
  //       elements[i].style.display = 'inline';
  //     }
  //     sessionStorage.setItem("paymentMethod", "CC");
  //     this.logger.log("***********tab3: " + this.studentplanssummarymain1);


  //     let endPoint = `/api/ap/customer/validatePlans`;
  //     let url = `${environment.apiUrl}${endPoint}`;
  //     var accessToken = sessionStorage.getItem('accessToken');

  //     let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
  //     let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
  //     let data = { plans: plansMain.concat(plansLife) };

  //     // let data = { "plans": JSON.parse(sessionStorage.getItem("plansummarymain")) }
  //     this.http.post(url, data, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     }).subscribe((Response: any) => {
  //       if (Response.status == '200') {
  //         this.homeaddresscheckvalue = false;
  //         this.homeaddressEnrollmentVal = false;
  //         this.planssummarymain = JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]") || "";
  //         this.planssummaryopt = JSON.parse(sessionStorage.getItem("plansummaryopt") ?? "[]");

  //         let healthplan = []
  //         let healthplanvol = []
  //         this.studentplanssummarymain =
  //           JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]").sort((a: { id: any; }, b: { id: any; }) => a.id - b.id) || "";

  //         const combinedArray = [];
  //         const groupedByParent: any = {};

  //         for (const obj of this.studentplanssummarymain) {

  //           const name = obj.name;

  //           const products = obj.products;
  //           if (!groupedByParent[name]) {
  //             groupedByParent[name] = [];
  //           }
  //           groupedByParent[name] = groupedByParent[name].concat(products);
  //         }

  //         for (const name in groupedByParent) {
  //           combinedArray.push({ name, products: groupedByParent[name] });
  //         }

  //         this.studentplanssummarymain1 = combinedArray;
  //         setTimeout(() => {
  //           this.allproducts = JSON.parse(sessionStorage.getItem("allproducts") ?? "[]");
  //           var total = 0;
  //           for (let i = 0; i < this.allproducts.length; i++) {
  //             total += this.allproducts[i].calculatedTax.total;
  //           }
  //           this.logger.log(total);
  //           this.planAmount = this._decimalPipe?.transform(total, "1.2-2")?.replace(/,/g, "");
  //           sessionStorage.setItem("totalAmount", this.planAmount);
  //           this.cartcheckvalue = this.planAmount > 0 ? true : false;
  //           // alert(this.planAmount)
  //         }, 1000);


  //         setTimeout(() => {
  //           this.signaturePadCC = new SignaturePad(this.signaturePadCanvasEl?.nativeElement);
  //           this.padAggsignaturePadCC = new SignaturePad(this.padAgreementSignaturePadCanvasEl?.nativeElement);
  //         }, 1000);

  //         this.savedGs = false;
  //         this.savedEq = false;
  //         this.savedCw = false;
  //         this.savedKIX = false;
  //         this.savedWADDELL = false;
  //         this.gsPlans = Response.data.gsPlans;
  //         this.eqPlans = Response.data.eqPlans;
  //         this.cwPlans = Response.data?.phrPlan;
  //         this.kixPlans = Response.data?.kixcarePlan;
  //         this.flexPlans = Response.data?.flexgsPlan;
  //         // this.flexPlans = true
  //         this.waddellPlans = Response.data?.waddellPlan;
  //         //iS replated to greenShield plans


  //         // if (this.gsPlans) {
  //         //   this.showGreenShiled = false;
  //         //   this.greenShiledForm.reset();
  //         //   $('#gsPlans').show();


  //         // }
  //         // else if (this.eqPlans) {
  //         //   this.showEquitable = false;
  //         //   this.EquitableForm.reset();
  //         //   $('#eqPlans').show();

  //         // }
  //         // else if (this.kixPlans) {
  //         //   this.showKixcarePlans = false;
  //         //   this.KixCareForm.reset();
  //         //   $('#kixPlans').show();

  //         // }
  //         // if (this.waddellPlans) {
  //         //   this.showWaddellPlans = false;
  //         //   this.waddellPlanForm.reset();

  //         //   $('#waddellPlans').show();

  //         // }
  //         // else {
  //         //   this.waddellRegistration = false;
  //         //   this.waddellPlans = false
  //         //   // this.kixCertificateId = '';
  //         // }

  //         // else {
  //         //   this.gsRegistration = false;
  //         //   this.gsPlans = false;
  //         //   this.gsMembershipId = '';
  //         //   this.eqRegistration = false;
  //         //   this.eqPlans = false
  //         //   this.eqCertificateId = '';
  //         // //   this.kixRegistration =false
  //         // //  this.kixPlans=false
  //         // //    this.kixCertificateId =''


  //         // }

  //         // if (this.cwPlans) {
  //         //   this.showCowan = false;
  //         //   this.cowanForm.reset();
  //         //   $('#cwPlans').show();
  //         // }
  //         // else {
  //         //   this.cwRegistraion = false;
  //         //   this.cwPlans = false
  //         //   this.cwCertificateId = '';
  //         // }

  //         //  if (this.kixPlans) {
  //         //   this.showKixcarePlans = false;
  //         //   this.KixCareForm.reset();

  //         //   $('#kixPlans').show();

  //         // }
  //         // else {
  //         //   this.kixRegistration = false;
  //         //   this.kixPlans = false
  //         //   // this.kixCertificateId = '';
  //         // }
  //         if (this.gsPlans) {
  //           this.showGreenShiled = false;
  //           this.greenShiledForm.reset();
  //           $('#gsPlans').show();

  //         } else if (this.eqPlans) {
  //           this.showEquitable = false;
  //           this.EquitableForm.reset();
  //           $('#eqPlans').show();
  //         }
  //         else {
  //           this.gsRegistration = false;
  //           this.gsPlans = false;
  //           this.gsMembershipId = '';
  //           this.eqRegistration = false;
  //           this.eqPlans = false
  //           this.eqCertificateId = '';
  //         }

  //         if (this.cwPlans) {
  //           this.showCowan = false;
  //           this.cowanForm.reset();
  //           $('#cwPlans').show();
  //         }
  //         else {
  //           this.cwRegistraion = false;
  //           this.cwPlans = false
  //           this.cwCertificateId = '';

  //         }

  //         if (this.kixPlans) {
  //           this.showKixcarePlans = false;
  //           this.KixCareForm.reset();

  //           $('#kixPlans').show();

  //         }
  //         else {
  //           this.kixRegistration = false;
  //           this.kixPlans = false
  //           // this.kixCertificateId = '';
  //         }

  //         if (this.flexPlans) {
  //           this.showFlexPlans = false;
  //           this.FlexForm.reset();

  //           $('#flexPlans').show();

  //         }
  //         else {
  //           this.flexRegistration = false;
  //           this.flexPlans = false
  //           // this.kixCertificateId = '';
  //         }
  //         if (this.waddellPlans) {
  //           this.showWaddellPlans = false;
  //           this.waddellPlanForm.reset();

  //           $('#waddellPlans').show();

  //         }
  //         else {
  //           this.waddellRegistration = false;
  //           this.waddellPlans = false
  //           // this.kixCertificateId = '';
  //         }
  //         if (!this.gsPlans && !this.eqPlans && !this.cwPlans && !this.kixPlans && !this.waddellPlans) {
  //           this.selectedTab = "tab3"
  //         }
  //         console.log(this.selectedTab)
  //         this.enrollmentForm.reset();
  //         // this.creditCardForm.reset();
  //         this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.setValue('');
  //         this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.setValue('');
  //         this.bankPayForm.reset();
  //         this.paymentMethodSelectCC = true;
  //         this.enrollmentBankDetailedVerify = false;
  //         this.bankDetailsNames = "";
  //         const elements = this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
  //         for (let i = 0; i < elements.length; i++) {
  //           elements[i].style.display = 'block';
  //           elements[i].style.display = 'inline';
  //         }
  //         sessionStorage.setItem("paymentMethod", "CC");
  //         this.logger.log("***********tab3: " + this.studentplanssummarymain1);

  //         this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
  //           this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
  //             "message": "Corporates information has been updated. Please refresh screen."
  //           }, {
  //             headers: {
  //               Authorization: 'Bearer ' + accessToken,
  //               'Content-Type': 'application/json',
  //             }
  //           }).subscribe((res) => {
  //             console.log({ res })
  //           })
  //         })

  //         // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
  //         //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
  //         //     "message": "Corporates information has been updated. Please refresh screen."
  //         //   }, { headers: {
  //         //     Authorization: 'Bearer ' + accessToken,
  //         //     'Content-Type': 'application/json',
  //         //   } }).subscribe((res)=>{
  //         //     console.log({res})
  //         //   })
  //         // })
  //       }
  //       else {
  //         Swal.fire({ title: this.lang.Info, text: Response.data.message })
  //       }
  //       // else {
  //       //   Swal.fire({ title: this.lang?.Error, text: Response.error || Response.data.error })
  //       // }

  //     }, (error) => {
  //       if (error.value) {
  //         Swal.fire({ title: this.lang?.Error, text: error.error })
  //         // this.router.navigate([this.lang?.Error]);
  //       } else {
  //         Swal.fire({ title: this.lang?.Error, text: error.error });
  //       }
  //     })


  //     //  $("#planSelectionInfo").css("display", "block");
  //     // $('#personalinfocheck').css("dispaly","none");

  //   }
  changeinvitationemail(event: any) {
    if (event.target.value == "true") {
      this.showinvitationmail = false;
      this.InvitationForm.get('invitationEmail').clearValidators();
      this.InvitationForm.get('invitationEmail').updateValueAndValidity();
      this.InvitationForm.get('invitationEmail')?.setValue('')


    } else if (event.target.value == "false") {
      this.showinvitationmail = false;
      this.InvitationForm.get('invitationEmail').clearValidators();
      this.InvitationForm.get('invitationEmail').updateValueAndValidity();
      this.InvitationForm.get('invitationEmail')?.setValue('')


    } else {
      this.showinvitationmail = true;
      this.InvitationForm.get('invitationEmail').setValidators([Validators.required, Validators.pattern(this.commonPatternsService.emailPattern)]);
      this.InvitationForm.get('invitationEmail').updateValueAndValidity();
    }
  }

  changeShowGreenShieldProv(event: any) {
    if (event.target.value == 'true') {
      this.showGreenShiled = true;
      this.greenShiledForm.get('greenShiledNumber').setValidators([Validators.required]);
    } else {
      this.showGreenShiled = false;
      this.greenShiledForm.get('greenShiledNumber').clearValidators();
    }
    this.greenShiledForm.get('greenShiledNumber').updateValueAndValidity();
  }

  saveGsPlans(id: any) {
    this.greenShiledForm.markAllAsTouched();
    if (this.greenShiledForm.valid) {
      this.gsRegistration = this.greenShiledForm.get('showGreenShieldProv').value == 'false' ? true : false;
      this.gsPlans = true;
      this.gsMembershipId = this.greenShiledForm.get('greenShiledNumber').value || "";
      this.eqRegistration = false;
      this.eqPlans = false
      this.eqCertificateId = "";
      this.savedGs = true
      this.cwPlans && !this.savedCw ? this.selectedTab = 'tab2' : this.selectedTab = 'tab3';
      console.log(this.selectedTab)

      this.closePopup(id);
    }
    else {
      return false;
    }

  }
  changeShowEquitableProv(event: any) {
    if (event.target.value == 'true') {
      this.showEquitable = true;
      this.EquitableForm.get('EquitableNumber').setValidators([Validators.required]);
      this.EquitableForm.get('EquitableNumber')?.setValue('')
    } else {
      this.showEquitable = false;
      this.EquitableForm.get('EquitableNumber').clearValidators();
    }
    this.EquitableForm.get('EquitableNumber').updateValueAndValidity();
  }
  saveeqPlans(id: any) {
    this.EquitableForm.markAllAsTouched();
    if (this.EquitableForm.valid) {


      this.eqRegistration = this.EquitableForm.get('EquitableFormProv').value == 'false' ? true : false;
      this.eqPlans = true
      this.eqCertificateId = this.EquitableForm.get('EquitableNumber').value || "";
      this.gsRegistration = false;
      this.gsPlans = false;
      this.gsMembershipId = '';
      this.savedEq = true
      this.cwPlans && !this.savedCw ? this.selectedTab = 'tab2' : this.selectedTab = 'tab3';
      console.log(this.selectedTab)

      this.closePopup(id);
    }
    else {
      return false;
    }

  }

  saveKixCarePlans(id: any) {

    this.KixCareForm.markAllAsTouched();
    const controls: any = this.KixCareForm.controls;
    console.log(controls)
    if (this.KixCareForm.valid) {

      this.kixRegistration = this.KixCareForm.get('KixCareFormProv').value == 'false' ? true : false;
      this.kixPlans = true
      // this.kixCertificateId = this.KixCareForm.get('KixCareNumber').value || "";
      // this.gsRegistration = false;
      // this.gsPlans = false;
      // this.eqRegistration = false;
      // this.eqPlans = false;
      // this.gsMembershipId = '';

      // this.gsPlans = Response.data.gsPlans;
      // this.eqPlans = Response.data.eqPlans;
      // this.cwPlans = Response.data?.phrPlan;
      // this.kixPlans = Response.data?.kixcarePlan;

      if (this.gsPlans) {

      }
      this.savedKIX = true;

      (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.kixPlans && this.savedKIX) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';
      // if(this.cwPlans && !this.savedCw && this.gsPlans && !this.savedGs && this.eqPlans && !this.savedEq){
      // this.selectedTab = 'tab3'
      // }else{
      // this.selectedTab = 'tab2';
      // }
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      alert("!")
      return false;
    }

  }

  saveFlexPlans(id: any) {
    this.FlexForm.markAllAsTouched();
    if (this.FlexForm.valid) {

      this.flexRegistration = this.FlexForm.get('FlexFormProv').value == 'false' ? true : false;
      this.flexPlans = true
      this.flexCertificateId = this.FlexForm.get('FlexMembershipId').value || "";
      // this.gsRegistration = false;
      // this.gsPlans = false;
      // this.eqRegistration = false;
      // this.eqPlans = false;
      // this.gsMembershipId = '';

      // this.gsPlans = Response.data.gsPlans;
      // this.eqPlans = Response.data.eqPlans;
      // this.cwPlans = Response.data?.phrPlan;
      // this.kixPlans = Response.data?.kixcarePlan;

      if (this.gsPlans) {

      }
      this.savedFLEX = true;


      (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.waddellPlans && this.savedWADDELL) || (this.kixPlans && this.savedKIX) || (this.flexPlans && this.savedFLEX) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';


      // if(this.kixPlans && this.savedKIX ){
      // this.selectedTab = 'tab3'
      // }else{
      // this.selectedTab = 'tab2';
      // }
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }
  changeFlexPlanProv(event: any) {
    if (event.target.value == 'true') {
      this.showFlexPlans = true;
      this.FlexForm.get('FlexMembershipId').setValidators([Validators.required]);
      this.FlexForm.get('FlexMembershipId')?.setValue('')
    } else {
      this.showFlexPlans = false;
      this.FlexForm.get('FlexMembershipId').clearValidators();
    }
    this.FlexForm.get('FlexMembershipId').updateValueAndValidity();
  }
  saveWaddellPlans(id: any) {

    this.waddellPlanForm.markAllAsTouched();
    const controls: any = this.waddellPlanForm.controls;
    console.log(controls)
    if (this.waddellPlanForm.valid) {

      this.waddellRegistration = this.waddellPlanForm.get('waddellFormProv').value == 'false' ? true : false;
      this.waddellPlans = true
      // this.kixCertificateId = this.KixCareForm.get('KixCareNumber').value || "";
      // this.gsRegistration = false;
      // this.gsPlans = false;
      // this.eqRegistration = false;
      // this.eqPlans = false;
      // this.gsMembershipId = '';

      // this.gsPlans = Response.data.gsPlans;
      // this.eqPlans = Response.data.eqPlans;
      // this.cwPlans = Response.data?.phrPlan;
      // this.kixPlans = Response.data?.kixcarePlan;

      if (this.gsPlans) {

      }
      this.savedWADDELL = false;

      (this.waddellPlans && this.savedWADDELL) || (this.kixPlans && this.savedKIX) || (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.waddellPlans && this.savedWADDELL) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';
      // if(this.cwPlans && !this.savedCw && this.gsPlans && !this.savedGs && this.eqPlans && !this.savedEq){
      // this.selectedTab = 'tab3'
      // }else{
      // this.selectedTab = 'tab2';
      // }
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }
  changeKixCareProv(event: any) {

  }
  changeWaddellProv(event: any) {

  }
  changeShowCowanProv(event: any) {
    if (event.target.value == 'true') {
      this.showCowan = true;
      this.cowanForm.get('cowanNumber').setValidators([Validators.required]);
      this.cowanForm.get('cowanNumber')?.setValue('')
    } else {
      this.showCowan = false;
      this.cowanForm.get('cowanNumber').clearValidators();
    }
    this.cowanForm.get('cowanNumber').updateValueAndValidity();
  }

  savecwPlans(id: any) {
    this.cowanForm.markAllAsTouched();
    if (this.cowanForm.valid) {

      this.cwRegistraion = this.cowanForm.get('cowanFormProv').value == 'false' ? true : false;;
      this.cwPlans = true
      this.cwCertificateId = this.cowanForm.get('cowanNumber').value || "";
      this.savedCw = true;
      (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.kixPlans && this.savedKIX) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';

      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }

  closeAddMemberPopup() {
    this.bankPayForm.reset();
    this.enrollmentForm.reset();
    this.userForm.reset();
    this.displayStudentId = false;
    this.displatGig = false;
    this.showBrokersList = false;
    this.forms = [];
    this.showForm = false;
  }

  public noofchildrenchanged(event: any) {
    let count = event.target.value;
    if (count < this.oldvaluenumber) {
      this.childrenDetailsArray.removeAt(count);
      this.oldvaluenumber--;
    } else {
      this.childrenDetailsArray.push(this.initChildDetails());
      this.oldvaluenumber++;
    }
  }
  closeAddChildrenPopup() {
    $('#childInfoModal').hide();
    this.graducationdaycheck = false;
    this.childFormGroup.reset();
  }
  childInfoAddData() {
    this.childFormGroup.markAllAsTouched();
    this.checkForGraduationDate()
    if (this.childFormGroup.invalid) {
      this.logger.log(this.childFormGroup.controls)
      return
    }


    this.logger.log('Button name: ' + this.childInfoModalAddAndUpdateButton);
    if (this.childInfoModalAddAndUpdateButton == this.lang.Add) {
      //  this.childInfoAddDataArray=this.childFormGroup.value;
      let childObj = this.childFormGroup.value;
      this.logger.log('>><<', childObj);
      childObj['childInfoDOB'] = moment(childObj.childInfoDOB).format(
        'MM-DD-YYYY'
      );
      childObj['childInfoGraduationday'] = childObj.childPostGraduate
        ? moment(childObj['childInfoGraduationday']).format('MM-DD-YYYY')
        : childObj.childPostGraduate;
      // this.childInfoAddDataArray.push(this.childFormGroup.value);
      this.logger.log('?>>?', childObj);
      this.childInfoAddDataArray.push(childObj);
      this.noOfChildrenChangedValue = this.childInfoAddDataArray.length;
      this.userForm.get('noofchildren').setValue(this.noOfChildrenChangedValue);
      this.childTableRowsLength = this.childInfoAddDataArray.length;
      this.logger.log(
        'childInfo123: ' + JSON.stringify(this.childInfoAddDataArray)
      );
      this.graducationdaycheck = false;
    } else if (this.childInfoModalAddAndUpdateButton == this.lang.Update) {
      let childObj = this.childFormGroup.value;
      childObj['childInfoDOB'] = moment(childObj.childInfoDOB).format(
        'MM-DD-YYYY'
      );
      childObj['childInfoGraduationday'] = childObj.childPostGraduate
        ? moment(childObj['childInfoGraduationday']).format('MM-DD-YYYY')
        : childObj.childPostGraduate;

      this.childInfoAddDataArray[this.childTableEditRowIndex] = childObj; //this.childFormGroup.value;

      this.childInfoModalAddAndUpdateButton = this.lang.Add;
      this.logger.log(
        'this.childInfoAddDataArray: ' +
        JSON.stringify(this.childInfoAddDataArray)
      );
      this.childInfoAddDataArray[''];
      this.dependentchildInsurenceval = false;
      this.graducationdaycheck = false;

      this.childFormGroup.clearValidators();
    }
    this.childFormGroup.reset();
    this.clearChildFormValidations();
    this.closeAddChildrenPopup();
  }
  clearChildFormValidations() {
    let controls = ['childdisablility', 'childInfoCarrierName', 'childPostGraduate', 'childInfoGraduationday'];
    for (let control of controls) {
      this.childFormGroup.get(control)?.clearValidators();
      this.childFormGroup.updateValueAndValidity();
      this.childFormGroup.get(control)?.reset();
    }
  }

  childInforTableEdit(index: any) {

    this.childInfoModalAddAndUpdateButton = this.lang.Update;
    this.childTableEditRowIndex = index;
    let dataObject = this.childInfoAddDataArray[index];
    this.setVlidationsForChild(dataObject);
    if (
      dataObject.childInfoGraduationday != '' &&
      dataObject.childPostGraduate
    ) {
      dataObject.childInfoGraduationday = new Date(dataObject.childInfoGraduationday);
      this.childFormGroup.patchValue(dataObject);
      this.graducationdaycheck = true;
      this.childFormGroup.get('childInfoGraduationday')?.setValidators(Validators.compose([Validators.required, this.validateDateforGraduation]));

    } else {
      this.graducationdaycheck = false;
    }
    if (
      dataObject.childInfoCarrierName != '' &&
      dataObject.DependentchildInsurence == 'true'
    ) {
      this.dependentchildInsurenceval = true;
    } else {
      this.dependentchildInsurenceval = false;
    }

    this.logger.log('Child data: ' + dataObject + ' index: ' + index);
    this.logger.log('Child data123: ' + JSON.stringify(dataObject));

    this.childFormGroup.patchValue(dataObject);
    this.logger.log("child form", this.childFormGroup.value)
    $('#childInfoModal').show();
  }

  setVlidationsForChild(data: any) {

    let controls = ['childInfoFirstName', 'childInfoLastName', 'childInfoGender', 'childInfoDOB',
      'DependentchildInsurence'];
    this.childFormGroup.get('childInfoFirstName').setValidators([Validators.required]);
    this.childFormGroup.get('childInfoLastName').setValidators([Validators.required]);
    this.childFormGroup.get('childInfoGender').setValidators([Validators.required]);
    this.childFormGroup.get("childInfoDOB").setValidators(Validators.compose([Validators.required, this.childrenminimumAgeValidator]));

    this.childFormGroup.get('DependentchildInsurence').setValidators([Validators.required]);
    if (data?.DependentchildInsurence == 'true')
      this.childFormGroup.get('childInfoCarrierName').setValidators([Validators.required]);

    for (const name of Object.keys(this.childFormGroup.controls)) {
      this.childFormGroup.get(name).updateValueAndValidity();
    }
    // this.childFormGroup = this.childInfoFormBuilder.group({
    //   childInfoFirstName: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
    //   childInfoLastName: ['', Validators.compose([Validators.required,Validators.minLength(1)])],
    //   childInfoGender: ["",[Validators.required]],
    //   childInfoDOB: ['', [Validators.required]], 
    //   childdisablility: [''],
    //   childInfoCarrierName: [''],
    //   childPostGraduate: [''],
    //   childInfoGraduationday: [''],
    //   DependentchildInsurence: ['',Validators.required]
    // })
  }
  deleteChildrenSwal(index: any) {
    Swal.fire({
      title: this.lang.Info,
      text: 'Are you sure you want to delete?',
      showCancelButton: true,
      confirmButtonColor: '#10104d',
      cancelButtonColor: '#10104d',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        this.childInforTableDelete(index);
        // Swal.fire({
        //   title: "Deleted!",
        //   text: "Your file has been deleted.",

        // });
      }
    });
  }

  childInforTableDelete(index: any) {
    if (this.childInfoAddDataArray.length == 1)
      document.getElementById('Dependentchildrenno')?.click();

    this.childInfoAddDataArray.splice(index, 1);
    this.noOfChildrenChangedValue = this.childInfoAddDataArray.length;
    this.userForm.get('noofchildren').setValue(this.noOfChildrenChangedValue);
    this.childTableRowsLength = this.childInfoAddDataArray.length;
    // if(this.childTableRowsLength==0){
    //   this.childTableRowsLength=1;
    // }

    this.logger.log('table length: ' + this.childTableRowsLength);
  }
  public provinceEnrollmentlist(event: any) {
    // alert(event.target.value)
    // if (event.target.value == 'QC') {
    //   // jQuery("#provinceinfo-modal").modal("show");
    //   // //const modal = new Modal(this.QCproviance.nativeElement);
    //   // //modal.show();
    //   $('#QCproviance').show();
    // }
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.logger.log('asasas', this.provincialHealthcareUrl)
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    // //this.logger.log(this.userForm.get('postalcode').value)
    if (this.enrollmentForm.get('enrollmentSummaryPostalCode')?.value) {
      if (
        this.provincialZipcodes.indexOf(
          this.enrollmentForm.get('enrollmentSummaryPostalCode')?.value[0]
        ) == -1
      ) {
        this.invalidenrollmentpostalcodeprovince = true;
        this.enrollmentForm.get('enrollmentSummaryPostalCode')?.markAsTouched();
      } else {
        this.invalidenrollmentpostalcodeprovince = false;
      }

      if (
        this.enrollmentForm.get('enrollmentSummaryPostalCode')?.value.length ==
        0
      ) {
        this.invalidenrollmentpostalcodeprovince = false;
      }
    }
    // alert(this.postalvalue)
  }

  //enrolment

  // this.paymentMethodSelectCC = true;
  // homeaddressEnrollmentVal: boolean = false;
  paymentMethodSelect(event: any) {
    if (event == 'Credit_Card') {
      this.fusebill_paymentMethod = 'CC';
      sessionStorage.setItem('paymentMethod', 'CC');
      this.paymentMethodSelectCC = true;
      this.enrollmentBankDetailedVerify = false;
      // this.voidCheckUploaded=false;

      this.bankPayForm.reset();
      this.enrollmentForm.get('enrollmentSummaryBankNumber')?.reset();
      this.enrollmentForm.get('enrollmentSummaryBankNumber')?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryBankNumber')
        ?.updateValueAndValidity();

      this.enrollmentForm.get('enrollmentSummaryTransitNumber')?.reset();
      this.enrollmentForm
        .get('enrollmentSummaryTransitNumber')
        ?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryTransitNumber')
        ?.updateValueAndValidity();

      this.enrollmentForm.get('enrollmentSummaryAccontNumber')?.reset();
      this.enrollmentForm
        .get('enrollmentSummaryAccontNumber')
        ?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryAccontNumber')
        ?.updateValueAndValidity();

      this.enrollmentForm.get('enrollmentBankTextdescription')?.reset();
      this.enrollmentForm
        .get('enrollmentBankTextdescription')
        ?.clearValidators();
      this.enrollmentForm
        .get('enrollmentBankTextdescription')
        ?.updateValueAndValidity();

      // this.signaturePad= new SignaturePad(this.signaturePadCanvas?.nativeElement);
      // this.ngAfterViewInit();
      // this.creditCard();
      const elements = this.elementRef.nativeElement.getElementsByClassName(
        'paymentMethodSelectCC'
      );
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'block';
      }
    }
    else {
      // this.creditCardForm.reset();
      this.fusebill_paymentMethod = 'PAD';
      this.enrollmentForm.get('enrollmentSummaryCardHolderFirstName')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCardHolderLastName')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCardNumnber')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCVV')?.reset();
      this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.reset();
      this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.reset();

      this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.setValue('');
      this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.setValue('');
      this.paymentMethodSelectCC = false;
      this.bankDetailsNames = '';
      sessionStorage.setItem('paymentMethod', 'PAD');
      const elements = this.elementRef.nativeElement.getElementsByClassName(
        'paymentMethodSelectCC'
      );
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
      }
      this.clearSignature();
    }
    this.signaturemessagecc = false;
  }

  homeaddressEnrollment(event: any) {
    this.logger.log(' event.target.value: ' + event.target.checked);
    this.homeaddressEnrollmentVal = event.target.checked;
    if (this.homeaddressEnrollmentVal) {
      this.logger.log('The homeaddressEnrollmentVal is checked.');

      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.reset();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.reset();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryProvince')?.reset();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryCity')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.reset();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddressLane2')
        ?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.reset();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddress')
        ?.clearValidators();

      this.enrollmentForm.updateValueAndValidity();
    } else {
      this.logger.log('The homeaddressEnrollmentVal is not checked.');
      this.enrollmentForm
        .get('enrollmentSummaryApartSuite')
        ?.setValidators(Validators.maxLength(50));
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddress')
        ?.setValidators(
          Validators.compose([Validators.required, Validators.maxLength(50)])
        );
      this.enrollmentForm
        .get('enrollmentSummaryCity')
        ?.setValidators(
          Validators.compose([Validators.required, Validators.maxLength(50)])
        );
      this.enrollmentForm
        .get('enrollmentSummaryProvince')
        ?.setValidators(Validators.compose([Validators.required]));
      this.enrollmentForm
        .get('enrollmentSummaryPostalCode')
        ?.setValidators(
          Validators.compose([Validators.required, Validators.maxLength(50)])
        );

      // this.enrollmentForm.get('recaptchaReactive')?.setValidators(Validators.compose([Validators.required]));
      this.enrollmentForm.updateValueAndValidity();
    }
    this.enrollmentForm.reset();
  }

  bankDetailsVerify() {
    return false;
    this.logger.log('bankDetailsVerify');
    let inputData = {
      bankCode: this.bankPayForm.get('enrollmentSummaryBankNumber')?.value,
      branchCode: this.bankPayForm.get('enrollmentSummaryTransitNumber')?.value,
    };
    // let getbanknamesvalues: string = `${environment.app.grp}api/students/bank/verify`;

    let getbanknamesvalues: string = '';
    // this.studentService.getbanknames(inputData)
    this.http.post(getbanknamesvalues, inputData, {}).subscribe(
      (result: any) => {
        this.logger.log('bank details verify: ' + result);
        if (result.status == '200') {
          this.bankDetailsVerifyStatus = false;
          this.bankDetailsError = '';
          //data saved into this bankverifyDetails variable
          this.bankverifyDetails = result.data;
          this.bankDetailsNames =
            result.data.bank.name +
            '\n' +
            result.data.address.split(',').join('\n');
          this.logger.log('this.bankDetailsNames: ' + this.bankDetailsNames);
          this.enrollmentBankDetailedVerify = true;
        } else {
          this.bankDetailsClear();
          this.bankDetailsVerifyStatus = true;
          this.bankDetailsError = result.message;
        }
      },
      (error) => {
        this.logger.log('bank details getting error: ' + JSON.stringify(error));
      }
    );
  }

  clearSignature() {
    // this.signaturePad.clear();
    if (this.signaturePadCC) {
      this.signaturePadCC.clear();
    }
    this.signaturePadClear = false;

    this.signaturemessagecc = true;
  }

  get enrollmentFormControl() {
    // this.logger.log("this.enrollmentForm.controls: "+JSON.stringify(this.enrollmentForm))
    return this.enrollmentForm.controls;
  }
  bankDetailsClear() {
    this.enrollmentBankDetailedVerify = false;
    this.bankDetailsNames = '';
    this.bankPayForm.get('enrollmentSummaryBankNumber')?.reset();
    this.bankPayForm.get('enrollmentSummaryTransitNumber')?.reset();
    this.bankPayForm.get('enrollmentSummaryAccontNumber')?.reset();
    this.bankPayForm.get('enrollmentBankTextarea')?.reset();
    this.bankPayForm.get('enrollmentSummaryvoidCheckUpload')?.reset();
    this.bankDetailsError = '';
  }

  memberTypeChange(broker: any, form: any) {
    this.logger.log('enter to function');
    console.log(broker)
    this.memberDetails = { ...this.memberDetails, isCorporateAccount: broker == 'CORPORATE' ? true : false }
    this.checkstudenthealthcardstatus = false;    //for student
    this.checkstudenthealthcardstatus_UHIP = false;
    if (broker.toLowerCase() == 'student_association') {
      this.showBrokersList = true;
      this.isCorporate = false;
      this.displayStudentId = true;
      this.displatGig = false;
      console.log('this.displatGig1',this.displatGig)
      this.isStudent = true;
      this.checkhealthcardstatus = false;
      this.waddellForm = false;
      this.userForm.reset()
      this.childFormGroup.reset()


      this.userForm.get('uhipprovincialhealth').setValidators(Validators.required);
      this.userForm.get('parentalinsurance').setValidators([Validators.required]);
      this.userForm.get('studentId').setValidators([Validators.required]);
      this.userForm.get('workinghours').clearValidators();
      this.userForm.get('hoursperweek').clearValidators();
      this.userForm.get("workingProvince").clearValidators()

      this.userForm.get('workinghours').updateValueAndValidity();
      this.userForm.get('hoursperweek').updateValueAndValidity();
      this.userForm.get('studentId').updateValueAndValidity();
      this.userForm.get('parentalinsurance').updateValueAndValidity();
      this.userForm.get('provincialhealth').updateValueAndValidity();
      this.userForm.get('uhipprovincialhealth').updateValueAndValidity();

      this.userForm.updateValueAndValidity();
      this.studentPlaceHolder = this.lang.student_fn;
      this.studentPlaceHolderln = this.lang.student_ln;
    }
    else if (broker == 'CORPORATE') {
      this.studentPlaceHolder = this.lang.name_as_shown_on_provincial_health_card;
      this.studentPlaceHolderln = this.lang.name_as_shown_on_provincial_health_card;
      this.showBrokersList = true;
      this.isCorporate = true;
      this.displayStudentId = false;
      this.isStudent = false;
      this.checkhealthcardstatus = false;
      this.showExtrafeilds = false
      this.showlandeddependentDetails = false
      this.showlandedimgratestatus = false;
      this.childInfoAddDataArray = []


      this.userForm.get('uhipprovincialhealth').clearValidators();
      this.userForm.get('parentalinsurance').clearValidators();
      this.userForm.get('foreignStudent').clearValidators();
      this.userForm.get('studentId').clearValidators();


      this.userForm
        .get('hoursperweek')
        .setValidators([Validators.required, validatehoursperweek]);
      this.userForm.get('hoursperweek').setValue('40');


      if (form.waddell.length > 0) {
        alert("1")
        this.waddellForm = true;

        this.childFormGroup.reset()
        this.displatGig = false
        console.log('this.displatGig1',this.displatGig)

        this.userForm.get('provincialhealth').clearValidators();
        this.userForm.get('havingspouse').clearValidators();
        this.userForm.get("Dependentchildren").clearValidators();
        this.userForm.get("workinghours").clearValidators();
        this.userForm.get("dateofbirth").clearValidators();
        this.userForm.get("gender").clearValidators();
        this.userForm.get("country").setValidators([Validators.required]);

      }
      else {
        this.waddellForm = false;
        this.displatGig = true;
        console.log('this.displatGig1',this.displatGig)
        this.userForm.get('provincialhealth').setValidators([Validators.required]);
        this.userForm.get('workinghours').setValidators(Validators.required);
        this.userForm.get('havingspouse').setValidators([Validators.required]);
        this.userForm.get("Dependentchildren").setValidators([Validators.required]);
        this.userForm.get("dateofbirth").setValidators([Validators.required]);;
        this.userForm.get("gender").setValidators([Validators.required]);
        this.userForm.get("workingProvince").setValidators([Validators.required]);
        this.userForm.get("country").clearValidators();

      }
      this.userForm.get("workingProvince")?.updateValueAndValidity();
      this.userForm.get("country")?.updateValueAndValidity();
      this.userForm.get("dateofbirth")?.updateValueAndValidity();
      this.userForm.get("gender")?.updateValueAndValidity();
      this.userForm.get("havingspouse")?.updateValueAndValidity();
      this.userForm.get("workinghours")?.updateValueAndValidity();
      this.userForm.get("Dependentchildren")?.updateValueAndValidity();
      this.userForm.get('foreignStudent')?.updateValueAndValidity();
      this.userForm.get('studentId')?.updateValueAndValidity();
      this.userForm.get('uhipprovincialhealth')?.updateValueAndValidity();
      this.userForm.get('parentalinsurance')?.updateValueAndValidity();
      this.userForm.get('hoursperweek').updateValueAndValidity();
      this.userForm.get('provincialhealth').updateValueAndValidity();



    }
    else {
      this.studentPlaceHolder = this.lang.name_as_shown_on_provincial_health_card;
      this.studentPlaceHolderln = this.lang.name_as_shown_on_provincial_health_card;
      this.showBrokersList = true;
      this.isCorporate = false;
      this.displayStudentId = false;
      this.isStudent = false;
      this.isCorporate = false
      this.checkhealthcardstatus = false;
      this.showExtrafeilds = false
      this.showlandeddependentDetails = false
      this.showlandedimgratestatus = false;
      this.childInfoAddDataArray = []


      this.userForm.get('uhipprovincialhealth').clearValidators();
      this.userForm.get('parentalinsurance').clearValidators();
      this.userForm.get('foreignStudent').clearValidators();
      this.userForm.get('studentId').clearValidators();
      this.userForm.get("workingProvince").clearValidators()

      this.userForm
        .get('hoursperweek')
        .setValidators([Validators.required, validatehoursperweek]);
      this.userForm.get('hoursperweek').setValue('40');


      if (form.waddell.length > 0) {
        this.waddellForm = true;

        this.childFormGroup.reset()
        this.displatGig = false
        console.log('this.displatGig1',this.displatGig)

        this.userForm.get('provincialhealth').clearValidators();
        this.userForm.get('havingspouse').clearValidators();
        this.userForm.get("Dependentchildren").clearValidators();
        this.userForm.get("workinghours").clearValidators();
        this.userForm.get("dateofbirth").clearValidators();
        this.userForm.get("gender").clearValidators();
        this.userForm.get("country").setValidators([Validators.required]);


      }
      else {
        this.waddellForm = false;
        this.displatGig = true;
        console.log('this.displatGig1',this.displatGig)
        this.userForm.get('provincialhealth').setValidators([Validators.required]);
        this.userForm.get('workinghours').setValidators(Validators.required);
        this.userForm.get('havingspouse').setValidators([Validators.required]);
        this.userForm.get("Dependentchildren").setValidators([Validators.required]);
        this.userForm.get("dateofbirth").setValidators([Validators.required]);;
        this.userForm.get("gender").setValidators([Validators.required]);;
        this.userForm.get("country").clearValidators();

      }
      this.userForm.get("country")?.updateValueAndValidity();
      this.userForm.get("dateofbirth")?.updateValueAndValidity();
      this.userForm.get("gender")?.updateValueAndValidity();
      this.userForm.get("havingspouse")?.updateValueAndValidity();
      this.userForm.get("workinghours")?.updateValueAndValidity();
      this.userForm.get("Dependentchildren")?.updateValueAndValidity();
      this.userForm.get('foreignStudent')?.updateValueAndValidity();
      this.userForm.get('studentId')?.updateValueAndValidity();
      this.userForm.get('uhipprovincialhealth')?.updateValueAndValidity();
      this.userForm.get('parentalinsurance')?.updateValueAndValidity();
      this.userForm.get('hoursperweek').updateValueAndValidity();
      this.userForm.get('provincialhealth').updateValueAndValidity();
      // this.logger.log("isWaddell", this.waddellForm, "iscustomerPlans", this.customerPlansActiveData)
      // } else {
      //   this.userForm.get('memberType').setValue(null);
      //   this.displayStudentId = false;
      //   this.displatGig = false;
      //   this.showBrokersList = false;
      //   this.forms = [];
      //   this.showForm = false;
      //   this.userForm.get('workinghours').setValidators([Validators.required]);
      //   this.userForm.get('hoursperweek').clearValidators();
    }
  }
  getBrokerDetails(memnerType: any) {
    let endPoint = `/api/ap/customers/broker/list?type=${memnerType.toUpperCase()}`;
    let url = `${environment.apiUrl}${endPoint}`;
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(url, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (Response: any) => {
          if (Response.status == '200') {
            this.logger.log(JSON.stringify(Response));
            //items.sort((a, b) => a.value - b.value);
            this.brokers = (Response.data.allBrokers);
            this.brokers.sort((a, b) => {
              let fa = a.name.toLowerCase(),
                fb = b.name.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
            this.logger.log(this.brokers)
            this.logger.log('broker details', JSON.stringify(this.brokers));
            this.userForm.get('brokername').setValue(null);
            this.userForm.get('brokername').updateValueAndValidity();
          } else {
            Swal.fire({ title: this.lang.Info, text: Response.data.message })
          }
        },
        (error) => {
          if (error.value) {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error });
            // this.router.navigate(["error"]);
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error });
          }
        }
      );
  }
  public hoursperweekvalue(event) {
    let value = event.target.value;

    // hoursperweekfun1(value)
  }

  public workinghours(value) {
    if (value == 'true') {
      this.hoursperweek = false;
      this.hourperweekvalue = true;
    } else {
      this.hoursperweek = true;
      this.hourperweekvalue = false;
    }
  }

  //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/11111111111/details
  // https://testapi.groupbenefitz.aitestpro.com/api/ap/12531466/details

  checkFusBillId() {
    this.logger.log('enter to checkFusBillId');
    let fusbillId = this.userForm.get('fusbillId').value;
    if (fusbillId) {
      let formLink = environment.apiUrl;
      var accessToken = sessionStorage.getItem('accessToken');
      let Url: string = `${environment.apiUrl}/api/ap/${fusbillId}/details`;
      let lang = 'en';
      this.http
        .get(Url, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (responce: any) => {
            // this.isLoaded =true
            //             hideOnOverlayClick: false,
            // hideOnContentClick: false,
            // closeClick: false,
            if (responce.status == '200') {
              this.logger.log(JSON.stringify(responce));
              Swal.fire({
                title: this.lang.Info,
                html: 'User Exists in Stax and Not in BMS <br> Are you sure you want to import the data?',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.patchUserDetails(responce.data);
                } else {
                  this.userForm.reset()
                  this.customerPlansInActive = false;
                  this.customerPlansActiveData = null
                }
              });
            } else {
              // if(responce.status!='201'){
              Swal.fire({
                title: this.lang.User_Not_Exists_in_Stax_and_Not_in_BMS,
                // icon: 'warning',
                html: `<div class="custom-content">${responce.message ? responce.message : responce.error
                  }</div>`,
                confirmButtonText: 'OK',
              });
              // }
            }
          },
          (error) => {
            if (error.value) {
              this.router.navigate([this.lang.Error]);
            } else {
            }
          }
        );
    }
    else {
      this.customerPlansInActive = false;
      this.customerPlansActiveData = null
    }

  }

  public customerPlansInActive: boolean = false;
  public customerPlansActiveData: any;

  customerPlansInActiveDisplay() {

  }

  patchUserDetails(data: any) {
    this.logger.log("gri", this.userForm.get('fusbillId').value)
    this.firstName = data.customerData.firstName || '';
    this.lastName = data.customerData.lastName;
    this.primaryEmail = data.customerData.primaryEmail;

    this.primaryPhone = data.customerData?.primaryPhone;
    this.country = data.customerAddress?.billingAddress?.country;
    this.line1 = data.customerAddress?.billingAddress?.line1;
    this.line2 = data.customerAddress?.billingAddress?.line2;
    this.city = data.customerAddress?.billingAddress?.city;
    //  this.state=data.customerAddress.billingAddress.state;
    this.postalZip = data.customerAddress?.billingAddress?.postalZip;
    this.postalZip = data.customerAddress?.billingAddress?.postalZip;
    this.configprovinceres.filter((proviance) => {
      if (
        proviance.name.toLowerCase() ==
        data.customerAddress?.billingAddress?.state?.toLowerCase()
      ) {
        this.state = proviance.shortName;
      }
    });
    this.logger.log(this.state);

    this.userForm.markAsTouched();

    if (data.customerPlansInActiveAndProvison && this.userForm.get('fusbillId').value) {
      this.logger.log("entered")
      this.customerPlansInActive = true;
      this.customerPlansActiveData = data.customerSubscrptions
    }
    else {
      this.customerPlansInActive = false;
      this.customerPlansActiveData = null
    }
  }
  resetFormAndValidations() {
    this.userForm.reset()
    this.userForm = this.fb.group({
      planEnrollmentDate: ['', [Validators.required]],
      studentId: ['', [Validators.required]],
      givenname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
        ]),
      ],
      lastname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
        ]),
      ],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),

          ,
        ]),
      ],

      phonenumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ]),
      ],
      apt_suite: [''],
      streetaddress: ['', Validators.compose([Validators.required])],
      streetaddressline2: [
        '',
      ],
      city: [
        '',
        Validators.compose([
          Validators.required,
          // Validators.pattern('^(?!\\s)[A-Za-z\\s]+$'),
        ]),
      ],
      province: ['', Validators.required],
      country: [''],
      workingProvince: [''],
      postalcode: [
        '',
        Validators.compose([Validators.required, postalcodeValidator]),
      ],
      dateofbirth: [
        '',
        Validators.compose([Validators.required]),
      ],
      gender: ['', Validators.required],
      foreignStudent: ['', Validators.required],
      parentalinsurance: ['', Validators.required],
      havingspouse: ['', Validators.required],

      uhipprovincialhealth: [''],
      provincialhealth: [''

      ],
      dateOfArrival: [""],
      isEmployeeImigrant: [""],
      applylandedstaus: [""],
      countryOrigin: [""],
      coverageRequiredOfEmployee: [""],

      dependentdateOfArrival: [""],
      coverageRequiredOfDependents: [""],
      dependentcountryOrigin: [""],
      dependentLandedImigrant: [""],
      dependentapplylandedstaus: [""],
      dependentMorethan3years: [""],

      spousefirstname: [''],
      spouselastname: [''],
      spousegender: [''],
      spousedateofbirth: ['04-01-2000'],
      spousehealthcard: [''],

      Spousenameofthecarrier: [''],
      spousecob: [''],

      Dependentchildren: ['', Validators.required],
      enrolledunversity: [''],
      childdsiablility: [''],
      graducationday: [''],
      noofchildren: [''],
      termsandconditions: [''],
      disclouseradvisor: [''],
      recaptchaReactivePerInfo: [''],
      // childrenDetails: this.fb.array([this.initChildDetails()]),
      workinghours: ['', Validators.compose([Validators.required])],
      // hoursperweek:[''],
      hoursperweek: [
        '40',
        Validators.compose([Validators.required, validatehoursperweek]),
      ],
      fusbillId: [''],
      formrname: ['', Validators.compose([Validators.required])],
      brokername: ['', Validators.compose([Validators.required])],
      // memberType: ['', Validators.compose([Validators.required])],
    });
  }



  getForms(id: any) {
    this.showForm = true;

    this.resetFormAndValidations()
    this.userForm.get('brokername').setValue(id);

    // this.userForm
    this.logger.log(this.userForm.value.brokername)
    if (id == null) {
      this.userForm.get('brokername').setValue(null);
      this.userForm.get('brokername').updateValueAndValidity();
    }
    this.userForm.get('formrname').setValue(null);
    this.userForm.get('formrname').updateValueAndValidity();
    this.forms = this.allBrokers.filter((broker) => {
      if (broker.id == id) {
        console.log(broker)
        this.FormbrokerType = broker.brokerType
        return broker;
      }
    });

console.log('this.forms[0]?.signupForms',this.forms[0]?.signupForms)
let signupFormData = [...this.forms[0]?.signupForms];
console.log('signupFormData',signupFormData)
    signupFormData?.sort((a, b) => {
      let fa = a.formType.toLowerCase(),
        fb = b.formType.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    this.logger.log('forms', this.forms);
    this.memberTypeChange(this.forms[0].brokerType, this.forms[0]);

  }

  // public onCheckboxChange(
  //   e,
  //   allowMultiple,
  //   disallowedPlanLevels,
  //   options,
  //   pname,
  //   groupname,
  //   plancoverage,
  //   planprice,
  //   gst,
  //   hst,
  //   pst,
  //   event,
  //   event1,
  //   packageindex,
  //   groupindex,
  //   planindex,
  //   plan,
  //   product,
  //   pckage,
  //   group,
  //   coverage: any
  // ) {
  //   // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;
  //   let multiple = allowMultiple == true ? true : false;

  //   this.logger.log(disallowedPlanLevels);

  //   if (disallowedPlanLevels != null) {
  //     this.logger.log(disallowedPlanLevels);
  //     let disallowed_plans = disallowedPlanLevels.split(',');
  //     const dom1: HTMLElement = this.elementRef.nativeElement;
  //     const disallowed_elements = dom1.querySelectorAll(
  //       ".plansscreen input[type='checkbox']"
  //     );

  //     // disallowed_elements.forEach((elem: any) => {

  //     for (let i = 0; i < disallowed_elements.length; i++) {
  //       let elem: any = disallowed_elements[i];
  //       // elementcv.checked=false

  //       let plandetails = elem.attributes.data.value;

  //       let plandetailsobj = plandetails.split('##');

  //       this.logger.log('main', plandetailsobj);
  //       let isBundle = plandetailsobj[21] == "true" ? true : false
  //       // console.log(isBundle)
  //       if (e.target.checked) {
  //         if (!elem.disabled) {

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //                 //  elem.checked=false
  //                 elem.disabled = true;
  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             } else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 //  elem.checked=false
  //                 elem.disabled = true;
  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             }

  //           } else {

  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

  //                 elem.disabled = true;

  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             } else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

  //                 elem.disabled = true;

  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             }

  //           }
  //         }
  //         if (elem.checked) {

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //               }

  //             }
  //             else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //               }
  //             }
  //           } else {
  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }
  //             else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }

  //           }
  //         }
  //       }
  //       else {
  //         if (elem.disabled) {
  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //                 //  elem.checked=false
  //                 elem.disabled = false;
  //               }
  //             } else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 //  elem.checked=false
  //                 elem.disabled = false;
  //               }
  //             }
  //           }
  //           if (isBundle) {
  //             if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

  //               elem.disabled = false;

  //               this.disabledelement =
  //                 'Already included in GroupBenefitz All-In';
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

  //               elem.disabled = false;

  //               this.disabledelement =
  //                 'Already included in GroupBenefitz All-In';
  //             }
  //           }

  //           // else {
  //           //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //           //     //  elem.checked=false
  //           //     elem.disabled = false;
  //           //   }
  //           // }
  //         }
  //         if (elem.checked) {

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //               }

  //             }
  //             else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //               }
  //             }
  //           } else {
  //             if (isBundle) {
  //               if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }
  //             else {
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }

  //           }
  //         }
  //       }
  //       // if (e.target.checked) {
  //       //   if (!elem.disabled) {
  //       //     if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //       //         //  elem.checked=false
  //       //         elem.disabled = true;

  //       //         this.disabledelement =
  //       //           'Already included in GroupBenefitz All-In';
  //       //       }
  //       //     } else {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //       //         //  elem.checked=false
  //       //         elem.disabled = true;
  //       //         this.disabledelement =
  //       //           'Already included in GroupBenefitz All-In';
  //       //       }
  //       //     }
  //       //   }
  //       //   if (elem.checked) {
  //       //     //this.logger.log(disallowed_plans)
  //       //     //this.logger.log(plandetailsobj)

  //       //     if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //       //         elem.checked = false;
  //       //         this.unselectplan(elem);
  //       //       }
  //       //     } else {
  //       //       //this.logger.log(disallowed_plans)
  //       //       //this.logger.log(plandetailsobj)
  //       //       if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //       //         elem.checked = false;
  //       //         this.unselectplan(elem);
  //       //         // elem.disabled =true
  //       //       }
  //       //     }
  //       //   }
  //       // }
  //       // else {
  //       //   if (elem.disabled) {
  //       //     if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //       //         //  elem.checked=false
  //       //         elem.disabled = false;
  //       //       }
  //       //     } else {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //       //         //  elem.checked=false
  //       //         elem.disabled = false;
  //       //       }
  //       //     }
  //       //   }
  //       //   if (elem.checked) {
  //       //     if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //       //         elem.checked = false;
  //       //         // elem.disabled =true
  //       //       }
  //       //     } else {
  //       //       if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //       //         elem.checked = false;
  //       //         // elem.disabled =true
  //       //       }
  //       //     }
  //       //   }
  //       // }
  //     }
  //   }
  //   let sameplanclassname = `newPlan${plan.id}` // //////this.consoleMessage(e)
  //   let classname = e.target.className.replace(sameplanclassname, '');
  //   classname = classname.split(' ').join('.');

  //   console.log(classname)
  //   console.log(sameplanclassname)
  //   // //////this.consoleMessage(classname)
  //   const dom: HTMLElement = this.elementRef.nativeElement;
  //   // const elements = dom.querySelectorAll('.' + classname);
  //   const elements = dom.querySelectorAll(classname);

  //   const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

  //   // //////this.consoleMessage(elements);

  //   let element: any;
  //   let elementcv: any;

  //   if (!multiple) {
  //     console.log("multiple elesehere")
  //     if (e.target.checked) {

  //       console.log(elements)
  //       for (let i = 0; i < elements.length; i++) {
  //         let elem = elements[i];
  //         element = elem;

  //         if (element.checked) {

  //           this.unselectplan(elem);
  //           element.checked = false;
  //         }
  //       }

  //       e.checked = true;
  //       e.target.checked = true;
  //     } else {
  //     }
  //   }
  //   else {

  //     console.log("elesehere")
  //     if (e.target.checked) {


  //       for (let i = 0; i < samePlanElements.length; i++) {
  //         let elem = samePlanElements[i];
  //         element = elem;

  //         if (element.checked) {

  //           this.unselectplan(elem);
  //           element.checked = false;
  //         }
  //       }

  //       e.checked = true;
  //       e.target.checked = true;
  //     } else {
  //     }
  //     // alert("!")
  //     //no checking for other checkboxes you can selet multiple
  //   }
  //   // ////this.logger.log(e)
  //   // let classname = e.target.className;
  //   // classname = classname.split(' ').join('.');

  //   // // ////this.logger.log(classname)
  //   // const dom: HTMLElement = this.elementRef.nativeElement;
  //   // const elements = dom.querySelectorAll('.' + classname);

  //   // // ////this.logger.log(elements);

  //   // let element: any;
  //   // let elementcv: any;

  //   // if (!multiple) {
  //   //   if (e.target.checked) {
  //   //     for (let i = 0; i < elements.length; i++) {
  //   //       let elem = elements[i];
  //   //       element = elem;

  //   //       if (element.checked) {
  //   //         this.unselectplan(elem);
  //   //         element.checked = false;
  //   //       }
  //   //     }

  //   //     e.checked = true;
  //   //     e.target.checked = true;
  //   //   } else {
  //   //   }
  //   // } else {
  //   //   //no checking for other checkboxes you can selet multiple
  //   // }
  //   setTimeout(() => {
  //     if (e.target.checked) {
  //       this.selectplan(e.target, options, plan, product, pckage, group);
  //     } else {
  //       this.unselectplan(e.target);
  //     }
  //   }, 10);
  // }

  public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan(elem);

        }
      }
      e.target.checked = true
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    classname = classname.split(' ').join('.').replaceAll('..', '.');

    console.log(classname)
    console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      console.log("multiple elesehere")
      if (e.target.checked) {

        console.log(elements)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {

            this.unselectplan(elem);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    }
    else {

      // console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem);
        //     element.checked = false;
        //   }
        // }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan(e.target);
      }
    }, 10);
  }
  // public onCheckboxChangeCorporate(
  //   e,
  //   allow_multiple,
  //   disallowedPlanLevels,
  //   options,
  //   pname,
  //   groupname,
  //   plancoverage,
  //   planprice,
  //   gst,
  //   hst,
  //   pst,
  //   event,
  //   event1,
  //   packageindex,
  //   groupindex,
  //   planindex,
  //   plan,
  //   product, pckage, group
  // ) {

  //   // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
  //   let multiple = allow_multiple==true ? true : false;


  //   if (disallowedPlanLevels != null) {

  //     let disallowed_plans = disallowedPlanLevels.split(",");
  //     const dom1: HTMLElement = this.elementRef.nativeElement;
  //     const disallowed_elements = dom1.querySelectorAll(".plansscreen input[type='checkbox']");

  //     // disallowed_elements.forEach((elem: any) => {

  //     for (let i = 0; i < disallowed_elements.length; i++) {
  //       let elem: any = disallowed_elements[i];
  //       // elementcv.checked=false

  //       let plandetails = elem.attributes.data.value;

  //       let plandetailsobj = plandetails.split("##");

  //       //this.logger.log("main", plandetailsobj);

  //       if (e.target.checked) {
  //         if (!elem.disabled) {
  //           if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = true;

  //               this.disabledelement = "Already included in GroupBenefitz All-In";
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = true;
  //               this.disabledelement = "Already included in GroupBenefitz All-In";
  //             }
  //           }
  //         }
  //         if (elem.checked) {
  //           ////this.logger.log(disallowed_plans)
  //           ////this.logger.log(plandetailsobj)

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               elem.checked = false;
  //               this.unselectplanCorporate(elem, options, plan, product, pckage, group);
  //             }
  //           } else {
  //             ////this.logger.log(disallowed_plans)
  //             ////this.logger.log(plandetailsobj)
  //             if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //               elem.checked = false;
  //               this.unselectplanCorporate(elem, options, plan, product, pckage, group);
  //               // elem.disabled =true
  //             }
  //           }
  //         }
  //       } else {
  //         if (elem.disabled) {
  //           if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = false;
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = false;
  //             }
  //           }
  //         }
  //         if (elem.checked) {
  //           if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               elem.checked = false;
  //               // elem.disabled =true
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //               elem.checked = false;
  //               // elem.disabled =true
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }

  //   // //////this.logger.log(e)
  //   let classname = e.target.className;
  //   classname = classname.split(" ").join(".");

  //   // //////this.logger.log(classname)
  //   const dom: HTMLElement = this.elementRef.nativeElement;
  //   const elements = dom.querySelectorAll("." + classname);

  //   // //////this.logger.log(elements);

  //   let element: any;
  //   let elementcv: any;

  //   if (!multiple) {
  //     if (e.target.checked) {
  //       for (let i = 0; i < elements.length; i++) {
  //         let elem = elements[i];
  //         element = elem;

  //         if (element.checked) {
  //           this.unselectplanCorporate(elem, options, plan, product, pckage, group);
  //           element.checked = false;
  //         }
  //       }

  //       e.checked = true;
  //       e.target.checked = true;
  //     } else {
  //     }
  //   } else {
  //     //no checking for other checkboxes you can selet multiple
  //   }
  //   setTimeout(() => {
  //     if (e.target.checked) {
  //       this.selectplanCorporate(e.target, options, plan, product, pckage, group);
  //     } else {
  //       this.unselectplanCorporate(e.target, options, plan, product, pckage, group);
  //     }
  //   }, 10);
  // }



  public onCheckboxChangeCorporate(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any
  ) {
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
    let multiple = allow_multiple == true ? true : false;


    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)



      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      //console.log(samePlanIdElements)
      let targetClassName = 'cp_plan'
      if (e.target.className.includes('cp_plan')) {
        targetClassName = 'cp_plan'
      }
      else if (e.target.className.includes('cc_plan')) {
        targetClassName = 'cc_plan'
      }
      else if (e.target.className.includes('ep_plan')) {
        targetClassName = 'ep_plan'
      }

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //console.log(elem)


        if (element.checked && element.className.includes(targetClassName)) {
          element.checked = false;
          element.disabled = false;  //need to change here for flex bronze disabled
          this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);

        }
      }
      e.target.checked = true

    } else {

    }



    //console.log(disallowedPlanLevels)
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(",");
      //console.log(disallowed_plans)
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        //this.consoleMessage("main", plandetailsobj);
        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {
          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }


          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }


      }
    }





    //////this.consoleMessage(e)
    // //console.log(`newPlan${plan.id}`)

    let sameplanclassname = `newPlan${plan.id}`
    // //console.log(e.target.className)/////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '');
    // //console.log(classname)
    classname = e.target.className.split(' ').join('.');
    // classname = classname.split(' ').join('.');

    // if (classname[0] != '.') {
    //   classname = `.${classname}`

    // }

    // if (classname[classname.length - 1] == '.') {
    //   classname = classname.substring(0, classname.length - 1);
    // }

    //console.log(classname)
    //console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll('.' + classname);
    const elements = dom.querySelectorAll(classname);

    const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);
    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {
            this.unselectplanCorporate(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {

      }
    } else {

      //console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem, options, plan, product, pckage, group,planindex);
        //     element.checked = false;
        //   }
        // }

        // e.checked = true;
        // e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {

        console.log(group)
        console.log(pckage)

        let removedisabledcompanypaidproductid: any = []
        let removedisabledcoveredpaidproductid: any = []
        let removedisabledemployedpaidproductid: any = []
        if (
          group.categorization.coveredByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcompanypaidproductid.push(
                          pl
                        );
                      }
                      else {
                        removedisabledcompanypaidproductid.push(
                          // id: product.id,

                          product.planLevel,

                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcompanypaidproductid.push(
                            pl
                          );
                        }
                        else {
                          removedisabledcompanypaidproductid.push(
                            // id: product.id,

                            product.planLevel,

                          );
                        }

                      });
                    });
                  });
                }
              }
            }

          });
        } else {
        }

        if (
          group.categorization.paidByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcoveredpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledcoveredpaidproductid.push(
                          // id: product.id,
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcoveredpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledcoveredpaidproductid.push(
                            // id: product.id,
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        if (
          group.categorization.paidByEmployee == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {



          pckage.groups.forEach((element: any) => {
            //console.log(element)
            if (pckage.id != 5) {

              if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledemployedpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledemployedpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {


              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledemployedpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledemployedpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        console.log(removedisabledcompanypaidproductid)
        console.log(removedisabledcoveredpaidproductid)
        console.log(removedisabledemployedpaidproductid)

        removedisabledcompanypaidproductid = removedisabledcompanypaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcoveredpaidproductid = removedisabledcoveredpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledemployedpaidproductid = removedisabledemployedpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcompanypaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;


            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)
                  //  plan.disabled = false;
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            }
            else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              plan.disabled = false;
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }





            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {

              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    /* //console.log(plan) */

                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);


              if (elem.isBundle) {
                // if (elem.id == element.id) {
                //   selectplans.splice(index, 1)
                // }

                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {


                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
                // if(elem.id==elem.products[0].id){
                //   selectplans.splice(index,1)
                // }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();

          }, 1000);
        });
        removedisabledcoveredpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });
        removedisabledemployedpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelectorAll("#plancheck" + element.id);
            // //console.log(plan)
            // //Rakesh changes here company to upgrade
            // plan.disabled = false;
            // plan.forEach((element: any) => {
            //   //console.log(element)
            //   element.checked = false
            // });


            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)

                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)

                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });


        this.selectplanCorporate(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      } else {


        this.unselectplanCorporate(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      }
    }, 10);
  }
  // public unselectplanCorporate(elementcv: any, options: any, plan: any, product: any, pckage: any, group: any) {

  //   // this.adddisabledcompanypaidproductid =[]

  //   // if(group.categorization.coveredByCompany==1 || group.categorization.paidByEmployee==1){
  //   //   pckage.groups.forEach(element => {

  //   //         if(element.categorization.paidByCompany==1){
  //   //           element.plans.forEach(plan => {
  //   //             Object.keys(plan.productAddonss).forEach(key=>{
  //   //               plan.productAddonss[key].forEach(product => {
  //   //                 this.adddisabledcompanypaidproductid.push({"id":product.id})


  //   //               });
  //   //             })
  //   //           });
  //   //         }


  //   //   });
  //   //   this.adddisabledcompanypaidproductid.forEach((element,index) => {


  //   //     setTimeout(() => {
  //   //       const dom: HTMLElement = this.elementRef.nativeElement;
  //   //       const plan: any = dom.querySelector("#plancheck" + element.id);
  //   //       $("#plancheck" + element.id).click()
  //   //           plan.disabled=true


  //   //     }, 100);
  //   //   })

  //   // }
  //   // else{

  //   // }


  //   let plandetails = elementcv.attributes.data.value;

  //   let plandetailsobj = plandetails.split("##");
  //   let obj = {
  //     isBundle: plan.isBundle,
  //     // enrollmentDate:this.datePipe.transform(
  //     //   this.userForm.value.planenrollmentdate,
  //     //   'yyyy-MM-dd'
  //     // ),
  //     enrollmentDate: sessionStorage.getItem('enrollmentdate'),

  //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //     name: plandetailsobj[14],
  //     details: plandetailsobj[0],
  //     packagename: plandetailsobj[0],
  //     groupName: plandetailsobj[1],
  //     amount: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
  //     planCoverage: plandetailsobj[2],
  //     planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
  //     amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, '')),
  //     gst:
  //       plandetailsobj[4] == null ||
  //         plandetailsobj[4] == "" ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == "null"
  //         ? 0
  //         : parseFloat(plandetailsobj[4]),
  //     hst:
  //       plandetailsobj[5] == null ||
  //         plandetailsobj[5] == "" ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == "null"
  //         ? 0
  //         : parseFloat(plandetailsobj[5]),
  //     pst:
  //       plandetailsobj[6] == null ||
  //         plandetailsobj[6] == "" ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == "null"
  //         ? 0
  //         : parseFloat(plandetailsobj[6]),
  //     qst:
  //       plandetailsobj[17] == null ||
  //         plandetailsobj[17] == "" ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == "null"
  //         ? 0
  //         : parseFloat(plandetailsobj[17]),
  //     gstCheck:
  //       plandetailsobj[4] == null ||
  //         plandetailsobj[4] == "" ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == "null"
  //         ? false
  //         : true,
  //     hstCheck:
  //       plandetailsobj[5] == null ||
  //         plandetailsobj[5] == "" ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == "null"
  //         ? false
  //         : true,
  //     pstCheck:
  //       plandetailsobj[6] == null ||
  //         plandetailsobj[6] == "" ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == "null"
  //         ? false
  //         : true,
  //     qstCheck:
  //       plandetailsobj[17] == null ||
  //         plandetailsobj[17] == "" ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == "null"
  //         ? false
  //         : true,
  //     id: parseFloat(plandetailsobj[7]),
  //     fusebillPlanID:
  //       plandetailsobj[8] == null ||
  //         plandetailsobj[8] == "" ||
  //         plandetailsobj[8] == undefined ||
  //         plandetailsobj[8] == "null"
  //         ? 0
  //         : parseFloat(plandetailsobj[8]),
  //     planFrequencyID:
  //       plandetailsobj[9] == null ||
  //         plandetailsobj[9] == "" ||
  //         plandetailsobj[9] == undefined ||
  //         plandetailsobj[9] == "null"
  //         ? 0
  //         : parseFloat(plandetailsobj[9]),
  //     optIn: plandetailsobj[10] == "true" ? true : false,
  //     planname: plandetailsobj[14],
  //     planLevel: parseInt(plandetailsobj[15]),
  //     packageId: parseInt(plandetailsobj[16]),
  //     options: [],
  //     paidByCompany1: plandetailsobj[19],
  //     coveredByCompany1: plandetailsobj[20],
  //     paidByEmployee1: plandetailsobj[21],
  //     planLevel_parentId: plandetailsobj[12],
  //     disallowedPlanLevels: plandetailsobj[11],
  //   };
  //   if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
  //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //     }
  //   }

  //   this.removeplansummaryCorporate(obj, group, pckage);
  // }
  // public selectplanCorporate(elementcv: any, options: any, plan: any, product: any, pckage: any, group: any) {

  //   if (
  //     group.categorization.coveredByCompany == 1 ||
  //     group.categorization.paidByEmployee == 1
  //   ) {
  //     pckage.groups.forEach((element) => {
  //       if (element.categorization.paidByCompany == 1) {
  //         element.plans.forEach((plan) => {
  //           Object.keys(plan.productAddonss).forEach((key) => {
  //             plan.productAddonss[key].forEach((product) => {
  //               this.removedisabledcompanypaidproductid.push({
  //                 id: product.id,
  //               });
  //             });
  //           });
  //         });
  //       }
  //     });
  //   } else {
  //   }
  //   this.removedisabledcompanypaidproductid.forEach((element, index) => {
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       const plan: any = dom.querySelector("#plancheck" + element.id);

  //       // plan.disabled = false;
  //     }, 100);
  //   });
  //   let plandetails = elementcv.attributes.data.value;

  //   let plandetailsobj = plandetails.split("##");
  //   if (options && options.length > 0) {

  //     let obj = {
  //       isBundle: plan.isBundle,
  //       // enrollmentDate:this.datePipe.transform(
  //       //   this.userForm.value.planenrollmentdate,
  //       //   'yyyy-MM-dd'
  //       // ),
  //       enrollmentDate: sessionStorage.getItem('enrollmentdate'),
  //       // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //       name: plandetailsobj[14],
  //       details: plandetailsobj[0],
  //       packagename: plandetailsobj[0],
  //       groupName: plandetailsobj[1],
  //       // amount: parseFloat(plandetailsobj[3]),
  //       amount: parseFloat(product.calculatedTax?.price),
  //       planCoverage: plandetailsobj[2],
  //       // planPrice: parseFloat(plandetailsobj[3]),
  //       planPrice: parseFloat(product.calculatedTax?.price),
  //       // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
  //       amountUI: "$" + parseFloat(product.calculatedTax?.price),
  //       gst:
  //         plandetailsobj[4] == null ||
  //           plandetailsobj[4] == "" ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[4]),
  //       hst:
  //         plandetailsobj[5] == null ||
  //           plandetailsobj[5] == "" ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[5]),
  //       pst:
  //         plandetailsobj[6] == null ||
  //           plandetailsobj[6] == "" ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[6]),
  //       qst:
  //         plandetailsobj[17] == null ||
  //           plandetailsobj[17] == "" ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[17]),
  //       gstCheck:
  //         plandetailsobj[4] == null ||
  //           plandetailsobj[4] == "" ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == "null"
  //           ? false
  //           : true,
  //       hstCheck:
  //         plandetailsobj[5] == null ||
  //           plandetailsobj[5] == "" ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == "null"
  //           ? false
  //           : true,
  //       pstCheck:
  //         plandetailsobj[6] == null ||
  //           plandetailsobj[6] == "" ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == "null"
  //           ? false
  //           : true,
  //       qstCheck:
  //         plandetailsobj[17] == null ||
  //           plandetailsobj[17] == "" ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == "null"
  //           ? false
  //           : true,
  //       id: parseFloat(plandetailsobj[7]),
  //       fusebillPlanID:
  //         plandetailsobj[8] == null ||
  //           plandetailsobj[8] == "" ||
  //           plandetailsobj[8] == undefined ||
  //           plandetailsobj[8] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[8]),
  //       planFrequencyID:
  //         plandetailsobj[9] == null ||
  //           plandetailsobj[9] == "" ||
  //           plandetailsobj[9] == undefined ||
  //           plandetailsobj[9] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[9]),
  //       optIn: plandetailsobj[10] == "true" ? true : false,
  //       planname: plandetailsobj[14],
  //       planLevel: parseInt(plandetailsobj[15]),
  //       packageId: parseInt(plandetailsobj[16]),
  //       options: [],
  //       paidByCompany1: plandetailsobj[19],
  //       coveredByCompany1: plandetailsobj[20],
  //       paidByEmployee1: plandetailsobj[21],
  //       planLevel_parentId: plandetailsobj[12],
  //       disallowedPlanLevels: plandetailsobj[11],
  //     };
  //     if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
  //       if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //       }
  //     }
  //     let coverage = product.planCoverage

  //     coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
  //     ////this.logger.log(obj)
  //     let productobj = {

  //       id: product.id,
  //       productId: product.productId,
  //       name: product.name,


  //       planProductId: product.planProductId,
  //       price: adjustWith2DecimalsForUI(product.price1 || product.price),
  //       tax: adjustWith2DecimalsForUI(product.calculatedTax ? product.calculatedTax.tax : 0),
  //       total: adjustWith2DecimalsForUI(product.calculatedTax ? product.calculatedTax.total : 0),
  //       //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
  //       //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
  //       //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
  //       tax_details: product.bundledTaxes && product.bundledTaxes.length > 0 ? product.bundledTaxes : product.taxesDataJSON,
  //       calculatedTax: product.calculatedTax,
  //       bundledProducts: product.bundledProducts,
  //       planCoverage: product.planCoverage,
  //       planLevel: product.planlevel ? product.planlevel.id : '',
  //       planLevelParent: product.planlevel ? product.planlevel.parentId : "",
  //       description: product.description,
  //       coverage: coverage
  //     };
  //     let obj1 = {

  //       packageId: plan.packageId,
  //       packageName: pckage.name,

  //       planproductname: productobj.name,

  //       groupid: plan.planLevel,
  //       groupName: group.name,
  //       id: plan.id,
  //       name: plan.name,
  //       planLevel: plan.planLevel ? plan.planLevel : group.id,
  //       planLevelParent: group.parentId,
  //       fusebillPlanID: plan.fusebillId,
  //       planFrequencyID: plan.frqMonthly,
  //       isBundle: plan.isBundle,
  //       coverage: coverage,
  //       planCoverage: product.planCoverage,
  //       bundledProducts: [],
  //       products: [],
  //       upgradeCalculation: plan.upgradeCalculation,
  //       paidByCompany: group.categorization.paidByCompany,
  //       coveredByCompany: group.categorization.coveredByCompany,
  //       paidByEmployee: group.categorization.paidByEmployee

  //     };


  //     obj1.products.push(productobj);
  //     this.planobjdata = obj1
  //     this.openplanoptions(elementcv, options, plan, product);
  //   }

  //   else {
  //     let obj = {
  //       isBundle: plan.isBundle,
  //       // enrollmentDate:this.datePipe.transform(
  //       //   this.userForm.value.planenrollmentdate,
  //       //   'yyyy-MM-dd'
  //       // ),
  //       enrollmentDate: sessionStorage.getItem('enrollmentdate'),

  //       // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //       name: plandetailsobj[14],
  //       details: plandetailsobj[0],
  //       packagename: plandetailsobj[0],
  //       groupName: plandetailsobj[1],
  //       // amount: parseFloat(plandetailsobj[3]),
  //       amount: parseFloat(product.calculatedTax?.price),
  //       planCoverage: plandetailsobj[2],
  //       // planPrice: parseFloat(plandetailsobj[3]),
  //       planPrice: parseFloat(product.calculatedTax?.price),
  //       // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
  //       amountUI: "$" + parseFloat(product.calculatedTax?.price),
  //       gst:
  //         plandetailsobj[4] == null ||
  //           plandetailsobj[4] == "" ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[4]),
  //       hst:
  //         plandetailsobj[5] == null ||
  //           plandetailsobj[5] == "" ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[5]),
  //       pst:
  //         plandetailsobj[6] == null ||
  //           plandetailsobj[6] == "" ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[6]),
  //       qst:
  //         plandetailsobj[17] == null ||
  //           plandetailsobj[17] == "" ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[17]),
  //       gstCheck:
  //         plandetailsobj[4] == null ||
  //           plandetailsobj[4] == "" ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == "null"
  //           ? false
  //           : true,
  //       hstCheck:
  //         plandetailsobj[5] == null ||
  //           plandetailsobj[5] == "" ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == "null"
  //           ? false
  //           : true,
  //       pstCheck:
  //         plandetailsobj[6] == null ||
  //           plandetailsobj[6] == "" ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == "null"
  //           ? false
  //           : true,
  //       qstCheck:
  //         plandetailsobj[17] == null ||
  //           plandetailsobj[17] == "" ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == "null"
  //           ? false
  //           : true,
  //       id: parseFloat(plandetailsobj[7]),
  //       fusebillPlanID:
  //         plandetailsobj[8] == null ||
  //           plandetailsobj[8] == "" ||
  //           plandetailsobj[8] == undefined ||
  //           plandetailsobj[8] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[8]),
  //       planFrequencyID:
  //         plandetailsobj[9] == null ||
  //           plandetailsobj[9] == "" ||
  //           plandetailsobj[9] == undefined ||
  //           plandetailsobj[9] == "null"
  //           ? 0
  //           : parseFloat(plandetailsobj[9]),
  //       optIn: plandetailsobj[10] == "true" ? true : false,
  //       planname: plandetailsobj[14],
  //       planLevel: parseInt(plandetailsobj[15]),
  //       packageId: parseInt(plandetailsobj[16]),
  //       options: [],
  //       paidByCompany1: plandetailsobj[19],
  //       coveredByCompany1: plandetailsobj[20],
  //       paidByEmployee1: plandetailsobj[21],
  //       planLevel_parentId: plandetailsobj[12],
  //       disallowedPlanLevels: plandetailsobj[11],
  //     };
  //     if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
  //       if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //       }
  //     }

  //     let coverage = product.planCoverage

  //     coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
  //     ////this.logger.log(obj)
  //     let productobj = {

  //       id: product.id,
  //       productId: product.productId,
  //       name: product.name,


  //       planProductId: product.planProductId,
  //       //  price: product.price1 || product.price,
  //       //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
  //       //  total: product.calculatedTax ? product.calculatedTax.total : 0,

  //       price: adjustWith2DecimalsForUI(product.price1 || product.price),
  //       tax: adjustWith2DecimalsForUI(product.calculatedTax ? product.calculatedTax?.tax : 0),
  //       total: adjustWith2DecimalsForUI(product.calculatedTax ? product.calculatedTax?.total : 0),
  //       //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
  //       //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
  //       //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),


  //       tax_details:

  //         product.bundledTaxes && product.bundledTaxes.length > 0

  //           ? product.bundledTaxes

  //           : product.taxesDataJSON,
  //       calculatedTax: product.calculatedTax,
  //       bundledProducts: product.bundledProducts,
  //       planCoverage: product.planCoverage,
  //       planLevel: product.planlevel ? product.planlevel.id : '',
  //       planLevelParent: product.planlevel ? product.planlevel.parentId : "",
  //       description: product.description,
  //       coverage: coverage
  //     };
  //     let obj1 = {

  //       packageId: plan.packageId,
  //       packageName: pckage.name,

  //       planproductname: productobj.name,

  //       groupid: plan.planLevel,
  //       groupName: group.name,
  //       id: plan.id,
  //       name: plan.name,
  //       planLevel: plan.planLevel ? plan.planLevel : group.id,
  //       planLevelParent: group.parentId,
  //       fusebillPlanID: plan.fusebillId,
  //       planFrequencyID: plan.frqMonthly,
  //       isBundle: plan.isBundle,
  //       coverage: coverage,
  //       planCoverage: product.planCoverage,
  //       bundledProducts: [],
  //       products: [],
  //       upgradeCalculation: plan.upgradeCalculation,
  //       paidByCompany: group.categorization.paidByCompany,
  //       coveredByCompany: group.categorization.coveredByCompany,
  //       paidByEmployee: group.categorization.paidByEmployee



  //     };

  //     //this.logger.log(group)
  //     obj1.products.push(productobj);
  //     //this.logger.log(obj1)

  //     this.addtoplansummaryCorporate(obj, obj1)
  //   }
  // }

  public selectplanCorporate(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {
    // ////this.consoleMessage(elementcv)
    //this.consoleMessage(plan);
    //this.consoleMessage(product)
    //this.consoleMessage(pckage)
    //this.consoleMessage(group)

    // alert("1")
    this.planobjdata = {};
    this.planobjdataobj = {}

    console.log(disallowedPlanLevels)

    let details: any = elementcv.attributes.data.value;

    let detailsObj: any = details.split("##");


    let categorization = {}

    if (group.categorization.paidByCompany == 1) {

      categorization = {
        paidByCompany: detailsObj[22] == "true" ? 0 : 1,
        coveredByCompany: detailsObj[22] == "true" ? 1 : 0,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    } else {
      categorization = {
        paidByCompany: group.categorization.paidByCompany,
        coveredByCompany: group.categorization.coveredByCompany,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    }

    //console.log(categorization)

    // paidByCompany: group.categorization.paidByCompany,
    // coveredByCompany: group.categorization.coveredByCompany,
    // paidByEmployee: group.categorization.paidByEmployee,

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let obj = {
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
         //     enrollmentDate: this.userForm.value.planEnrollmentDate
    //       ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
    //       : undefined,
    //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
    //     name: plandetailsobj[14],
    //     details: plandetailsobj[0],
    //     packagename: plandetailsobj[0],
    //     groupName: plandetailsobj[1],
    //     // amount: parseFloat(plandetailsobj[3]),
    //     amount: parseFloat(product.calculatedTax.price),
    //     planCoverage: plandetailsobj[2],
    //     // planPrice: parseFloat(plandetailsobj[3]),
    //     planPrice: parseFloat(product.calculatedTax.price),
    //     // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
    //     amountUI: "$" + parseFloat(product.calculatedTax.price),
    //     gst:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[4]),
    //     hst:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[5]),
    //     pst:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[6]),
    //     qst:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[17]),
    //     gstCheck:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? false
    //         : true,
    //     hstCheck:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? false
    //         : true,
    //     pstCheck:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? false
    //         : true,
    //     qstCheck:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? false
    //         : true,
    //     id: parseFloat(plandetailsobj[7]),
    //     fusebillPlanID:
    //       plandetailsobj[8] == null ||
    //         plandetailsobj[8] == "" ||
    //         plandetailsobj[8] == undefined ||
    //         plandetailsobj[8] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[8]),
    //     planFrequencyID:
    //       plandetailsobj[9] == null ||
    //         plandetailsobj[9] == "" ||
    //         plandetailsobj[9] == undefined ||
    //         plandetailsobj[9] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[9]),
    //     optIn: plandetailsobj[10] == "true" ? true : false,
    //     planname: plandetailsobj[14],
    //     planLevel: parseInt(plandetailsobj[15]),
    //     packageId: parseInt(plandetailsobj[16]),
    //     options: [],
    //     paidByCompany1: plandetailsobj[19],
    //     coveredByCompany1: plandetailsobj[20],
    //     paidByEmployee1: plandetailsobj[21],
    //     planLevel_parentId: plandetailsobj[12],
    //     // disallowedPlanLevels: plandetailsobj[11],
    //     version: plan.version,
    //     description: plan.description,
    //     insuranceType: plan.insuranceType,
    //   };
    //   if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
    //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
    //     }
    //   }
    //   let coverage = product.planCoverage;

    //   coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,

    //     planProductId: product.planProductId,
    //     price: adjustWith2DecimalsForUI(product.price1 || product.price),
    //     tax: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.tax : 0
    //     ),
    //     total: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.total : 0
    //     ),
    //     //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
    //     //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
    //     //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel
    //       ? product.planlevel.id
    //       : plan.planLevel
    //         ? plan.planLevel
    //         : group.id,
    //     planLevelParent: product.planlevel
    //       ? product.planlevel.parentId
    //       : group.parentId,
    //     description: product.description,
    //     coverage: coverage,
    //     version: product.version
    //   };
    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //     upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    //   };
    //   obj1.products.push(this.productobj);
    //   let finalobj1: any = { ...obj1, ...categorization };



    //   //this.consoleMessage(obj1);


    //   this.planobjdata = finalobj1;
    //   this.planobjdataobj = obj
    //   this.elementcvValues = elementcv

    //   console.log(this.planobjdata)

    //   // this.addtoplansummary(obj, obj1, elementcv);
    //   this.addtoplansummaryCorporate(obj, finalobj1, elementcv);
    //   this.openplanoptions(elementcv);
    // }
    // else {
      let obj = {
        isBundle: plan.isBundle,
        disallowedPlanLevels: disallowedPlanLevels,
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        // amount: parseFloat(plandetailsobj[3]),
        amount: parseFloat(product.calculatedTax.price),
        planCoverage: plandetailsobj[2],
        // planPrice: parseFloat(plandetailsobj[3]),
        planPrice: parseFloat(product.calculatedTax.price),
        // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
        amountUI: "$" + parseFloat(product.calculatedTax.price),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == "" ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == "null"
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == "" ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == "null"
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == "" ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == "null"
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == "" ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == "null"
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == "" ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == "null"
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == "" ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == "null"
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == "" ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == "null"
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == "" ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == "null"
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == "" ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == "null"
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == "" ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == "null"
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == "true" ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        paidByCompany1: plandetailsobj[19],
        coveredByCompany1: plandetailsobj[20],
        paidByEmployee1: plandetailsobj[21],
        planLevel_parentId: plandetailsobj[12],
        // disallowedPlanLevels: plandetailsobj[11],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType,
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }

      let coverage = product.planCoverage;

      coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
        ? coverage
        : null;
      ////this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,

        planProductId: product.planProductId,
        //  price: product.price1 || product.price,
        //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
        //  total: product.calculatedTax ? product.calculatedTax.total : 0,

        price: adjustWith2DecimalsForUI(product.price1 || product.price),
        tax: adjustWith2DecimalsForUI(
          product.calculatedTax ? product.calculatedTax.tax : 0
        ),
        total: adjustWith2DecimalsForUI(
          product.calculatedTax ? product.calculatedTax.total : 0
        ),
        //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
        //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
        //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),

        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: product.planCoverage,
        planLevel: product.planlevel
          ? product.planlevel.id
          : plan.planLevel
            ? plan.planLevel
            : group.id,
        planLevelParent: product.planlevel
          ? product.planlevel.parentId
          : group.parentId,
        description: product.description,
        coverage: coverage,
        version: product.version
      };
      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: coverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

      };

      obj1.products.push(this.productobj);
      let finalobj1: any = { ...obj1, ...categorization };

      //console.log(finalobj1)


      this.addtoplansummaryCorporate(obj, finalobj1, elementcv);

    setTimeout(() => {

      this.openplanoptions(elementcv)
    }, 1000);

  }

  public unselectplanCorporate(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {

    //console.log(plan)

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      isBundle: plan.isBundle,
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      disallowedPlanLevels: plandetailsobj[11],
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryCorporate(obj, group, pckage, elementcv);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }




  public addtoplansummaryCorporate(obj: any, obj1: any, e: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");

    console.log(obj)
    console.log(obj1)

    /* This code mainly for flex plan silver and gold */


    for (let i = 0; i < planSummary.length; i++) {
      if (obj1.planLevelParent) {
        if (planSummary[i].planLevelParent == obj1.planLevelParent && planSummary[i].coveredByCompany == obj1.coveredByCompany) {

          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("#plancheck" + planSummary[i].id + ".coverage" + planSummary[i].coverage);
          //console.log(plan)
          if (plan.checked) {
            plan.checked = false
          }
          planSummary.splice(i, 1)
        }
      }
    }



    //this.consoleMessage("obj1", obj1);
    //console.log("obj", obj);
    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
      // //console.log(plan)

      if (obj.coverage === "SINGLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "COUPLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "FAMILY") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
      } else {
        // Default case - hide all plans if coverage doesn't match expected
      }



    }, 2000);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.options && obj.options.length > 0) {
      obj["disallowedPlanLevels"] = obj1.disallowedPlanLevels

    }

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;

      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(hstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;


      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    // ////this.consoleMessage(object["taxUI"])

    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
    // );
    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2")
    // );
    obj['tax'] = obj1.products[0]
      ? this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2") : 0;
    obj['tax'] = parseFloat(obj['tax']);
    // obj["products"] =obj1

    obj["coverage"] = obj1.coverage;
    obj["planCoverage"] = obj1.planCoverage;
    obj["planLevelParent"] = obj1.planLevelParent;
    obj["planproductname"] = obj1.planproductname;

    obj["products"] = obj1.products;
    obj["upgradeCalculation"] = obj1.upgradeCalculation;
    obj["paidByCompany"] = obj1.paidByCompany;
    obj["coveredByCompany"] = obj1.coveredByCompany;
    obj["paidByEmployee"] = obj1.paidByEmployee;



    let pricecal = obj1.products[0].calculatedTax.total;
    obj["totalPrice"] = pricecal;

    obj["totalUI"] = "$" + pricecal;

    (obj["total"] = pricecal),
      (obj["skuTotalPrice"] = parseFloat(
        obj1.products.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.total;
        }, 0)
      ));

    let updatedSum = this.addtosum(obj.skuTotalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem("plansskumain", JSON.stringify(this.plansskumain));

    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary", JSON.stringify(planSummary));

    // setTimeout(() => {
    this.planCoverafeFunction();

    // }, 3000);

    if (planSummary.length > 0) {
      this.plansnexttab = false;
    } else {
      this.plansnexttab = true;
    }

    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }
    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }


      this.companypaidproductid = this.companypaidproductid.filter(
        (item: any) => item !== undefined && item !== null
      );

      var result = this.companypaidproductid.reduce((unique: any, o: any) => {
        if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log(result);
      const filteredPlans = result.filter((result: any) => result.planLevel === 18);

      console.log(filteredPlans);


      if (filteredPlans.length > 0) {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }



          }
        }
      } else {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector(`#plancheck792`)
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                  this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
                }, 1000);
                break;
              }

            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
              break;
            }
          }
        }
      }
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   if (obj.planproductname.includes("La Vie")) {

      //     if (this.planssummarymain[i].planLevel == 18) {

      //       if (this.planssummarymain[i].coverage == obj.coverage) {

      //       } else {
      //         // const dom: HTMLElement = this.elementRef.nativeElement;
      //         // // const plan: any = dom.querySelector(`#plancheck792`)
      //         // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
      //         // setTimeout(() => {
      //         //   plan.click()
      //         //   this.toastrService.success("Complete Executive plan include in La vie", "");
      //         // }, 1000);
      //       }
      //       break;
      //     }
      //     else {

      //       const dom: HTMLElement = this.elementRef.nativeElement;
      //       // const plan: any = dom.querySelector(`#plancheck792`)
      //       const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

      //       console.log(plan)
      //       setTimeout(() => {
      //         plan.click()
      //         this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
      //       }, 1000);
      //     }
      //   }
      // }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = parseFloat(total.toString());
      sessionStorage.setItem("totalAmount", this.planAmount);
    }, 100);

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";



      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);

          const samePlanIdElements = dom.querySelectorAll('#' + e.id);
          //console.log(samePlanIdElements)
          let targetClassName = 'cp_plan'
          if (e.className.includes('cp_plan')) {
            targetClassName = 'cp_plan'
          }
          else if (e.className.includes('cc_plan')) {
            targetClassName = 'cc_plan'
          }
          else if (e.className.includes('ep_plan')) {
            targetClassName = 'ep_plan'
          }

          for (let i = 0; i < samePlanIdElements.length; i++) {
            let elem = samePlanIdElements[i];
            let element: any = elem;
            // //console.log(elem)
            // //console.log(elem.className.includes('cp_plan'))
            if (elem.className.includes('cp_plan')) {
              element.disabled = false;
              if (element.checked) {
                element.disabled = true;

              }
            }
          }
          if (plan) {
            // plan.disabled = true;
            // if(plan.isBundle){
            //   plan.disabled = false;
            // }else{
            //   plan.disabled = false;
            // }

          }
        }
      });
    }, 1000);
  }





  public removeplansummaryCorporate(obj: any, group: any, pckage: any, e: any) {



    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {

      let index: any = this.getindexofplan(obj);
      if (index > -1) {
        planSummary.splice(index, 1);
      } else {

        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;


        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;




        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(hstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);

      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;


        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);




      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // ////this.consoleMessage(object["taxUI"])



      obj['tax'] = gstprice + hstprice + pstprice + qstprice
        ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
        : 0;
      obj['tax'] = parseFloat(obj['tax']);
      (obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj["totalUI"] =
          "$" +
          parseFloat(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice
          ));

      obj["total"] = parseFloat(
        obj.planPrice + gstprice + hstprice + pstprice + qstprice
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];
      console.log(planSummary)

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem("plansummary", JSON.stringify(planSummary));
      if (planSummary.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }


      this.planCoverafeFunction();


      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }





      setTimeout(() => {
        let selectplans =
          JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

        //console.log(pckage);
        //console.log(group);

        let adddisabledcompanypaidproductid: any = []

        if (
          group.categorization.coveredByCompany == 1
          ||
          group.categorization.paidByEmployee == 1
        ) {
          pckage.groups.forEach((element: any) => {
            if (element.categorization.paidByCompany == 1) {
              if (group?.parentId == element?.parentId) {
                element.plans.forEach((plan: any) => {

                  let pl = { ...plan, ...element.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      //console.log(product)
                      //console.log(pl)
                      if (pl.isBundle) {
                        adddisabledcompanypaidproductid.push(
                          pl,
                        );
                      } else {
                        adddisabledcompanypaidproductid.push(product.planlevel);
                      }

                    });
                  });
                });
              }
            }
          });



          adddisabledcompanypaidproductid = adddisabledcompanypaidproductid.filter(
            (item: any) => item !== undefined && item !== null
          );
          console.log(adddisabledcompanypaidproductid);

          for (let i = 0; i < adddisabledcompanypaidproductid.length; i++) {
            // adddisabledcompanypaidproductid.forEach((element: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#plancheck" + adddisabledcompanypaidproductid[i].id);


            // const planCheck1 = this.renderer.selectRootElement("#plancheck" + element.id, true);

            let selectPlanCheck;
            if (obj?.isBundle == true) {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId && el.planLevelParent == adddisabledcompanypaidproductid[i].planLevel_parentId;
              })
            }
            else {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId;
              })



              let planData: any = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
              let targetClassName = 'cp_plan'
              if (e.className.includes('cp_plan')) {
                targetClassName = 'cp_plan'
              }
              else if (e.className.includes('cc_plan')) {
                targetClassName = 'cc_plan'
              }
              else if (e.className.includes('ep_plan')) {
                targetClassName = 'ep_plan'
              }

              for (let i = 0; i < planData.length; i++) {
                console.log(planData[i])
                if (planData[i].className.includes('cp_plan')) {
                  planData[i].click()
                  return false;

                }
              }


            }

            //console.log(selectPlanCheck)
            if (selectPlanCheck) {

              selectplans.forEach((products: any) => {

                if (products.packageId == adddisabledcompanypaidproductid[i].packageId) {

                  products.products.forEach((prod: any) => {
                    // if (prod.id == adddisabledcompanypaidproductid[i].id) {
                    if (prod.planLevel == adddisabledcompanypaidproductid[i].id) {
                    } else {
                      //console.log("checkHere")
                      // $("#plancheck" + element.id).click()
                    }
                  });
                } else {
                  // //this.consoleMessage("CheckHere1")

                }
              });
            } else {


              const dom: HTMLElement = this.elementRef.nativeElement;

              let coverage = adddisabledcompanypaidproductid[i].companyPaidCoverage?.replace("SELECTIVE_", "")
              //console.log(coverage)

              let planData;
              if (coverage && coverage != "DIRECT") {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id + ".coverage" + coverage)
                //console.log(planData)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
                break;
              }
              else {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
              }


            }
          }
        }




        setTimeout(() => {
          let selectplans =
            JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

          selectplans.forEach((products: any) => {
            if (products.paidByCompany == 1) {
              products.products.forEach((element: any) => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);

                //this.consoleMessage(plan);

                if (plan) {

                }


                const samePlanIdElements = dom.querySelectorAll('#' + e.id);
                //console.log(e)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                for (let i = 0; i < samePlanIdElements.length; i++) {
                  let elem = samePlanIdElements[i];
                  let element: any = elem;
                  if (elem.className.includes('cp_plan')) {
                    element.disabled = false;
                    if (element.checked) {
                      element.disabled = true;

                    }
                  }

                }
              });
            }
          });
        }, 1000);
      }, 100);



      setTimeout(() => {
        let selectplansInfo =
          JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";

        //console.log(selectplansInfo)

        if (selectplansInfo.length > 0) {
          for (let i = 0; i < selectplansInfo.length; i++) {
            if (selectplansInfo[i].id == obj.id) {

            }

            else {
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
                const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
                const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
                /*  //console.log(plan) */


                plan.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });

                plan2.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });
                plan3.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });



              }, 1000);
            }
          }



        }
        else {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
            const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
            const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
            /*  //console.log(plan) */


            plan.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });

            plan2.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });
            plan3.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });



          }, 1000);
        }
      }, 1000);

      setTimeout(() => {
        let selectplansInfo = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";
        if (selectplansInfo.length === 0) {
          if (obj.groupName != "Complete Executive Care") {
            this.autoSelectCompanyPaidPlans()
          }


        }
      }, 1000);
    }
  }


  public planCoverafeFunction() {
    this.paidEmployeeShare = 0;
    this.coveredEmployeeShare = 0;

    //this.consoleMessage("plancoverage");

    let planDetailsArray = JSON.parse(
      sessionStorage.getItem("planDetailsArray") || "[]"
    );
    //this.consoleMessage(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans2(this.packagesInBlocks);
    // var package_plans = this.convertpackagesToPlans2(this.basepackages);

    //this.consoleMessage(package_plans);
    let planSummaryMain = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
    let planSummaryLife = JSON.parse(sessionStorage.getItem("plansummaryLife") || "[]");
    // let iafgplansCheck = JSON.parse(
    //   sessionStorage.getItem('plansummaryLife') || '[]'
    // );

    this.iafgplansCheck = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );
    //console.log(planSummaryMain)

    // let planSummary;
    // if(planSummaryMain.length>0){
    //  let planSummary = planSummaryMain.concat(planSummaryLife)
    // }else{
    //    planSummary = planSummaryLife
    // }
    let planSummary = planSummaryMain.concat(planSummaryLife)

    //console.log(planSummary)
    //this.consoleMessage(planSummary);
    var all_selected_plans = [];
    var payrollCCplans = [];
    var directpayCCplans = [];
    var employeeDealingPlans = [];
    var companyDealingPlans = [];
    var alloptinplans = [];
    var company_selected_plans = [];
    var employee_selected_plans = [];
    var company_paid_selected_plans = [];
    var company_covered_selected_plans = [];


    var selected_cp_plans = planSummary.filter(function (plan: any) {
      return plan.paidByCompany == 1 || plan.categorization?.paidByCompany == true;;
    });

    var selected_cc_plans = planSummary.filter(function (plan: any) {
      return plan.coveredByCompany == 1 || plan.categorization?.coveredByCompany == true;;
    });

    var selected_ep_plans = planSummary.filter(function (plan: any) {
      return plan.paidByEmployee == 1 || plan.categorization?.paidByEmployee == true;
    });

    // var selected_cc_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.coveredByCompany == 1;

    //   });

    // });

    // var selected_cp_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByCompany == 1;

    //   });

    // });
    // var selected_ep_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByEmployee == 1;

    //   });

    // });

    //this.consoleMessage(selected_cc_plans);
    //this.consoleMessage(selected_cp_plans);
    //this.consoleMessage(selected_ep_plans);

    //console.log(selected_cp_plans)

    for (var cp = 0; cp < selected_cp_plans.length; cp++) {
      var current_cp_plan: any = selected_cp_plans[cp];

      // current_cp_plan.amount = parseFloat(
      //   this._decimalPipe.transform(current_cp_plan.amount, "1.2-2")
      // );
      current_cp_plan.amount = adjustWith2DecimalsForUI(current_cp_plan.amount)

      // //this.consoleMessage("rakesh",current_cp_plan.amount)
      current_cp_plan["amounts"] = {
        company: current_cp_plan.amount,
        employee: 0,
        total: current_cp_plan.amount,
      };
      current_cp_plan["categorization"] = {
        paidByCompany: true,
        coveredByCompany: false,
        paidByEmployee: false,
      };

      current_cp_plan["type"] = this.lang["100_Company_Paid"];

      current_cp_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
      current_cp_plan["employeeAmountUI"] =
        "$" + current_cp_plan["amounts"].employee;
      current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
      current_cp_plan["companyAmountUI"] =
        "$" + current_cp_plan["amounts"].company;
      current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

      if (
        current_cp_plan.id == 429 ||
        current_cp_plan.packageId == 8 ||
        current_cp_plan.planLevel == 16
      ) {
        alloptinplans.push(current_cp_plan);
      } else {
        all_selected_plans.push(current_cp_plan);
        company_selected_plans.push(current_cp_plan);
        company_paid_selected_plans.push(current_cp_plan);
      }
    }

    for (var cc = 0; cc < selected_cc_plans.length; cc++) {
      var current_cc_plan: any = selected_cc_plans[cc];

      current_cc_plan["amounts"] = {
        company: current_cc_plan.upgradeCalculation.baseplanPrice,
        employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
        total: current_cc_plan.upgradeCalculation.combinedplanPrice,
      };

      current_cc_plan["companyCoveredBasePlan"] =
        current_cc_plan.upgradeCalculation.basePlanDetails;

      current_cc_plan["companyCoveredBasePlan"].companyTax =
        current_cc_plan.upgradeCalculation.baseplanTax;
      current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage =
        current_cc_plan.upgradeCalculation.companyTaxPercentage;

      current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage =
        current_cc_plan.upgradeCalculation.employeeTaxPercentage;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect =
        "0%";
      current_cc_plan["companyCoveredBasePlan"].specialTax =
        current_cc_plan["companyCoveredBasePlan"].companyTax +
        current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
      current_cc_plan["companyCoveredBasePlan"].tax2 =
        current_cc_plan["companyCoveredBasePlan"].companyTax;

      //this.consoleMessage(current_cc_plan);
      ///
      //deleta plan things
      current_cc_plan["employeeDeductions"] = {
        amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
        tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
        taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
      };

      // current_cc_plan["employeeDeductions"].amountUI =
      //   "$" + current_cc_plan["employeeDeductions"].amount;
      // current_cc_plan["employeeDeductions"].taxUI = current_cc_plan[
      //   "companyCoveredBasePlan"
      // ].taxUI.replace(
      //   current_cc_plan["companyCoveredBasePlan"].tax,
      //   current_cc_plan["employeeDeductions"].tax
      // );
      // current_cc_plan["employeeDeductions"].totalUI =
      //   "$" + current_cc_plan["employeeDeductions"].total;

      current_cc_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: true,
        paidByEmployee: false,
      };

      current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type;

      current_cc_plan["planGrandTotal"] = {
        amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
        tax: current_cc_plan.upgradeCalculation.combinedplanTax,
        total: current_cc_plan.upgradeCalculation.combinedplanTotal,
        taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
      };
      // planid,planname,planlevelid,planlevename,amount
      current_cc_plan.amount = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.amountUI = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax;
      current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI;
      current_cc_plan.total = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI;
      current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total;

      //this.consoleMessage(current_cc_plan);

      current_cc_plan["companyShareTotal"] =
        current_cc_plan["companyCoveredBasePlan"].total;
      current_cc_plan["employeeShareTotal"] =
        current_cc_plan["employeeDeductions"].total;

      current_cc_plan["companySharePlanAmountTotal"] =
        current_cc_plan["companyCoveredBasePlan"].amount;
      current_cc_plan["employeeSharePlanAmountTotal"] =
        current_cc_plan["employeeDeductions"].amount;

      current_cc_plan["companyShareTaxTotal"] =
        current_cc_plan["companyCoveredBasePlan"].tax;
      current_cc_plan["employeeShareTaxTotal"] =
        current_cc_plan["employeeDeductions"].tax;

      current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
      current_cc_plan["employeeAmountUI"] =
        "$" + current_cc_plan["amounts"].employee;
      current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
      current_cc_plan["companyAmountUI"] =
        "$" + current_cc_plan["amounts"].company;
      //this.consoleMessage(current_cc_plan["amounts"].employee);
      //this.consoleMessage(current_cc_plan["amounts"].company);
      //this.consoleMessage(current_cc_plan["amounts"].total);
      this.coveredEmployeeShare += parseFloat(
        current_cc_plan["amounts"].employee
      );

      // this.coveredEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2" ||)
      // );
      this.coveredEmployeeShare = parseFloat(this.coveredEmployeeShare)
      all_selected_plans.push(current_cc_plan);
      company_selected_plans.push(current_cc_plan);
      company_covered_selected_plans.push(current_cc_plan);

      if (current_cc_plan.upgradeCalculation.payroll) {
        payrollCCplans.push(current_cc_plan);
      } else {
        directpayCCplans.push(current_cc_plan);
      }
      //this.consoleMessage("payrollCCplans",payrollCCplans)
      //this.consoleMessage("directpayCCplans",directpayCCplans)
    }

    for (var ep = 0; ep < selected_ep_plans.length; ep++) {
      var current_ep_plan: any = selected_ep_plans[ep];

      //this.consoleMessage(current_ep_plan)

      current_ep_plan.amount = adjustWith2DecimalsForUI(current_ep_plan.products[0].price);

      current_ep_plan["amounts"] = {
        company: 0,
        employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
        total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
      };

      current_ep_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: false,
        paidByEmployee: true,
      };

      current_ep_plan["type"] = this.lang["Voluntary_Opt_In"];

      current_ep_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
      current_ep_plan["employeeAmountUI"] =
        "$" + current_ep_plan["amounts"].employee;
      current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
      current_ep_plan["companyAmountUI"] =
        "$" + current_ep_plan["amounts"].company;
      //  current_cp_plan["planLevelName"] = current_ep_plan.groupName || ""

      //this.consoleMessage(current_ep_plan)

      //console.log(current_ep_plan)

      //this.consoleMessage(current_ep_plan["amounts"].employee);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = +current_ep_plan["amounts"].employee;
      this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2")
      // );

      //this.consoleMessage(this.paidEmployeeShare);
      all_selected_plans.push(current_ep_plan);
      employee_selected_plans.push(current_ep_plan);
    }

    employeeDealingPlans = directpayCCplans.concat(employee_selected_plans);

    //console.log(employeeDealingPlans)
    companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans);
    //console.log(this.iafgplansCheck)
    // employeeDealingPlans = employeeDealingPlans.concat(this.iafgplansCheck)  //hererakesh
    //console.log(employeeDealingPlans)

    //this.consoleMessage("employeeDealingPlans",employeeDealingPlans)
    //this.consoleMessage("companyDealingPlans",companyDealingPlans)

    this.alloptinplans = alloptinplans;

    //this.consoleMessage(this.coveredEmployeeShare);
    //this.consoleMessage(this.paidEmployeeShare);

    sessionStorage.setItem("employeeshare", this.paidEmployeeShare);
    //this.consoleMessage(this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2"));
    //this.consoleMessage(this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2"));

    var totalIAFG = 0;
    for (let i = 0; i < this.iafgplansCheck.length; i++) {
      totalIAFG += parseFloat(this.iafgplansCheck[i].skuTotalPrice);
    }



    this.totalEmployeeShare =
      this.coveredEmployeeShare + this.paidEmployeeShare;
    // this.cartDisplayAmount = this.paidEmployeeShare + totalIAFG;
    this.cartDisplayAmount = this.paidEmployeeShare;
    // this.totalEmployeeShare = parseFloat(
    //   this._decimalPipe.transform(this.totalEmployeeShare, "1.2-2")
    // );
    this.totalEmployeeShare = parseFloat(this.totalEmployeeShare)
    this.cartDisplayAmount = this._decimalPipe.transform(
      this.cartDisplayAmount,
      "1.2-2"
    );

    //this.cartDisplayAmount = floatWith2Decimals(this.cartDisplayAmount);

    //this.consoleMessage(this.totalEmployeeShare);

    /* if (employee_selected_plans.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";

    } else {


      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      sessionStorage.setItem("paymentMethod", "NONE");
    }*/

    //console.log(this.iafgplansCheck)
    //console.log(this.iafgplansCheck.length)
    if (employeeDealingPlans.length > 0 || this.iafgplansCheck.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";
      this.voluntryplansCheck = true
      // this.paymentForm.get('paymentRadioCheck')?.setValue("CC");
    } else {
      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      this.voluntryplansCheck = false
      // this.bankpay =false;  //rakesh
      // this.paymentForm.get('paymentRadioCheck')?.setValue('');
      sessionStorage.setItem("paymentMethod", "NONE");
    }

    this.directpayCCplansarr = directpayCCplans;
    this.payrollCCplansarr = payrollCCplans;
    this.companyDealingPlans = companyDealingPlans;
    this.employeeDealingPlansarr = employeeDealingPlans;

    //console.log(this.employeeDealingPlansarr)


    this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    if (this.payrollCCplansarr.length > 0) {
      this.upgradeplansCheck = true
    }
    //this.consoleMessage(this.companyDealingPlans)
    //this.consoleMessage(this.payrollCCplansarr)
    sessionStorage.setItem(
      "allSelectedPlans",
      JSON.stringify(all_selected_plans)
    );
    sessionStorage.setItem(
      "allSelectedOptPlans",
      JSON.stringify(alloptinplans)
    );
    //this.consoleMessage(all_selected_plans);
    //this.consoleMessage(company_selected_plans);

    //this.consoleMessage(company_paid_selected_plans);
    //this.consoleMessage(company_covered_selected_plans);
    //this.consoleMessage(employee_selected_plans);

    //company paid plans

    this.companySelectedPlans = company_paid_selected_plans;
    this.companyCoveredPlans = company_covered_selected_plans;
    // this.EmployeeSelectedPlans = employee_selected_plans.concat(this.iafgplansCheck);
    this.EmployeeSelectedPlans = employee_selected_plans
    this.allSelectedPlans = all_selected_plans;

    this.allSelectedPlans = this.allSelectedPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
    //     this.allPlansAmountTotal =  this._decimalPipe.transform(
    //   this.allPlansAmountTotal,
    //   "1.2-2"
    // );
    this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
    // this.allPlansTotal =  this._decimalPipe.transform(
    //   this.allPlansTotal,
    //   "1.2-2"
    // );
    this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");
    // this.allPlansTotaltax =  this._decimalPipe.transform(
    //   this.allPlansTotaltax,
    //   "1.2-2"
    // );

    this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
    this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
    this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");
    //this.consoleMessage(this.companyPaidTotal);
    // this.companyPaidTotal =  this._decimalPipe.transform(
    //   this.companyPaidTotal,
    //   "1.2-2"
    // );
    //this.consoleMessage(this.companyPaidTotal);
    // for(var i=0;i<this.companySelectedPlans.length;i++){
    //   this.companyPaidTotal += this.companySelectedPlans[i].total

    //   this.companyPaidTotal = parseFloat(this._decimalPipe.transform(this.companySelectedPlans[i].total, "1.2-2"))

    // }
    // for(var i=0;i<this.companyCoveredPlans.length;i++){
    //   this.companyCoveredTotal += this.companyCoveredPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.companyCoveredTotal, "1.2-2"))

    // }
    this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
    this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
    this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");
    //this.consoleMessage(this.allCCPlansAmountTotal);
    //this.consoleMessage(this.allCCTaxTotal);
    //this.consoleMessage(this.companyCoveredTotal);
    this.companyCoveredCompanyShareTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTotal"
    );
    this.companyCoveredCompanySharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "companySharePlanAmountTotal"
    );
    this.companyCoveredCompanyShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTaxTotal"
    );
    this.companyCoveredEmployeeShareTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTotal"
    );
    this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "employeeSharePlanAmountTotal"
    );
    this.companyCoveredEmployeeShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTaxTotal"
    );

    this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
    this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
    this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

    this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
    this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
    this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

    //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
    this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
    this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
    this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

    //Company paid and company covered split with payroll
    this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
    this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
    this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");

    // for(var i=0;i<this.EmployeeSelectedPlans.length;i++){
    //   this.companyCoveredTotal += this.EmployeeSelectedPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.EmployeeSelectedPlans[i].total, "1.2-2"))

    // }
    //cp+cc(company)
    this.effectiveCompanyPlansAmountTotal =
      parseFloat(this.allCPPlansAmountTotal) +
      parseFloat(this.companyCoveredCompanySharePlanAmountTotal);
    this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
      this.effectiveCompanyPlansAmountTotal,
      "1.2-2"
    );
    this.effectiveCompanyTaxTotal =
      parseFloat(this.allCPTaxTotal) +
      parseFloat(this.companyCoveredCompanyShareTaxTotal);
    this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
      this.effectiveCompanyTaxTotal,
      "1.2-2"
    );
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyPaidTotal) +
      parseFloat(this.companyCoveredCompanyShareTotal);
    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
    this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
    this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");
    //this.consoleMessage(this.paidEmployeedTotal);
    // this.paidEmployeedTotal = this._decimalPipe.transform(
    //   this.paidEmployeedTotal,
    //   "1.2-2"
    // );
    // //this.consoleMessage(this.companyPaidTotal)
    // //this.consoleMessage(this.companyCoveredTotal)
    // //this.consoleMessage(this.paidEmployeedTotal)



    this.planssummarymainLife = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    //console.log(this.planssummarymainLife)
    let total: any = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    //console.log(total)
    this.effectiveEmployeeTotalContibution =
      parseFloat(this.companyCoveredEmployeeShareTotal) +
      parseFloat(this.paidEmployeedTotal);
    this.effectiveEmployeeTotalContibution = adjustWith2DecimalsForUI(
      this.effectiveEmployeeTotalContibution
    );

    //console.log(this.effectiveEmployeeTotalContibution)
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyCoveredCompanyShareTotal) +
      parseFloat(this.companyPaidTotal);

    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );

    //this.consoleMessage(this.companyCoveredPlans)
    //payrollDeduction setting

    let payrollDeduction = sessionStorage.getItem("payrollDeduction")
      ? sessionStorage.getItem("payrollDeduction")
      : "EMPLOYEE_CHOICE";

    if (
      this.companyCoveredPlans.length > 0 &&
      payrollDeduction == "EMPLOYEE_CHOICE"
    ) {
      // $("payrolldeduction-modal").show()
      // jQuery("#payrolldeduction-modal").modal("show");
    }
  }
  public calculateTaxforPlan(plan: any) {
    let plandetails;
    //this.consoleMessage(plan)
    //this.consoleMessage($(`#plancheck${plan.id}`))
    for (const cpPlan of plan) {
      //this.consoleMessage(plan)
      for (const product1 in cpPlan.productAddonss) {
        //this.consoleMessage(cpPlan.productAddonss[product1][0].id)
        // const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + cpPlan.productAddonss[product1][0].id);
        // plandetails = $(
        //   "#plancheck" + cpPlan.productAddonss[product1][0].id
        // ).attr("data"); //rakesh


        plandetails = this.renderer.selectRootElement("#plancheck" + cpPlan.productAddonss[product1][0].id).attr("data");

        //this.consoleMessage(plandetails)
        let plandetailsobj = plandetails.split("##");

        let obj: any = {
          enrollmentDate: this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
            : undefined,
          // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
          name: plandetailsobj[14],
          details: plandetailsobj[0],
          packagename: plandetailsobj[0],
          groupName: plandetailsobj[1],
          amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
          planCoverage: plandetailsobj[2],
          planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
          amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
          gst:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? 0
              : parseFloat(plandetailsobj[4]),
          hst:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? 0
              : parseFloat(plandetailsobj[5]),
          pst:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? 0
              : parseFloat(plandetailsobj[6]),
          qst:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? 0
              : parseFloat(plandetailsobj[17]),
          gstCheck:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? false
              : true,
          hstCheck:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? false
              : true,
          pstCheck:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? false
              : true,
          qstCheck:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? false
              : true,
          id: parseFloat(plandetailsobj[7]),
          fusebillPlanID:
            plandetailsobj[8] == null ||
              plandetailsobj[8] == "" ||
              plandetailsobj[8] == undefined ||
              plandetailsobj[8] == "null"
              ? 0
              : parseFloat(plandetailsobj[8]),
          planFrequencyID:
            plandetailsobj[9] == null ||
              plandetailsobj[9] == "" ||
              plandetailsobj[9] == undefined ||
              plandetailsobj[9] == "null"
              ? 0
              : parseFloat(plandetailsobj[9]),
          optIn: plandetailsobj[10] == "true" ? true : false,
          planname: plandetailsobj[14],
          planLevel: parseInt(plandetailsobj[15]),
          packageId: parseInt(plandetailsobj[16]),
          options: [],
          paidByCompany1: plandetailsobj[19],
          coveredByCompany1: plandetailsobj[20],
          paidByEmployee1: plandetailsobj[21],
          planLevel_parentId: plandetailsobj[12],
          disallowedPlanLevels: plandetailsobj[11],
        };

        ////this.consoleMessage(obj)
        let gstprice = 0;
        let hstprice = 0;
        let pstprice = 0;
        let qstprice = 0;

        if (obj.gst > 0) {
          gstprice = obj.planPrice * obj.gst;
          obj['gstPrice'] = gstprice
            ? this._decimalPipe.transform(gstprice, '1.2-2')
            : 0;
          obj['gstPrice'] = parseFloat(obj['gstPrice']);

        } else {
          obj["gstPrice"] = 0;
        }

        if (obj.hst > 0) {
          hstprice = obj.planPrice * obj.hst;

          obj["hstPrice"] = parseFloat(
            this._decimalPipe.transform(hstprice, "1.2-2") ?? '0'
          );
        } else {
          obj["hstPrice"] = 0;
        }

        if (obj.pst > 0) {
          pstprice = obj.planPrice * obj.pst;
          obj["pstPrice"] = parseFloat(
            this._decimalPipe.transform(pstprice, "1.2-2") ?? '0'
          );
        } else {
          obj["pstPrice"] = 0;
        }

        if (obj.qst > 0) {
          qstprice = obj.planPrice * obj.qst;
          obj["qstPrice"] = parseFloat(
            this._decimalPipe.transform(qstprice, "1.2-2") ?? '0'
          );
        } else {
          obj["qstPrice"] = 0;
        }

        obj["taxUI"] = "";
        if (obj["gstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["gstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
              "&nbsp;(GST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["pstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["pstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
              "&nbsp;(PST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["qstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["qstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
              "&nbsp;(QST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["hstCheck"]) {
          obj["taxUI"] += "<span> ";
          if (obj["hstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
              "&nbsp;(HST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (
          !obj["hstCheck"] &&
          !obj["gstCheck"] &&
          !obj["pstCheck"] &&
          !obj["qstCheck"]
        ) {
          obj["taxUI"] += "<span>-";

          obj["taxUI"] += "</span>";
        }

        // ////this.consoleMessage(object["taxUI"])

        obj["tax"] = parseFloat(
          this._decimalPipe.transform(
            gstprice + hstprice + pstprice + qstprice,
            "1.2-2"
          ) ?? '0'
        );

        //this.consoleMessage(obj.planPrice);
        //this.consoleMessage(gstprice);
        //this.consoleMessage(hstprice);
        //this.consoleMessage(pstprice);

        //this.consoleMessage(qstprice);
        let pricecal =
          obj.planPrice + gstprice + hstprice + pstprice + qstprice;
        obj["totalPrice"] = pricecal;

        obj["totalUI"] = "$" + pricecal;

        obj["total"] = pricecal;
        //this.consoleMessage(obj)
        return obj;
      }
    }
  }
  public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let coverage = product.planCoverage;

    //   coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,
    //     planProductId: product.planProductId,
    //     price: this._decimalPipe
    //       .transform(product.price1 || product.price, '1.2-2')
    //       ?.replace(/,/g, ''),
    //     tax: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.tax : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     total: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.total : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel ? product.planlevel.id : '',
    //     planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    //     description: product.description,
    //     coverage: coverage,
    //   };

    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //   };
    //   obj1.products.push(this.productobj);
    //   this.planobjdata = obj1;

    //   this.openplanoptions(elementcv, options, plan, product);
    // }

    // else {
    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(
          this.userForm.value.planEnrollmentDate
        )
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    //this.consoleMessage(obj1)

    this.addtoplansummary(obj, obj1);
    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)

 this.openplanoptions(elementcv)
    }, 1000);
    // }
  }
  public unselectplan(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      enrollmentDate: moment(
        this.userForm.get('planEnrollmentDate')?.value,
        'DD-MMM-YYYY'
      ).format('YYYY-MM-DD'),
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummary(obj);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }

  public addtoplansummary(obj: any, obj1: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    this.logger.log(obj1);
    this.logger.log(planSummary)
    //this.logger.log("addroplansummaryplans")
    //this.logger.log(planSummary.length)
    //this.logger.log(obj.id)
    this.logger.log('obj', obj);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = parseFloat(
        this._decimalPipe.transform(gstprice, '1.2-2')
      );
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = parseFloat(
        this._decimalPipe.transform(hstprice, '1.2-2')
      );
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = parseFloat(
        this._decimalPipe.transform(pstprice, '1.2-2')
      );
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;
      obj['qstPrice'] = parseFloat(
        this._decimalPipe.transform(qstprice, '1.2-2')
      );
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // //this.logger.log(object["taxUI"])

    obj['tax'] = parseFloat(
      this._decimalPipe.transform(
        obj1.products.reduce((acc, calculatedTax) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
    );

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;
    obj['version'] = obj1.version;

    this.logger.log(obj.planPrice);
    this.logger.log(gstprice);
    this.logger.log(hstprice);
    this.logger.log(pstprice);

    this.logger.log(qstprice);
    let pricecal = obj1.products.reduce((acc, calculatedTax) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = pricecal;

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    this.logger.log(obj1);

    obj['skuTotalPrice'] = obj1.products.reduce((acc, calculatedTax) => {
      return acc + calculatedTax.total;
    }, 0);

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];
    console.log({ planSummary })

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.logger.log(obj1);

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    console.log(JSON.parse(sessionStorage.getItem('plansummarymain')));
    if (planSummary.length > 0) {
    } else {
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymain =
        JSON.parse(sessionStorage.getItem('plansummarymain')) || '';

      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {

          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
              }, 1000);
            }
            break;
          }
          else {

            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector(`#plancheck792`)
            const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

            console.log(plan)
            setTimeout(() => {
              plan.click()
              this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.logger.log(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        .replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }

  public removeplansummary(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary'));

    //  //this.logger.log("Beforeremoving")
    //this.logger.log(planSummary)
    //this.logger.log("removeingobject")
    //this.logger.log(obj)

    // //this.logger.log(obj.name)
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {
      //this.logger.log("removeinplanid"+obj.id)
      let index = this.getslectedplans(obj.id);
      //this.logger.log(index)

      if (index > -1) {
        planSummary.splice(index, 1);
        //this.logger.log("afterremove")
        //this.logger.log(planSummary)
      } else {
        return;
      }

      // //this.logger.log(planSummary)
      // //this.logger.log(planSummary.length)
      //this.logger.log("beforeremoveplans")
      let selectedPlans = JSON.parse(sessionStorage.getItem('selectedPlans'));
      var newselectedplans = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      //this.logger.log("newselectedPlans")
      //this.logger.log(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = parseFloat(
          this._decimalPipe.transform(gstprice, '1.2-2')
        );
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = parseFloat(
          this._decimalPipe.transform(hstprice, '1.2-2')
        );
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = parseFloat(
          this._decimalPipe.transform(pstprice, '1.2-2')
        );
      } else {
        obj['pstPrice'] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;
        obj['qstPrice'] = parseFloat(
          this._decimalPipe.transform(qstprice, '1.2-2')
        );
      } else {
        obj['qstPrice'] = 0;
      }

      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // //this.logger.log(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        )
      );
      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        )
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));

      if (planSummary.length > 0) {
        // this.plansnexttab = false;
      } else {
        // this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      this.planssummarymain =
        JSON.parse(sessionStorage.getItem('plansummarymain')) || '';

      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.logger.log(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        .replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    //this.logger.log("beforeaddtoplans")
    //this.logger.log(planid)
    //this.logger.log(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //this.logger.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    //this.logger.log("afteraddtoplans")
    //this.logger.log(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }
  public removeslectplans(planid: number, plansumamryindex: number) {
    //this.logger.log("beforeremoveplans")
    let selectedPlans = JSON.parse(sessionStorage.getItem('selectedPlans'));

    //this.logger.log(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      //this.logger.log(planid)
      //this.logger.log(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    //this.logger.log("adjustedselectedPlans")
    //this.logger.log(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public getslectedplans(planid: number) {
    //this.logger.log(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //this.logger.log(selectedPlans)
    return selectedPlans[planid];
  }
  public addtosum(amount: any) {
    this.logger.log('addtosum' + amount);

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    this.logger.log('selectedPlansAmount' + selectedPlansAmount);
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      .replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount').replace(/,/g, '')
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        .replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      .replace(/,/g, '');
    return selectedPlansAmount;
  }

  public openplanoptions(elementcv) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let modifiedOptions = [];

    // this.plandetailsobjvalue = plandetailsobj;
    // this.logger.log(plandetails);
    // this.logger.log(product.id);

    this.plandetailsobjvalue = plandetails;
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData

      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
    }

    optionsValue.forEach((element) => {
      element.planOptionsValues.forEach((options) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    // this.showoptions = true;
    // alert("startrhetre")
    // setTimeout(() => {
    //   $('#showplanoptions-modal').modal('show');
    // }, 1000);
  }
  public planoptionselection(event, optionvalue, optionid, optionvalueid) {
    // $(".optionselectionmethod-" + optionid)
    //   .not(this)
    //   .prop("checked", false);

    // $("#planselectionvalue-" + optionvalueid + "-" + optionid).prop(
    //   "checked",
    //   true
    // );

    this.optionmessage = '';
  }

  public confirmoptionsselection() {
    let optionumber = $('#optionumber').val();
    this.logger.log('plandetailsobj', $('#plandetailsobj').val());

    let plandetailsobj = $('#plandetailsobj').val().split('##');

    let array = [];

    let optionarray = [];

    let checkvalue = true;

    for (let i = 1; i <= optionumber; i++) {
      checkvalue =
        checkvalue && $('.optionselectionmethod-' + i + ':checked').val();
    }

    if (!checkvalue) {
      this.optionmessage = this.lang.Please_select_all_plan_options;
      return;
    } else {
      this.optionmessage = '';
    }

    $('#showplanoptions-modal').modal('hide');

    if (sessionStorage.getItem('maritalStatus') == plandetailsobj[2]) {
    } else {
      if (sessionStorage.getItem('brokerType') == 'EXECUTIVE') {
        $('#insuranceconfirmation-modal').modal('show');
      }
    }

    for (let i = 1; i <= optionumber; i++) {
      let optionobj: any = {};

      let selectedOptionValues = JSON.parse(
        $('.optionselectionmethod-' + i + ':checked').val()
      );
      // //this.logger.log(selectedOptionValues)
      optionobj = selectedOptionValues;

      optionobj.name = selectedOptionValues.planOptionName;
      optionobj.value = selectedOptionValues.value;
      optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

      optionarray.push(optionobj);
    }

    // let plandetailsobj = $("#plandetailsobj").val().split(",");

    let obj = {
      enrollmentDate: moment(
        this.userForm.get('planEnrollmentDate')?.value,
        'DD-MMM-YYYY'
      ).format('YYYY-MM-DD'),
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: optionarray || [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
        // elementcv.checked =false
      }
    }

    let obj1 = {};
    this.logger.log(obj);
    // this.addtoplansummary(obj, this.planobjdata);
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    for (let i = 0; i < planSummary.length; i++) {
      if (planSummary[i].planLevel == 18) {
        planSummary[i].options = obj.options
      }
    }

    console.log(planSummary)
    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    sessionStorage.setItem('plansummarymain', JSON.stringify(planSummary));
  }

  public closeoptionsselection() {
    $('#showplanoptions-modal').modal('hide');
    let plandetailsobj = $('#plandetailsobj').val().split('##');

    this.logger.log(plandetailsobj[19]);
    // this.logger.log(plandetailsobj[20])

    $('#plancheck' + plandetailsobj[19]).prop('checked', false);

    let optionumber = $('#optionumber').val();

    $('#showplanoptions-modal').modal('hide');

    for (let i = 1; i <= optionumber; i++) {
      $('.optionselectionmethod-' + i + ':checked').prop('checked', false);
    }
  }
  TextToLowerCase(form: FormGroup, id: any) {
    let value = form.get(id).value.toLowerCase();
    form.get(id).setValue(value);
    form.get(id).updateValueAndValidity();
  }
}

export function apt_suitecheck(
  control: AbstractControl
): { [key: string]: any } | null {
  var Regexp = /^[a-zA-Z0-9]{1,50}$/;
  if (control.value && !Regexp.test(control.value)) {
    return { aptexpression: true };
  }
  return null;
}

export function postalcodeValidator(control: FormControl): {
  [key: string]: any;
} {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return String;
}
export function diff_years(dt2: any) {
  let dt1 = new Date();
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60 * 24;
  return Math.abs(Math.round(diff / 365.25));
}

export function dateofbirthvalidation(
  control: AbstractControl
): { [key: string]: any } | null {
  let minDate = moment().subtract(74, 'years').calendar();
  let maxDate = moment().subtract(16, 'years').calendar();

  let minDatevalue = new Date(minDate);

  let maxDatevalue = new Date(maxDate);

  console.log(new Date(control.value) > maxDatevalue, new Date(control.value) < minDatevalue)
  if (new Date(control.value) > maxDatevalue) {
    return { mindateofbirth: true };
  } else if (new Date(control.value) < minDatevalue) {
    return { maxdateofbirth: true };
  }

  return null;
}


export function creditcardvalidation(
  control: AbstractControl
): { [key: string]: any } | null {
  this.logger.log('creditcardvalidation: ' + control.value);
  var creditcardRegexp = /^[0-9]{13,19}$/;
  if (control.value && !creditcardRegexp.test(control.value)) {
    return { invalidcreditcarddetails: true };
  }
  return null;
}

export function validatehoursperweek(
  control: AbstractControl
): { [key: string]: any } | null {
  if (control.value && control.value < 20) {
    return { mininvalidhours: true };
  } else if (control.value && control.value >= 81) {
    return { maxinvalidhours: true };
  }
}
